
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jlRK6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eJlpI = parcelRequire("eJlpI");


var $bGjLa = parcelRequire("bGjLa");


var $98tu2 = parcelRequire("98tu2");

function $7a06b5f81a7d81a9$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
        case 'max':
            return 0, $98tu2.FullPageEditor;
        case 'chromeless':
            return 0, $eJlpI.default;
        case 'comment':
            return 0, $bGjLa.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}



var $6ohxN = parcelRequire("6ohxN");

const $7d1a2ecb96f2a021$export$36a7c46ebbddbc5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ComposableEditor(props) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props.appearance) {
        t0 = (0, $7a06b5f81a7d81a9$export$2e2bcd8739ae039)(props.appearance);
        $[0] = props.appearance;
        $[1] = t0;
    } else t0 = $[1];
    const AppearanceComponent = t0;
    let t1;
    if ($[2] !== AppearanceComponent || $[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            AppearanceComponent: AppearanceComponent
        });
        $[2] = AppearanceComponent;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function ComposableEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $cozmU.useMemo)(()=>(0, $7a06b5f81a7d81a9$export$2e2bcd8739ae039)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
};
module.exports["ComposableEditor"] = $7d1a2ecb96f2a021$export$36a7c46ebbddbc5d;

});

parcelRegister("98tu2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8dxef = parcelRequire("8dxef");


var $3k5Tv = parcelRequire("3k5Tv");


var $jZ0wT = parcelRequire("jZ0wT");


var $bdURs = parcelRequire("bdURs");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");


var $jkcNT = parcelRequire("jkcNT");


var $5JOGK = parcelRequire("5JOGK");











var $hekY6 = parcelRequire("hekY6");

const $216648e7afc3dd30$var$styles = {
    root: "_4ouGXIe9dk _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc"
};
const $216648e7afc3dd30$export$2e95191265575e53 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, className: className, style: style } = t0;
    let t1;
    if ($[0] !== className) {
        t1 = (0, $hekY6.default)([
            $216648e7afc3dd30$var$styles.root,
            className
        ]);
        $[0] = className;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== ref || $[4] !== style || $[5] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            className: t1,
            style: style
        }, children);
        $[2] = children;
        $[3] = ref;
        $[4] = style;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, className: className, style: style }, ref)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            $216648e7afc3dd30$var$styles.root,
            className
        ]),
        style: style
    }, children));


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `FullPage.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 



var $lOiVq = parcelRequire("lOiVq");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $2d5048e016452847$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2d5048e016452847$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $2d5048e016452847$export$484266f72d7ebbab = {
    name: "znpqtq",
    styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
};
const $2d5048e016452847$export$a838a71bfc839c1d = {
    name: "18di8tn",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end;.extension-editable-area &{height:auto;position:sticky;top:0;align-self:flex-start;}"
};


const $f60fa7b48fca8ab6$export$41c7ea372447284a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, className: className, style: style }, ref)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-classname-prop -- intentional: emotion fallback branch reuses StyledComponents style
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2d5048e016452847$export$ffbc962f588258d5),
        ref: ref,
        className: className,
        style: style
    }, children));








/* FullPageContentArea-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $5X6fy = parcelRequire("5X6fy");


var $kSwu1 = parcelRequire("kSwu1");





var $l1ngX = parcelRequire("l1ngX");








var $anBbz = parcelRequire("anBbz");





var $8eIAK = parcelRequire("8eIAK");


var $iy9Au = parcelRequire("iy9Au");


var $c1cJ9 = parcelRequire("c1cJ9");


var $58PSv = parcelRequire("58PSv");


var $01rUB = parcelRequire("01rUB");

const $b81011fd32db5405$var$akEditorFullWidthLayoutWidth = 1800;
const $b81011fd32db5405$var$akEditorUltraWideLayoutWidth = 4000;
const $b81011fd32db5405$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $b81011fd32db5405$var$tableMarginFullWidthMode = 2;
const $b81011fd32db5405$var$akLayoutGutterOffset = 12;
const $b81011fd32db5405$var$SWOOP_ANIMATION = `0.5s ${$b81011fd32db5405$var$akEditorSwoopCubicBezier}`;
const $b81011fd32db5405$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $b81011fd32db5405$var$getTotalPadding = ()=>(0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2; // Isolates the scroll container's layout and size from the rest of the page under
// platform_editor_contain_layout. Because of contain: size wrapper
// must take its height from the parent rather than from the contained content.
const $b81011fd32db5405$var$containLayoutStyles = {
    wrapper: "_1yltTq6iPg _0jFU0VN91d"
};
const $b81011fd32db5405$var$compiledStyles = {
    contentAreaWrapper: "_39xV02N91d _0u2WMmrU95 _3n40gWTKRA _1yltTqrdn2",
    sidebarArea: "_0jFU0VN91d _24h04i2Njc _4xdlr0z9WS _3wNLtgIZbP _4ibiQNHE3j _20X8EYdnbC _2BzSyuchRC",
    editorContentAreaProsemirrorStyle: "_1gPRV27dHp _2X1Eii2Njc _1oq46kZSoF _3X5i6JYbGa _2i5IdgYbGa _49NqcmYbGa _1CSjSDYbGa _4cwzmvYbGa _26fnghYbGa _2CSfq1YbGa _1UWOuQYbGa _0w5K66YbGa _3taUQyNHnM",
    hideEditorContentAreaProsemirrorWithAttributeStyle: "_2xnZxcYbGa",
    hideEditorContentAreaScrollGutterWithAttributeStyle: "_0HwuViYbGa",
    hideEditorScrollGutterStyle: "_3iDTPbYbGa",
    fullWidthNonChromelessBreakoutBlockTableStyle: "_2dVtt3TTQh _1GXRiKTTQh _2mjA9nTTQh _1KIxemS2te _1cGLdGOiJt",
    editorContentAreaNew: "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _23rrnHxW2a _26BoRwoWWg _0Of8r2p0Oa _1wydGWp0Oa _0jFU0V5UbO _39xV02N91d _0aFT5vbt8w _2O5Vij7dHp _1EqgXlN9qa _4oeACXRNCI",
    tableFullPageEditorStylesNew: "_4jf8G9dnbC _0AmSRYA17z _3I7FkhN91d",
    editorContentAreaContainerNestedDndStyle: "_1YBOQqU7F1",
    editorContentAreaContainerStyleExcludeCodeBlockNew: "_4y7G8nha8K _0CoKaaha8K _2SWjyvN91d _37a9tMOLYo _1YBOQqJhBE",
    editorContentAreaContainerStyleNew: "_2DXnNBha8K _4y7G8nha8K _0CoKaaha8K _2SWjyvN91d _37a9tMOLYo _1YBOQqJhBE",
    editorContentGutterStyleFG: "_0Of8r2dnbC _1ZnuxbL04q _1wydGWdnbC _2Zuz6QL04q",
    editorContentGutterStyles: "_0Of8r2dnbC _1ZnuxbmpvA _1wydGWdnbC _2Zuz6QmpvA _24h04i2Njc",
    editorContentReducedGutterStyles: "_3fmpEZdnbC _1wq6pioWWg _0RxOB8dnbC _2nXIBWoWWg",
    contentAreaNew: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _23rrnHyiWy _3iDTPbQ4SZ _0aFT5v1qpb _0jFU0V2uDb _24h04i2Njc _0yUVLO43fD",
    contentAreaHeightNoToolbar: "_0jFU0VN91d",
    markdownModeContainerBackgroundStyle: "_0KLXrunmFW _2nupUenQyn",
    markdownModeContentAreaStyle: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _24h04i2Njc _0jFU0VN91d _1EqgXlYbGa _4ouGXIdnbC _1wydGWdnbC _0Of8r2dnbC _39xV02N91d _11kFsYdnbC _0sRJyJdnbC _0YVgiZdnbC _3U5kzndnbC _4xpWKM2Njc _2BOyauQ4SZ _1Iszs2bt8w _32orp8N91d _4rwDE6dnbC _4Bb8y4dnbC _0jHvJyN91d _3jzSi17dHp _0LNDQN7dHp _2CUhh0IZbP _2sJ0n8Q4SZ _2IOeePdnbC _1KkfX9dnbC _1q0xJ9N91d"
};
const $b81011fd32db5405$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area'; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $b81011fd32db5405$export$5c151fe82051a1a7 = 'ak-editor-container';
const $b81011fd32db5405$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const fullWidthMode = props.appearance === 'full-width';
    const maxWidthMode = props.appearance === 'max';
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const contentAreaRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    const allowScrollGutter = props.editorAPI?.base?.sharedState.currentState()?.allowScrollGutter;
    const contentAreaMaxWidth = $b81011fd32db5405$var$getTotalPadding() + (!fullWidthMode ? maxWidthMode ? $b81011fd32db5405$var$akEditorUltraWideLayoutWidth : (0, $7Y8M5.akEditorDefaultLayoutWidth) : $b81011fd32db5405$var$akEditorFullWidthLayoutWidth); // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && (props.editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const markdownPluginCurrentView = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view);
    const markdownPluginCurrentIsMarkdownMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states_0)=>states_0.markdownModeState?.isMarkdownMode);
    const isMarkdownModeExperimentEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
    const shouldHideProseMirrorForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentView !== 'preview' && markdownPluginCurrentIsMarkdownMode;
    const shouldHideScrollGutterForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentIsMarkdownMode;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58PSv.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance,
        contentMode: props.contentMode,
        useStandardNodeWidth: useStandardNodeWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8eIAK.ClickAreaBlock), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-markdown-mode-hide-prosemirror": shouldHideProseMirrorForMarkdownMode ? 'true' : undefined,
        "data-markdown-mode-hide-scroll-gutter": shouldHideScrollGutterForMarkdownMode ? 'true' : undefined,
        style: {
            '--ak-editor-content-area-max-width': `${contentAreaMaxWidth}px`
        },
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$compiledStyles.editorContentAreaNew,
            $b81011fd32db5405$var$compiledStyles.editorContentAreaProsemirrorStyle,
            shouldHideProseMirrorForMarkdownMode && $b81011fd32db5405$var$compiledStyles.hideEditorContentAreaProsemirrorWithAttributeStyle,
            shouldHideScrollGutterForMarkdownMode && $b81011fd32db5405$var$compiledStyles.hideEditorContentAreaScrollGutterWithAttributeStyle,
            shouldHideProseMirrorForMarkdownMode && $b81011fd32db5405$var$compiledStyles.markdownModeContentAreaStyle,
            $b81011fd32db5405$var$compiledStyles.tableFullPageEditorStylesNew,
            $b81011fd32db5405$var$compiledStyles.fullWidthNonChromelessBreakoutBlockTableStyle,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? $b81011fd32db5405$var$compiledStyles.editorContentAreaContainerStyleExcludeCodeBlockNew : $b81011fd32db5405$var$compiledStyles.editorContentAreaContainerStyleNew,
            $b81011fd32db5405$var$compiledStyles.editorContentAreaContainerNestedDndStyle,
            "ak-editor-content-area-region"
        ]),
        "data-editor-editable-content": true,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $l1ngX.messages).editableContentLabel),
        ref: contentAreaRef,
        "data-vc": "editor-content-area-region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$compiledStyles.editorContentGutterStyles,
            (0, $iDrrr.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && $b81011fd32db5405$var$compiledStyles.editorContentGutterStyleFG,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            }) && $b81011fd32db5405$var$compiledStyles.editorContentReducedGutterStyles,
            (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('ak-editor-content-area', 'appearance-full-page', {
                'fabric-editor--full-width-mode': fullWidthMode,
                'fabric-editor--max-width-mode': Boolean(maxWidthMode)
            })
        ]),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01rUB.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents.after) : null, allowScrollGutter && ((0, $jkcNT.editorExperiment)('platform_editor_blocks', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "editor-scroll-gutter",
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        "data-editor-scroll-gutter": "true",
        className: (0, $hekY6.default)([
            shouldHideScrollGutterForMarkdownMode && $b81011fd32db5405$var$compiledStyles.hideEditorScrollGutterStyle
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "editor-scroll-gutter",
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        className: (0, $hekY6.default)([
            shouldHideScrollGutterForMarkdownMode && $b81011fd32db5405$var$compiledStyles.hideEditorScrollGutterStyle
        ])
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $b81011fd32db5405$export$81adcdb8b9fca1f7,
        ref: containerRef,
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$compiledStyles.contentAreaNew,
            props.isEditorToolbarHidden && $b81011fd32db5405$var$compiledStyles.contentAreaHeightNoToolbar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $b81011fd32db5405$export$5c151fe82051a1a7,
        "data-editor-container": 'true',
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$compiledStyles.contentAreaWrapper,
            shouldHideProseMirrorForMarkdownMode && $b81011fd32db5405$var$compiledStyles.markdownModeContainerBackgroundStyle
        ])
    }, props.UNSAFE_containLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "editor-contain-size-and-layout-wrapper",
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$containLayoutStyles.wrapper
        ])
    }, content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $b81011fd32db5405$var$compiledStyles.sidebarArea
        ])
    }, props.contextPanel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1cJ9.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $b81011fd32db5405$export$776d816c3b1a9691 = (0, $kSwu1.injectIntl)($b81011fd32db5405$var$Content, {
    forwardRef: true
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





var $60EJg = parcelRequire("60EJg");








var $kAzEy = parcelRequire("kAzEy");


var $7eTEw = parcelRequire("7eTEw");






































function $c01f95e0698f4819$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c01f95e0698f4819$var$akEditorFullWidthLayoutWidth = 1800;
const $c01f95e0698f4819$var$akEditorUltraWideLayoutWidth = 4000;
const $c01f95e0698f4819$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $c01f95e0698f4819$var$tableMarginFullWidthMode = 2;
const $c01f95e0698f4819$var$akLayoutGutterOffset = 12;
const $c01f95e0698f4819$var$SWOOP_ANIMATION = `0.5s ${$c01f95e0698f4819$var$akEditorSwoopCubicBezier}`;
const $c01f95e0698f4819$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $c01f95e0698f4819$var$getTotalPadding = ()=>(0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2;
// Isolates the scroll container's layout and size from the rest of the page under
// platform_editor_contain_layout. Because of contain: size wrapper
// must take its height from the parent rather than from the contained content.
const $c01f95e0698f4819$var$containStrictWrapperStyles = {
    name: "g1hz97",
    styles: "contain:layout size;height:100%"
};
const $c01f95e0698f4819$var$editorContentAreaProsemirrorStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $7eTEw.taskListSelector}):not(${0, $kAzEy.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
});
/*
 EDITOR-7249: Scope to the main editor's ProseMirror (direct child) so nested
 editors like the footer page-comment composer aren't hidden in Syntax view.
*/ const $c01f95e0698f4819$var$hideEditorContentAreaProsemirrorWithAttributeStyle = {
    name: "1q5kzop",
    styles: "&[data-markdown-mode-hide-prosemirror=\"true\"] > .ak-editor-content-area > .ProseMirror{display:none;}"
};
const $c01f95e0698f4819$var$hideEditorContentAreaScrollGutterWithAttributeStyle = {
    name: "1aax7yz",
    styles: "&[data-markdown-mode-hide-scroll-gutter=\"true\"] > .ak-editor-content-area > [data-vc=\"scroll-gutter\"]{display:none;}"
};
const $c01f95e0698f4819$var$hideEditorScrollGutterStyle = {
    name: "eivff4",
    styles: "display:none"
};
const $c01f95e0698f4819$var$fullWidthNonChromelessBreakoutBlockTableStyle = {
    name: "bywn89",
    styles: ".fabric-editor--full-width-mode:not(:has(#chromeless-editor)){.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}"
};
// new styles
const $c01f95e0698f4819$var$editorContentAreaNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + var(--ak-editor-fullpage-toolbar-height) + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    maxWidth: 'var(--ak-editor-content-area-max-width)',
    transition: `max-width ${$c01f95e0698f4819$var$SWOOP_ANIMATION}`
});
const $c01f95e0698f4819$var$tableFullPageEditorStylesNew = {
    name: "1h9cr7f",
    styles: ".ProseMirror .pm-table-wrapper > table{margin-left:0;margin-right:-1px;width:100%;}"
};
const $c01f95e0698f4819$var$editorContentAreaContainerNestedDndStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${($c01f95e0698f4819$var$akLayoutGutterOffset + $c01f95e0698f4819$var$AK_NESTED_DND_GUTTER_OFFSET) * 2}px)`
        }
    }
});
/* Prevent horizontal scroll on page in full width mode */ const $c01f95e0698f4819$var$editorContentAreaContainerStyleExcludeCodeBlockNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container, .multiBodiedExtension--container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% - ${$c01f95e0698f4819$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$c01f95e0698f4819$var$akLayoutGutterOffset * 2}px)`
        }
    }
});
/* Prevent horizontal scroll on page in full width mode */ const $c01f95e0698f4819$var$editorContentAreaContainerStyleNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code-block, .extension-container, .multiBodiedExtension--container': {
            maxWidth: `calc(100% - ${$c01f95e0698f4819$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$c01f95e0698f4819$var$akLayoutGutterOffset * 2}px)`
        }
    }
});
const $c01f95e0698f4819$var$editorContentGutterStyleFG = {
    name: "56lgh2",
    styles: "padding:0 72px"
};
const $c01f95e0698f4819$var$editorContentGutterStyles = {
    name: "1h0el6e",
    styles: "box-sizing:border-box;padding:0 52px"
};
const $c01f95e0698f4819$var$editorContentReducedGutterStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
    }
});
const $c01f95e0698f4819$var$contentAreaNew = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'row',
    height: `calc(100% - var(--ak-editor-fullpage-toolbar-height))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '&.ak-editor-content-area-no-toolbar': {
        // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
        // to match the toolbar height
        height: `calc(100% + 1px)`
    },
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    transition: `padding 0ms ${$c01f95e0698f4819$var$akEditorSwoopCubicBezier}`
});
const $c01f95e0698f4819$var$contentAreaHeightNoToolbar = {
    name: "13udsys",
    styles: "height:100%"
};
// When the markdown source view is shown (markdown mode toggled on and not in
// the WYSIWYG "preview" view) we tint the whole editor container with the
// sunken surface so the source editor reads as a distinct, inset surface.
const $c01f95e0698f4819$var$markdownModeContainerBackgroundStyle = {
    name: "1r5xjsv",
    styles: "background-color:var(--ds-surface-sunken, #F8F8F8);& [data-editor-scroll-container=\"true\"]{overflow-y:hidden;}"
};
const $c01f95e0698f4819$var$markdownModeContentAreaStyle = {
    name: "eecls",
    styles: "box-sizing:border-box;height:100%;margin:0;max-width:none;min-width:0;padding-bottom:0;padding-top:0;width:100%;> .ak-editor-content-area{box-sizing:border-box;display:flex;flex-direction:column;height:100%;min-height:0;min-width:0;padding:0;width:100%;}> .ak-editor-content-area > [data-testid=\"plugins-components-wrapper\"]{display:flex;flex:1 1 auto;min-height:0;min-width:0;width:100%;}"
};
const $c01f95e0698f4819$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $c01f95e0698f4819$export$5c151fe82051a1a7 = 'ak-editor-container';
const $c01f95e0698f4819$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const theme = (0, $60EJg.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const maxWidthMode = props.appearance === 'max';
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const contentAreaRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    const allowScrollGutter = props.editorAPI?.base?.sharedState.currentState()?.allowScrollGutter;
    const contentAreaMaxWidth = $c01f95e0698f4819$var$getTotalPadding() + (!fullWidthMode ? maxWidthMode ? $c01f95e0698f4819$var$akEditorUltraWideLayoutWidth : (0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_core_static_css', 'isEnabled', true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : theme.layoutMaxWidth : $c01f95e0698f4819$var$akEditorFullWidthLayoutWidth);
    // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && (props.editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const markdownPluginCurrentView = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view);
    const markdownPluginCurrentIsMarkdownMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.isMarkdownMode);
    const isMarkdownModeExperimentEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
    const shouldHideProseMirrorForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentView !== 'preview' && markdownPluginCurrentIsMarkdownMode;
    const shouldHideScrollGutterForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentIsMarkdownMode;
    const content = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $58PSv.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance,
        contentMode: props.contentMode,
        useStandardNodeWidth: useStandardNodeWidth
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8eIAK.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-markdown-mode-hide-prosemirror": shouldHideProseMirrorForMarkdownMode ? 'true' : undefined,
        "data-markdown-mode-hide-scroll-gutter": shouldHideScrollGutterForMarkdownMode ? 'true' : undefined,
        css: [
            $c01f95e0698f4819$var$editorContentAreaNew,
            $c01f95e0698f4819$var$editorContentAreaProsemirrorStyle,
            // EDITOR-6558: hide ProseMirror when the markdown-mode plugin
            // reports a non-WYSIWYG view.
            shouldHideProseMirrorForMarkdownMode && $c01f95e0698f4819$var$hideEditorContentAreaProsemirrorWithAttributeStyle,
            shouldHideScrollGutterForMarkdownMode && $c01f95e0698f4819$var$hideEditorContentAreaScrollGutterWithAttributeStyle,
            shouldHideProseMirrorForMarkdownMode && $c01f95e0698f4819$var$markdownModeContentAreaStyle,
            $c01f95e0698f4819$var$tableFullPageEditorStylesNew,
            $c01f95e0698f4819$var$fullWidthNonChromelessBreakoutBlockTableStyle,
            // for breakout resizing, there's no need to restrict the width of codeblocks as they're always wrapped in a breakout mark
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? $c01f95e0698f4819$var$editorContentAreaContainerStyleExcludeCodeBlockNew : $c01f95e0698f4819$var$editorContentAreaContainerStyleNew,
            $c01f95e0698f4819$var$editorContentAreaContainerNestedDndStyle
        ],
        style: {
            '--ak-editor-content-area-max-width': `${contentAreaMaxWidth}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "ak-editor-content-area-region",
        "data-editor-editable-content": true,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $l1ngX.messages).editableContentLabel),
        ref: contentAreaRef,
        "data-vc": "editor-content-area-region"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $c01f95e0698f4819$var$editorContentGutterStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $iDrrr.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && $c01f95e0698f4819$var$editorContentGutterStyleFG,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $c01f95e0698f4819$var$editorContentReducedGutterStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('ak-editor-content-area', 'appearance-full-page', {
            'fabric-editor--full-width-mode': fullWidthMode,
            'fabric-editor--max-width-mode': Boolean(maxWidthMode)
        }),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $01rUB.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(props.customContentComponents.after) : null, allowScrollGutter && ((0, $jkcNT.editorExperiment)('platform_editor_blocks', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        id: "editor-scroll-gutter",
        css: shouldHideScrollGutterForMarkdownMode && $c01f95e0698f4819$var$hideEditorScrollGutterStyle,
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        "data-editor-scroll-gutter": "true"
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        id: "editor-scroll-gutter",
        css: shouldHideScrollGutterForMarkdownMode && $c01f95e0698f4819$var$hideEditorScrollGutterStyle,
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter"
    }))))));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $c01f95e0698f4819$var$contentAreaNew,
            props.isEditorToolbarHidden && $c01f95e0698f4819$var$contentAreaHeightNoToolbar
        ],
        "data-testid": $c01f95e0698f4819$export$81adcdb8b9fca1f7,
        ref: containerRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2d5048e016452847$export$484266f72d7ebbab),
            shouldHideProseMirrorForMarkdownMode && $c01f95e0698f4819$var$markdownModeContainerBackgroundStyle
        ],
        "data-testid": $c01f95e0698f4819$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, props.UNSAFE_containLayout ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "editor-contain-size-and-layout-wrapper",
        css: $c01f95e0698f4819$var$containStrictWrapperStyles
    }, content) : content), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2d5048e016452847$export$a838a71bfc839c1d)
    }, props.contextPanel || /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c1cJ9.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $c01f95e0698f4819$export$272e13b0c66d0169 = (0, $kSwu1.injectIntl)($c01f95e0698f4819$var$Content, {
    forwardRef: true
});


const $7d1be946ccb7e8e1$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $7d1be946ccb7e8e1$export$5c151fe82051a1a7 = 'ak-editor-container';
const $7d1be946ccb7e8e1$export$7db1e8e055ebd208 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $b81011fd32db5405$export$776d816c3b1a9691), (0, $c01f95e0698f4819$export$272e13b0c66d0169));





















var $bZDJe = parcelRequire("bZDJe");





var $96wsv = parcelRequire("96wsv");


var $bVYsF = parcelRequire("bVYsF");



















const $2af895f971544fb4$var$styles = {
    beforePrimaryToolbarPluginWrapper: "_3iDTPbQ4SZ _2O5Vij7dHp _37wbyuz9WS _0hPCNLDIqT"
};
const $2af895f971544fb4$export$25fbb719f83ec07a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $2af895f971544fb4$var$styles.beforePrimaryToolbarPluginWrapper
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.beforePrimaryToolbarComponents) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "before-primary-toolbar-components-plugin",
            className: t0
        }, props.beforePrimaryToolbarComponents);
        $[1] = props.beforePrimaryToolbarComponents;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": 'before-primary-toolbar-components-plugin',
        className: (0, $hekY6.default)([
            $2af895f971544fb4$var$styles.beforePrimaryToolbarPluginWrapper
        ])
    }, props.beforePrimaryToolbarComponents);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `BeforeWrapper.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 


function $865ca942e7fd67b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $865ca942e7fd67b7$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $865ca942e7fd67b7$export$5b210105ec3161aa = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $865ca942e7fd67b7$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);


const $01a5fa2e0bf9040e$export$b41281e8d2acb8ab = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $2af895f971544fb4$export$25fbb719f83ec07a), (0, $865ca942e7fd67b7$export$5b210105ec3161aa));




















const $715a08d897e6e3a2$var$firstChildStyles = {
    base: "_3iDTPbQ4SZ _2O5Vij7dHp",
    twoLine: "_1ZHvVg7dHp _0CK5Oh7dHp _3xF9B6N91d _0zts8MZuyT _1pVQW8z9WS _4eczCgE6Kk"
};
const $715a08d897e6e3a2$var$secondChildStyles = {
    base: "_4ouGXIE6Kk",
    twoLine: "_1ZHvVg7dHp _0CK5Oh7dHp _3xF9B6N91d _4kbjZAIZbP _4bDbrhIZbP _3H7QO2IZbP _0PJLQEIZbP _0xCIbWQ4SZ _0zts8MZuyT _4eczCgdnbC"
}; // ---------------- First child wrapper ----------------
const $715a08d897e6e3a2$export$2c0ded503b620548 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, "aria-label": ariaLabel, "data-testid": testId } = t0;
    const t1 = twoLineEditorToolbar && $715a08d897e6e3a2$var$firstChildStyles.twoLine;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $715a08d897e6e3a2$var$firstChildStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaLabel || $[3] !== children || $[4] !== role || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: role,
            "aria-label": ariaLabel,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = ariaLabel;
        $[3] = children;
        $[4] = role;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ $cozmU.createElement("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $715a08d897e6e3a2$var$firstChildStyles.base,
            twoLineEditorToolbar && $715a08d897e6e3a2$var$firstChildStyles.twoLine
        ])
    }, children); // ---------------- Second child wrapper ----------------
const $715a08d897e6e3a2$export$e0d25e266e1f98e9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, "aria-label": ariaLabel, "data-testid": testId } = t0;
    const t1 = twoLineEditorToolbar && $715a08d897e6e3a2$var$secondChildStyles.twoLine;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $715a08d897e6e3a2$var$secondChildStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaLabel || $[3] !== children || $[4] !== role || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: role,
            "aria-label": ariaLabel,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = ariaLabel;
        $[3] = children;
        $[4] = role;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ $cozmU.createElement("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $715a08d897e6e3a2$var$secondChildStyles.base,
            twoLineEditorToolbar && $715a08d897e6e3a2$var$secondChildStyles.twoLine
        ])
    }, children);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `CustomToolbarWrapper.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("cozmU");




function $917102e879debdb5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Pre-computed static styles for first- and second-child wrappers.
// These contain no runtime logic and are safe for static-emotion mode.
const $917102e879debdb5$var$firstChildStaticBase = {
    name: "5thnkd",
    styles: "display:flex;flex-grow:1"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $917102e879debdb5$var$firstChildStaticTwoLine = {
    name: "125cgyn",
    styles: "@media (max-width: 868px){flex:1 1 100%;height:var(--ak-editor-fullpage-toolbar-height);justify-content:flex-end;min-width:fit-content;}"
};
const $917102e879debdb5$var$secondChildStaticBase = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $917102e879debdb5$var$secondChildStaticTwoLine = {
    name: "3psy",
    styles: "@media (max-width: 868px){display:flex;flex-grow:1;flex:1 1 100%;margin:auto;height:var(--ak-editor-fullpage-toolbar-height);min-width:0;}"
};
const $917102e879debdb5$export$d2325359d397e0b2 = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $917102e879debdb5$var$firstChildStaticBase,
            twoLineEditorToolbar && $917102e879debdb5$var$firstChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $917102e879debdb5$export$d02bc47084c37572 = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $917102e879debdb5$var$secondChildStaticBase,
            twoLineEditorToolbar && $917102e879debdb5$var$secondChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);


const $fbe8cfa9d91015c0$export$e9a48721664257fd = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $715a08d897e6e3a2$export$2c0ded503b620548), (0, $917102e879debdb5$export$d2325359d397e0b2));
const $fbe8cfa9d91015c0$export$c8150e2de9fece09 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $715a08d897e6e3a2$export$e0d25e266e1f98e9), (0, $917102e879debdb5$export$d02bc47084c37572));




















const $5b6f88f5a359c8c3$var$nonCustomToolbarWrapperCompiledStyles = {
    root: "_0hPCNLDIqT _3iDTPbQ4SZ _2O5Vij7dHp"
};
const $5b6f88f5a359c8c3$export$237e1ac09b615dbd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$nonCustomToolbarWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$nonCustomToolbarWrapperCompiledStyles.root
        ])
    }, children);
const $5b6f88f5a359c8c3$var$customToolbarWrapperCompiledStyles = {
    root: "_0hPCNLDIqT _3iDTPbQ4SZ"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $5b6f88f5a359c8c3$export$cbddf074130aa75 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$customToolbarWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$customToolbarWrapperCompiledStyles.root
        ])
    }, children);
const $5b6f88f5a359c8c3$var$mainToolbarIconBeforeCompiledStyles = {
    root: "_3138425zaO _0adFHs5zaO _1DCdHi5zaO _2XsHFM5zaO _0jFU0VVa5s _39xV02Va5s _1usWhA7dHp _1YaYFq7dHp"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $5b6f88f5a359c8c3$export$fb3cf9f8d75e0584 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$mainToolbarIconBeforeCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5b6f88f5a359c8c3$var$mainToolbarIconBeforeCompiledStyles.root
        ])
    }, children);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `MainToolbar.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("cozmU");







function $9fd9b31fadf607e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9fd9b31fadf607e8$var$nonCustomToolbarWrapperEmotionStyles = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $9fd9b31fadf607e8$export$b15d6273b403900f = ({ children: children })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9fd9b31fadf607e8$var$nonCustomToolbarWrapperEmotionStyles
    }, children);
const $9fd9b31fadf607e8$var$customToolbarWrapperEmotionStyles = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};
const $9fd9b31fadf607e8$export$cae7d61e24bc118f = ({ children: children })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9fd9b31fadf607e8$var$customToolbarWrapperEmotionStyles
    }, children);
const $9fd9b31fadf607e8$var$mainToolbarIconBeforeEmotionStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7Y8M5.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $9fd9b31fadf607e8$export$c648b69d467ee76 = ({ children: children })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9fd9b31fadf607e8$var$mainToolbarIconBeforeEmotionStyles
    }, children);


const $4a1504e889890b6d$export$d44d6319207b3004 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $5b6f88f5a359c8c3$export$cbddf074130aa75), (0, $9fd9b31fadf607e8$export$cae7d61e24bc118f));


const $4aa536a4f2b2b9c7$export$f71dca5c73c8a7 = 868;










const $dba51f42e486181c$export$8889272e3d68acbb = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $5b6f88f5a359c8c3$export$fb3cf9f8d75e0584), (0, $9fd9b31fadf607e8$export$c648b69d467ee76));




















const $26fd3e88ed6cd51d$var$styles = {
    base: "_23rrnHjHti _1x1D3gOeNX _1mT5xdRAKS _0hPCNLDIqT _2OUyjtYbGa _42Yu6BFIQA _3iDTPbQ4SZ _0jFU0VZuyT _3YEZNOdnbC _0KLXrulfZc _3KgJoSAASz",
    flexibleIconSize: "_0fdGNFN91d",
    keyline: "_2OUyjtFYNq",
    twoLine: "_4eyQS8HnLE _0zts8M9oRZ"
};
const $26fd3e88ed6cd51d$export$112f93be337305c1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, "data-testid": testId } = t0;
    const t1 = showKeyline && $26fd3e88ed6cd51d$var$styles.keyline;
    const t2 = twoLineEditorToolbar && $26fd3e88ed6cd51d$var$styles.twoLine;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $hekY6.default)([
            $26fd3e88ed6cd51d$var$styles.base,
            $26fd3e88ed6cd51d$var$styles.flexibleIconSize,
            t1,
            t2
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            className: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $26fd3e88ed6cd51d$var$styles.base,
            $26fd3e88ed6cd51d$var$styles.flexibleIconSize,
            showKeyline && $26fd3e88ed6cd51d$var$styles.keyline,
            twoLineEditorToolbar && $26fd3e88ed6cd51d$var$styles.twoLine
        ])
    }, children);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `MainToolbarWrapper.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("cozmU");








function $92ac1a7764f5292a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92ac1a7764f5292a$var$baseToolbarStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'relative',
    alignItems: 'center',
    boxShadow: 'none',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `box-shadow 200ms ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
    display: 'flex',
    height: 'var(--ak-editor-fullpage-toolbar-height)',
    flexShrink: 0,
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& object': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        height: '0 !important'
    }
});
const $92ac1a7764f5292a$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $92ac1a7764f5292a$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)"}`
});
const $92ac1a7764f5292a$var$mainToolbarTwoLineStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $4aa536a4f2b2b9c7$export$f71dca5c73c8a7}px)`]: {
        flexWrap: 'wrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(var(--ak-editor-fullpage-toolbar-height) * 2)`
    }
});
const $92ac1a7764f5292a$export$2a90a9bbb1b4d6a3 = ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $92ac1a7764f5292a$var$baseToolbarStyles,
            $92ac1a7764f5292a$var$flexibleIconSize,
            showKeyline && $92ac1a7764f5292a$var$mainToolbarWithKeyline,
            twoLineEditorToolbar && $92ac1a7764f5292a$var$mainToolbarTwoLineStyle
        ],
        "data-testid": testId
    }, children);
};


const $5a568e1bbe998ad4$export$9e3c8dcb351b94fd = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $26fd3e88ed6cd51d$export$112f93be337305c1), (0, $92ac1a7764f5292a$export$2a90a9bbb1b4d6a3));










const $496f5200399ac3c7$export$c576cd6cf1d399bf = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $5b6f88f5a359c8c3$export$237e1ac09b615dbd), (0, $9fd9b31fadf607e8$export$b15d6273b403900f));


const $a28bca03d52754ef$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(49);
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $cozmU.useState)(false);
    const { editorAPI: editorAPI } = props;
    const twoLineEditorToolbar = (0, $jkcNT.editorExperiment)("platform_editor_controls", "variant1") ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    const { Portal: ToolbarPortal } = (0, $96wsv.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    let t0;
    if ($[0] !== props.beforeIcon) {
        t0 = props.beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dba51f42e486181c$export$8889272e3d68acbb), null, props.beforeIcon);
        $[0] = props.beforeIcon;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== popupsMountPoint || $[3] !== props.appearance || $[4] !== props.containerElement || $[5] !== props.disabled || $[6] !== props.dispatchAnalyticsEvent || $[7] !== props.editorActions || $[8] !== props.editorView || $[9] !== props.eventDispatcher || $[10] !== props.hasMinWidth || $[11] !== props.popupsBoundariesElement || $[12] !== props.popupsScrollableElement || $[13] !== props.primaryToolbarComponents || $[14] !== props.providerFactory || $[15] !== twoLineEditorToolbar) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVYsF.ToolbarWithSizeDetector), {
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            items: props.primaryToolbarComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            containerElement: props.containerElement,
            hasMinWidth: props.hasMinWidth,
            twoLineEditorToolbar: twoLineEditorToolbar
        });
        $[2] = popupsMountPoint;
        $[3] = props.appearance;
        $[4] = props.containerElement;
        $[5] = props.disabled;
        $[6] = props.dispatchAnalyticsEvent;
        $[7] = props.editorActions;
        $[8] = props.editorView;
        $[9] = props.eventDispatcher;
        $[10] = props.hasMinWidth;
        $[11] = props.popupsBoundariesElement;
        $[12] = props.popupsScrollableElement;
        $[13] = props.primaryToolbarComponents;
        $[14] = props.providerFactory;
        $[15] = twoLineEditorToolbar;
        $[16] = t1;
    } else t1 = $[16];
    let t2;
    if ($[17] !== t0 || $[18] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $496f5200399ac3c7$export$c576cd6cf1d399bf), null, t0, t1);
        $[17] = t0;
        $[18] = t1;
        $[19] = t2;
    } else t2 = $[19];
    const nonCustomToolbar = t2;
    let t3;
    if ($[20] !== props.customPrimaryToolbarComponents) {
        t3 = !!props.customPrimaryToolbarComponents && "before" in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01a5fa2e0bf9040e$export$b41281e8d2acb8ab), {
            beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
        }) : null;
        $[20] = props.customPrimaryToolbarComponents;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== editorAPI?.findReplace || $[23] !== popupsMountPoint || $[24] !== props.containerElement || $[25] !== props.dispatchAnalyticsEvent || $[26] !== props.editorView || $[27] !== props.popupsBoundariesElement || $[28] !== props.popupsScrollableElement || $[29] !== twoLineEditorToolbar) {
        t4 = !(0, $jkcNT.editorExperiment)("platform_editor_controls", "variant1") && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: props.popupsScrollableElement,
            editorView: props.editorView,
            containerElement: props.containerElement,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
        }) : null;
        $[22] = editorAPI?.findReplace;
        $[23] = popupsMountPoint;
        $[24] = props.containerElement;
        $[25] = props.dispatchAnalyticsEvent;
        $[26] = props.editorView;
        $[27] = props.popupsBoundariesElement;
        $[28] = props.popupsScrollableElement;
        $[29] = twoLineEditorToolbar;
        $[30] = t4;
    } else t4 = $[30];
    const t5 = !!props.customPrimaryToolbarComponents && "after" in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents;
    let t6;
    if ($[31] !== t3 || $[32] !== t4 || $[33] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a1504e889890b6d$export$d44d6319207b3004), null, t3, t4, t5);
        $[31] = t3;
        $[32] = t4;
        $[33] = t5;
        $[34] = t6;
    } else t6 = $[34];
    const customToolbar = t6;
    let t7;
    if ($[35] !== twoLineEditorToolbar) {
        t7 = ()=>{
            if (twoLineEditorToolbar) {
                const updateOnResize = ()=>{
                    setShouldSplitToolbar(window.innerWidth <= (0, $4aa536a4f2b2b9c7$export$f71dca5c73c8a7));
                };
                window.addEventListener("resize", updateOnResize);
                updateOnResize();
                return ()=>window.removeEventListener("resize", updateOnResize);
            }
        };
        $[35] = twoLineEditorToolbar;
        $[36] = t7;
    } else t7 = $[36];
    (0, $cozmU.useEffect)(t7);
    const isShortcutToFocusToolbar = $a28bca03d52754ef$var$_temp;
    let t8;
    if ($[37] !== props.editorView) {
        t8 = (event_0)=>{
            if (!props.editorView?.hasFocus()) props.editorView?.focus();
            event_0.preventDefault();
            event_0.stopPropagation();
        };
        $[37] = props.editorView;
        $[38] = t8;
    } else t8 = $[38];
    const handleEscape = t8;
    let t9;
    if ($[39] !== ToolbarPortal || $[40] !== customToolbar || $[41] !== handleEscape || $[42] !== nonCustomToolbar || $[43] !== props.editorView || $[44] !== props.intl || $[45] !== props.showKeyline || $[46] !== shouldSplitToolbar || $[47] !== twoLineEditorToolbar) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdURs.ContextPanelConsumer), null, (t10)=>{
            const { width: contextPanelWidth } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
                editorView: props.editorView,
                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                intl: props.intl
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a568e1bbe998ad4$export$9e3c8dcb351b94fd), {
                showKeyline: props.showKeyline || contextPanelWidth > 0,
                twoLineEditorToolbar: twoLineEditorToolbar,
                "data-testid": "ak-editor-main-toolbar"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbe8cfa9d91015c0$export$e9a48721664257fd), {
                twoLineEditorToolbar: twoLineEditorToolbar,
                role: "toolbar",
                "aria-label": props.intl.formatMessage((0, $l1ngX.messages).toolbarLabel)
            }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbe8cfa9d91015c0$export$c8150e2de9fece09), {
                twoLineEditorToolbar: twoLineEditorToolbar,
                "data-testid": "avatar-group-outside-plugin",
                role: "region",
                "aria-label": props.intl.formatMessage((0, $l1ngX.messages).pageActionsLabel)
            }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96wsv.ToolbarPortalMountPoint), null))));
        });
        $[39] = ToolbarPortal;
        $[40] = customToolbar;
        $[41] = handleEscape;
        $[42] = nonCustomToolbar;
        $[43] = props.editorView;
        $[44] = props.intl;
        $[45] = props.showKeyline;
        $[46] = shouldSplitToolbar;
        $[47] = twoLineEditorToolbar;
        $[48] = t9;
    } else t9 = $[48];
    return t9;
} : (props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $cozmU.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $96wsv.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $496f5200399ac3c7$export$c576cd6cf1d399bf), null, props.beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dba51f42e486181c$export$8889272e3d68acbb), null, props.beforeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVYsF.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a1504e889890b6d$export$d44d6319207b3004), null, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01a5fa2e0bf9040e$export$b41281e8d2acb8ab), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $cozmU.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $4aa536a4f2b2b9c7$export$f71dca5c73c8a7));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (0, $cozmU.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    const handleEscape = (0, $cozmU.useCallback)((event_0)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event_0.preventDefault();
        event_0.stopPropagation();
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdURs.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a568e1bbe998ad4$export$9e3c8dcb351b94fd), {
            showKeyline: props.showKeyline || contextPanelWidth > 0,
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbe8cfa9d91015c0$export$e9a48721664257fd), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $l1ngX.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbe8cfa9d91015c0$export$c8150e2de9fece09), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $l1ngX.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96wsv.ToolbarPortalMountPoint), null)))));
});
const $a28bca03d52754ef$export$26f3f0e30f9545b4 = (0, $kSwu1.injectIntl)($a28bca03d52754ef$export$477aaffea178bc4e);
function $a28bca03d52754ef$var$_temp(event) {
    return event.altKey && (event.key === "F9" || event.keyCode === 120);
}





















var $4iudd = parcelRequire("4iudd");




const $6dfc6a91dc63fc3b$export$2b04a2c5fbfbfe6c = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition !== 'none';
    if (contextualFormattingEnabled === 'always-pinned') return true;
    return false;
};


var $3nacY = parcelRequire("3nacY");














var $83KD5 = parcelRequire("83KD5");













/**
 * ExcludeFromHydration component delays rendering of its children until after the initial
 * hydration phase. It renders the fallback during SSR/hydration and children after.
 * @param children - The content to render after hydration
 * @param fallback - Optional fallback content to render during hydration (e.g., a placeholder to prevent layout shift)
 * @returns
 */ const $3ec78178c96b3325$var$ExcludeFromHydration = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ExcludeFromHydration(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children, fallback: t1 } = t0;
    const fallback = t1 === undefined ? null : t1;
    const [shouldRender, setShouldRender] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if ((0, $4iudd.isSSR)()) return;
            setShouldRender(true);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if (!shouldRender) return fallback ?? null;
    return children;
} : function ExcludeFromHydration({ children: children, fallback: fallback = null }) {
    const [shouldRender, setShouldRender] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $4iudd.isSSR)()) return;
        setShouldRender(true);
    }, []);
    if (!shouldRender) return fallback ?? null;
    return children;
};
var $3ec78178c96b3325$export$2e2bcd8739ae039 = $3ec78178c96b3325$var$ExcludeFromHydration;



var $lMyvS = parcelRequire("lMyvS");




const $54395c4f335ff96c$var$styles = {
    mainToolbarIconBefore: "_3138425zaO _0adFHs5zaO _1DCdHi5zaO",
    mainToolbarIconBeforeNew: "_0hPCNLDIqT _3iDTPbQ4SZ",
    mainToolbarWrapper: "_4c065UgVvo _2Y7lL48HPE _1x1D3gOeNX",
    mainToolbarNew: "_3iDTPbQ4SZ _0jFU0VUofl",
    mainToolbarZIndex: "_42Yu6BFIQA _1mT5xdRAKS",
    mainToolbarWithKeyline: "_2OUyjtFYNq",
    customToolbarWrapperStyle: "_0hPCNLDIqT _3iDTPbQ4SZ",
    firstChildWrapperOneLine: "_3iDTPbQ4SZ _2O5Vij7dHp",
    firstChildWrapperContainerContext: "_0u2WMmrU95 _3n40gWGjUA",
    secondChildWrapperOneLine: "_3iDTPbQ4SZ _4ouGXIE6Kk _0hPCNLDIqT",
    beforePrimaryToolbarComponents: "_3iDTPbQ4SZ _2O5Vij7dHp _37wbyuz9WS _0hPCNLDIqT",
    backgroundColor: "_0KLXrulfZc"
};
const $54395c4f335ff96c$var$MainToolbarWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId, showKeyline: showKeyline } = t0;
    const t1 = showKeyline && $54395c4f335ff96c$var$styles.mainToolbarWithKeyline;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.mainToolbarWrapper,
            t1,
            $54395c4f335ff96c$var$styles.mainToolbarZIndex,
            $54395c4f335ff96c$var$styles.mainToolbarNew,
            (0, $ieeJu.expValEquals)("platform_editor_table_sticky_header_improvements", "cohort", "test_with_overflow") && $54395c4f335ff96c$var$styles.backgroundColor
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, testId: testId, showKeyline: showKeyline })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.mainToolbarWrapper,
            showKeyline && $54395c4f335ff96c$var$styles.mainToolbarWithKeyline,
            $54395c4f335ff96c$var$styles.mainToolbarZIndex,
            $54395c4f335ff96c$var$styles.mainToolbarNew,
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $54395c4f335ff96c$var$styles.backgroundColor
        ])
    }, children);
};
const $54395c4f335ff96c$var$FirstChildWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.firstChildWrapperOneLine,
            $54395c4f335ff96c$var$styles.firstChildWrapperContainerContext
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "main-toolbar-first-child-wrapper",
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "main-toolbar-first-child-wrapper",
        className: (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.firstChildWrapperOneLine,
            $54395c4f335ff96c$var$styles.firstChildWrapperContainerContext
        ])
    }, children);
};
const $54395c4f335ff96c$var$SecondChildWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.secondChildWrapperOneLine
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "main-toolbar-second-child-wrapper",
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "main-toolbar-second-child-wrapper",
        className: (0, $hekY6.default)([
            $54395c4f335ff96c$var$styles.secondChildWrapperOneLine
        ])
    }, children);
};
const $54395c4f335ff96c$var$shouldShowToolbarContainer = (toolbar, customPrimaryToolbarComponents)=>{
    return !!toolbar || !!customPrimaryToolbarComponents;
};
const $54395c4f335ff96c$var$getToolbarComponentsForMarkdownView = (components, markdownModeView, isConvertedMarkdownPreview)=>{
    if (markdownModeView === 'syntax' || markdownModeView === 'preview') {
        // Converted markdown live pages in preview should show full toolbar content
        // so preference-based docking can work consistently.
        if (isConvertedMarkdownPreview) return components;
        return components.filter((component)=>component.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR || component.key === (0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key);
    }
    return components;
};
const $54395c4f335ff96c$export$9f4aa6ea8358228b = ({ editorAPI: editorAPI, beforeIcon: beforeIcon, toolbarDockingPosition: toolbarDockingPosition, editorView: editorView, popupsMountPoint: popupsMountPoint, showKeyline: showKeyline, customPrimaryToolbarComponents: customPrimaryToolbarComponents, disabled: disabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const runtimeOverride = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const contextualFormattingEnabled = runtimeOverride ?? editorAPI?.toolbar?.actions.contextualFormattingMode();
    const markdownModeState = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'markdownMode'
    ], (states_0)=>states_0.markdownModeState);
    const isLivePage = markdownModeState?.isLivePage;
    const isMarkdownMode = markdownModeState?.isMarkdownMode;
    const markdownModeView = markdownModeState?.view;
    const isConvertedMarkdownPreview = isMarkdownMode === true && isLivePage === true && markdownModeView === 'preview' && (0, $iDrrr.fg)('platform_editor_markdown_patch_m3');
    const intl = (0, $kSwu1.useIntl)();
    const toolbar = components?.find((component)=>component.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR);
    const visibleToolbarComponents = (0, $cozmU.useMemo)(()=>components ? $54395c4f335ff96c$var$getToolbarComponentsForMarkdownView(components, markdownModeView, isConvertedMarkdownPreview) : undefined, [
        components,
        markdownModeView,
        isConvertedMarkdownPreview
    ]);
    const effectiveContextualFormattingEnabled = isConvertedMarkdownPreview && contextualFormattingEnabled === 'always-pinned' ? 'controlled' : contextualFormattingEnabled;
    const primaryToolbarDockingConfigEnabled = (0, $6dfc6a91dc63fc3b$export$2b04a2c5fbfbfe6c)(effectiveContextualFormattingEnabled, toolbarDockingPosition); // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $96wsv.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const mountPoint = hasToolbarPortal ? undefined : popupsMountPoint;
    const isShortcutToFocusToolbar = (0, $cozmU.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && event.key === 'F9';
    }, []);
    const handleEscape = (0, $cozmU.useCallback)((event_0)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event_0.preventDefault();
        event_0.stopPropagation();
    }, [
        editorView
    ]); // Remove entire primary toolbar region if:
    // - primary toolbar isn't registered
    // - no custom primary toolbar components to render
    // note: primary toolbar must render if toolbar docking preference is set to "controlled" to avoid SSR conflicts
    // note(platform_editor_ssr_toolbar_optimistic): On the SSR and CSR, the toolbar plugin may be registered in the
    // injection API but its components not yet populated. Bypass the early-return
    // so the toolbar chrome stays mounted for layout stability; ToolbarNext renders
    // null inside it until components arrive.
    const isAwaitingToolbarComponents = (0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) && !Boolean(editorAPI?.toolbar);
    if (!isAwaitingToolbarComponents && !$54395c4f335ff96c$var$shouldShowToolbarContainer(toolbar, customPrimaryToolbarComponents)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarPortal, null, null);
    if (isConvertedMarkdownPreview && !primaryToolbarDockingConfigEnabled && !customPrimaryToolbarComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarPortal, null, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdURs.ContextPanelConsumer), null, ({ width: ContextPanelWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
            editorView: editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54395c4f335ff96c$var$MainToolbarWrapper, {
            testId: "ak-editor-main-toolbar",
            showKeyline: showKeyline || ContextPanelWidth > 0
        }, beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $54395c4f335ff96c$var$styles.mainToolbarIconBefore,
                $54395c4f335ff96c$var$styles.mainToolbarIconBeforeNew
            ])
        }, beforeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54395c4f335ff96c$var$FirstChildWrapper, null, (0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? // optimistic toolbar — render immediately on both SSR and CSR with items enabled.
        // Clicks are noops until editorView mounts.
        primaryToolbarDockingConfigEnabled && (components && visibleToolbarComponents && (0, $83KD5.isToolbar)(toolbar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lMyvS.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: false
        }) : // toolbar plugin not yet registered — render nothing inside the chrome for layout stability
        null) : (0, $4o0zT.isExperimentEnabled)('platform_editor_default_toolbar_state') ? primaryToolbarDockingConfigEnabled && components && visibleToolbarComponents && (0, $83KD5.isToolbar)(toolbar) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lMyvS.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ec78178c96b3325$export$2e2bcd8739ae039), null, primaryToolbarDockingConfigEnabled && components && visibleToolbarComponents && (0, $83KD5.isToolbar)(toolbar) && editorView && !(0, $4iudd.isSSR)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lMyvS.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54395c4f335ff96c$var$SecondChildWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $54395c4f335ff96c$var$styles.customToolbarWrapperStyle
            ])
        }, !!customPrimaryToolbarComponents && 'before' in customPrimaryToolbarComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": 'before-primary-toolbar-components-plugin',
            className: (0, $hekY6.default)([
                $54395c4f335ff96c$var$styles.beforePrimaryToolbarComponents
            ])
        }, customPrimaryToolbarComponents.before), !!customPrimaryToolbarComponents && 'after' in customPrimaryToolbarComponents ? customPrimaryToolbarComponents.after : customPrimaryToolbarComponents)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96wsv.ToolbarPortalMountPoint), null))))));
};


const $792580320b48ec67$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/fullPageAppearance';
const $792580320b48ec67$var$FullPageEditorWrapperMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $216648e7afc3dd30$export$2e95191265575e53), (0, $f60fa7b48fca8ab6$export$41c7ea372447284a));
const $792580320b48ec67$var$useShowKeyline = (0, $gtMdU.isReactCompilerActivePlatform)() ? (contentAreaRef)=>{
    const $ = (0, $bDgLe.c)(3);
    const [showKeyline, setShowKeyline] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== contentAreaRef) {
        t0 = ()=>{
            if (!contentAreaRef.current?.contentArea) return;
            const browser = (0, $8dxef.getBrowserInfo)();
            const intersection = new IntersectionObserver((t2)=>{
                const [entry] = t2;
                setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
            }, {
                root: undefined,
                threshold: browser.safari ? 0.98 : 1
            });
            intersection.observe(contentAreaRef.current.contentArea);
            return ()=>{
                intersection.disconnect();
            };
        };
        t1 = [
            contentAreaRef
        ];
        $[0] = contentAreaRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return showKeyline;
} : (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const browser = (0, $8dxef.getBrowserInfo)();
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: browser.safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $792580320b48ec67$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $792580320b48ec67$export$a15423dd96de66f2 = (props)=>{
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $cozmU.useRef)(performance.now());
    const wrapperElementRef = (0, $cozmU.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $cozmU.useRef)(null);
    const showKeyline = $792580320b48ec67$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const state = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'primaryToolbar',
        'interaction',
        'editorViewMode',
        'toolbar'
    ], (states)=>({
            primaryToolbarComponents: states.primaryToolbarState?.components,
            interactionState: states.interactionState?.interactionState,
            editorViewMode: states.editorViewModeState?.mode,
            contextualFormattingModeOverride: states.toolbarState?.contextualFormattingModeOverride
        }));
    // Markdown Mode forces `'always-pinned'` while in source / preview view
    // (no PM selection to anchor a floating toolbar to). The user's docking
    // pref alone is not enough to decide whether to mount the primary toolbar
    // in that case — the override has to short-circuit the hide gate below.
    const forcePrimaryToolbarPinned = state.contextualFormattingModeOverride === 'always-pinned';
    const interactionState = state.interactionState;
    const primaryToolbarState = (0, $5JOGK.getPrimaryToolbarComponents)(editorAPI, state.primaryToolbarComponents);
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    let toolbarDocking = (0, $4Qu9h.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking', {
        disabled: (0, $iDrrr.fg)('platform_editor_use_preferences_plugin')
    });
    if (!(0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) {
        if (!toolbarDocking) {
            // This is a workaround for the rendering issue with the selection toolbar
            // where using useSharedPluginStateSelector or useSharedPluginState the state are not
            // available when the editor is first loaded. and cause the toolbar to blink.
            const defaultDocking = props.__livePage ? 'none' : 'top';
            toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
        }
    }
    let { toolbarDockingPosition: toolbarDockingPosition } = (0, $4Qu9h.useSharedPluginStateSelector)(editorAPI, 'userPreferences.preferences', {
        disabled: !(0, $iDrrr.fg)('platform_editor_use_preferences_plugin')
    }) || {};
    if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) {
        if (!toolbarDockingPosition) {
            // This is a workaround for the rendering issue with the selection toolbar
            // when using useSharedPluginStateWithSelector the state is not yet
            // available when the editor is first loaded.
            // This causes the toolbar to blink creating a layout shift.
            const defaultDockingPosition = props.__livePage ? 'none' : 'top';
            toolbarDockingPosition = editorAPI?.userPreferences?.actions.getUserPreferences()?.toolbarDockingPosition ?? defaultDockingPosition;
        }
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = state.editorViewMode === 'view';
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) // need to check if the toolbarDockingPosition is set to 'none' or 'top'
        {
            if (toolbarDockingPosition === 'none' && !forcePrimaryToolbarPinned) {
                primaryToolbarComponents = [];
                if (!$792580320b48ec67$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else if (toolbarDocking === 'none' && !forcePrimaryToolbarPinned) {
            primaryToolbarComponents = [];
            if (!$792580320b48ec67$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZ0wT.SSRRenderMeasure), {
        segmentName: $792580320b48ec67$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: props.onSSRMeasure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdURs.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($792580320b48ec67$var$FullPageEditorWrapperMigration, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props
        {
            '--ak-editor-fullpage-toolbar-height': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7Y8M5.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)(isToolbarAIFCEnabled)
        }
    }, !isEditorToolbarHidden && (isToolbarAIFCEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54395c4f335ff96c$export$9f4aa6ea8358228b), {
        disabled: (0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? !hasHadInteraction ? false : !!props.disabled : !!props.disabled || !hasHadInteraction && (0, $4o0zT.isExperimentEnabled)('platform_editor_default_toolbar_state'),
        disabledWithoutInteractionLogic: !!props.disabled,
        toolbarDockingPosition: toolbarDockingPosition ?? toolbarDocking,
        beforeIcon: props.primaryToolbarIconBefore,
        editorAPI: editorAPI,
        editorView: props.editorView,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        showKeyline: showKeyline,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a28bca03d52754ef$export$26f3f0e30f9545b4), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d1be946ccb7e8e1$export$7db1e8e055ebd208), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: state.editorViewMode,
        hasHadInteraction: hasHadInteraction,
        contentMode: props.contentMode,
        UNSAFE_containLayout: props.UNSAFE_containLayout
    }))));
};
module.exports["FullPageEditor"] = $792580320b48ec67$export$a15423dd96de66f2;

});

parcelRegister("c1cJ9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5pkPF = parcelRequire("5pkPF");


var $bdURs = parcelRequire("bdURs");


var $3k5Tv = parcelRequire("3k5Tv");


var $lsQud = parcelRequire("lsQud");


var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");











var $hekY6 = parcelRequire("hekY6");

const $55f3b684141891b5$var$ANIM_SPEED_MS = 500;
const $55f3b684141891b5$var$getContextPanelWidthStyle = ({ customWidth: customWidth, visible: visible })=>{
    if (!visible) return {
        width: 0
    };
    if (customWidth) return {
        width: `${customWidth}px`
    };
    return undefined;
};
const $55f3b684141891b5$var$panelStyles = {
    panel: "_23rrnH8fjt _4bt5LAnQyn _2WAcuGnQyn _39xV02sz7G _0jFU0VN91d _2OUyjtvKUt",
    disablePanelAnimation: "_23rrnHYbGa",
    content: "_23rrnHu6BX _24h04i2Njc _39xV02sz7G _0jFU0VN91d _2WAcuGIZbP",
    padding: "_0Of8r25zaO _1Znuxb5zaO _1wydGWPgdg _2Zuz6Q5zaO",
    customWidthOverflow: "_4bt5LAnQyn"
};
const $55f3b684141891b5$export$1427500076f636b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let children;
    let customWidth;
    let disableAnimation;
    let rest;
    let visible;
    if ($[0] !== t0) {
        ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = customWidth;
        $[3] = disableAnimation;
        $[4] = rest;
        $[5] = visible;
    } else {
        children = $[1];
        customWidth = $[2];
        disableAnimation = $[3];
        rest = $[4];
        visible = $[5];
    }
    let t1;
    if ($[6] !== customWidth || $[7] !== visible) {
        t1 = $55f3b684141891b5$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        });
        $[6] = customWidth;
        $[7] = visible;
        $[8] = t1;
    } else t1 = $[8];
    const widthStyle = t1;
    const t2 = customWidth && "";
    const t3 = disableAnimation && $55f3b684141891b5$var$panelStyles.disablePanelAnimation;
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = (0, $hekY6.default)([
            $55f3b684141891b5$var$panelStyles.panel,
            t2,
            t3
        ]);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== children || $[13] !== rest || $[14] !== t4 || $[15] !== widthStyle) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: widthStyle,
            ...rest,
            className: t4
        }, children);
        $[12] = children;
        $[13] = rest;
        $[14] = t4;
        $[15] = widthStyle;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest })=>{
    const widthStyle = (0, $cozmU.useMemo)(()=>$55f3b684141891b5$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
    , {
        style: widthStyle,
        ...rest,
        className: (0, $hekY6.default)([
            $55f3b684141891b5$var$panelStyles.panel,
            customWidth && "",
            disableAnimation && $55f3b684141891b5$var$panelStyles.disablePanelAnimation
        ])
    }, children);
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $55f3b684141891b5$export$90b9783dea435d4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    let children;
    let customWidth;
    let disableAnimation;
    let hasPadding;
    let rest;
    let visible;
    if ($[0] !== t0) {
        ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = customWidth;
        $[3] = disableAnimation;
        $[4] = hasPadding;
        $[5] = rest;
        $[6] = visible;
    } else {
        children = $[1];
        customWidth = $[2];
        disableAnimation = $[3];
        hasPadding = $[4];
        rest = $[5];
        visible = $[6];
    }
    let t1;
    if ($[7] !== customWidth || $[8] !== visible) {
        t1 = $55f3b684141891b5$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        });
        $[7] = customWidth;
        $[8] = visible;
        $[9] = t1;
    } else t1 = $[9];
    const widthStyle = t1;
    const t2 = hasPadding && $55f3b684141891b5$var$panelStyles.padding;
    const t3 = customWidth && "";
    const t4 = disableAnimation && $55f3b684141891b5$var$panelStyles.disablePanelAnimation;
    let t5;
    if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
        t5 = (0, $hekY6.default)([
            $55f3b684141891b5$var$panelStyles.content,
            t2,
            t3,
            t4
        ]);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== children || $[15] !== rest || $[16] !== t5 || $[17] !== widthStyle) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: widthStyle,
            ...rest,
            className: t5
        }, children);
        $[14] = children;
        $[15] = rest;
        $[16] = t5;
        $[17] = widthStyle;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest })=>{
    const widthStyle = (0, $cozmU.useMemo)(()=>$55f3b684141891b5$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
    , {
        style: widthStyle,
        ...rest,
        className: (0, $hekY6.default)([
            $55f3b684141891b5$var$panelStyles.content,
            hasPadding && $55f3b684141891b5$var$panelStyles.padding,
            customWidth && "",
            disableAnimation && $55f3b684141891b5$var$panelStyles.disablePanelAnimation
        ])
    }, children);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `index.tsx`.
 *
 * Cleanup: delete this file once the `platform_editor_core_non_ecc_static_css` experiment has shipped.
 */ 



var $lOiVq = parcelRequire("lOiVq");




function $d7784fe36e421d9e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d7784fe36e421d9e$var$ANIM_SPEED_MS = 500;
const $d7784fe36e421d9e$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $d7784fe36e421d9e$var$panel = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7Y8M5.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$d7784fe36e421d9e$var$ANIM_SPEED_MS}ms ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #0B120E24)"}`
});
const $d7784fe36e421d9e$var$disablePanelAnimation = {
    name: "1wx2bp",
    styles: "transition:none"
};
const $d7784fe36e421d9e$var$content = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7Y8M5.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $d7784fe36e421d9e$var$paddingStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
const $d7784fe36e421d9e$export$cf4d28bc76693823 = ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest })=>{
    const customPanelWidthStyles = (0, $cozmU.useMemo)(()=>customWidth ? /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${customWidth}px`,
            overflowX: 'hidden'
        }) : undefined, [
        customWidth
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $d7784fe36e421d9e$var$panel,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
            customPanelWidthStyles,
            !visible && $d7784fe36e421d9e$var$panelHidden,
            disableAnimation && $d7784fe36e421d9e$var$disablePanelAnimation
        ],
        ...rest
    }, children);
};
const $d7784fe36e421d9e$export$8d909fc7bf63a35 = ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest })=>{
    const customPanelWidthStyles = (0, $cozmU.useMemo)(()=>customWidth ? /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${customWidth}px`,
            overflowX: 'hidden'
        }) : undefined, [
        customWidth
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $d7784fe36e421d9e$var$content,
            hasPadding && $d7784fe36e421d9e$var$paddingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
            customPanelWidthStyles,
            !visible && $d7784fe36e421d9e$var$panelHidden,
            disableAnimation && $d7784fe36e421d9e$var$disablePanelAnimation
        ],
        ...rest
    }, children);
};


const $ee0a2320f7c492de$var$ANIM_SPEED_MS = 500;
const $ee0a2320f7c492de$var$ContextPanelWrapperMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $55f3b684141891b5$export$1427500076f636b6), (0, $d7784fe36e421d9e$export$cf4d28bc76693823));
const $ee0a2320f7c492de$var$ContextPanelContentMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $55f3b684141891b5$export$90b9783dea435d4f), (0, $d7784fe36e421d9e$export$8d909fc7bf63a35));
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ee0a2320f7c492de$var$SwappableContentAreaInner extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $7Y8M5.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const disableAnimation = (0, $iDrrr.fg)('platform_editor_disable_context_panel_animation');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdURs.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee0a2320f7c492de$var$ContextPanelWrapperMigration, {
                customWidth: this.props.customWidth,
                visible: visible,
                disableAnimation: disableAnimation,
                "data-testid": "context-panel-panel",
                // eslint-disable-next-line @atlassian/a11y/no-empty-aria-label -- Pre-existing; intl should always resolve a label here
                "aria-label": this.props.intl?.formatMessage((0, $lsQud.contextPanelMessages).panelLabel) || '',
                "aria-modal": "false",
                role: "dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee0a2320f7c492de$var$ContextPanelContentMigration, {
                customWidth: this.props.customWidth,
                visible: visible,
                disableAnimation: disableAnimation,
                hasPadding: hasPadding,
                "data-testid": "context-panel-content",
                // Adding tabIndex=0 here to make content focusable as it is a scrollable region
                tabIndex: 0,
                role: "region",
                "aria-label": this.props.intl?.formatMessage((0, $lsQud.contextPanelMessages).panelContentLabel)
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            mounted: false,
            currentPluginContent: undefined
        };
        this.handleTransitionExited = ()=>{
            this.unsetPluginContent();
        };
        this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        };
        this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $iDrrr.fg)('platform_editor_disable_context_panel_animation') ? 0 : $ee0a2320f7c492de$var$ANIM_SPEED_MS;
            const onExited = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? this.handleTransitionExited : ()=>this.unsetPluginContent();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pkPF.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: onExited
            }, currentPluginContent);
        };
        this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $iDrrr.fg)('platform_editor_disable_context_panel_animation') ? 0 : $ee0a2320f7c492de$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pkPF.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
const $ee0a2320f7c492de$export$2aac880ec6fe2608 = (0, $kSwu1.injectIntl)($ee0a2320f7c492de$var$SwappableContentAreaInner);
const $ee0a2320f7c492de$export$c174a7dc96b2afb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ContextPanel(props) {
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "contextPanel"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const contextPanelContents = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, t0, $ee0a2320f7c492de$var$_temp);
    let t1;
    if ($[1] !== contextPanelContents) {
        t1 = contextPanelContents && contextPanelContents.find(Boolean);
        $[1] = contextPanelContents;
        $[2] = t1;
    } else t1 = $[2];
    const firstContent = t1;
    let t2;
    if ($[3] !== firstContent || $[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee0a2320f7c492de$export$2aac880ec6fe2608, {
            ...props,
            editorAPI: props.editorAPI,
            pluginContent: firstContent
        });
        $[3] = firstContent;
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ContextPanel(props) {
    const contextPanelContents = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.editorAPI, [
        'contextPanel'
    ], (states)=>states?.contextPanelState?.contents);
    const firstContent = contextPanelContents && contextPanelContents.find(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee0a2320f7c492de$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    });
};
function $ee0a2320f7c492de$var$_temp(states) {
    return states?.contextPanelState?.contents;
}
module.exports["ContextPanel"] = $ee0a2320f7c492de$export$c174a7dc96b2afb8;

});

parcelRegister("96wsv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a9ee929a3823763d$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $a9ee929a3823763d$export$89a0c16b81a39772 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, portal: portal, isActive: isActive } = t0;
    let t1;
    if ($[0] !== isActive || $[1] !== portal) {
        t1 = {
            Portal: portal,
            isActive: isActive
        };
        $[0] = isActive;
        $[1] = portal;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9ee929a3823763d$var$ToolbarPortalContext.Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9ee929a3823763d$var$ToolbarPortalContext.Provider, {
        value: value
    }, children);
};
const $a9ee929a3823763d$export$9fa9b541c351558 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($a9ee929a3823763d$var$ToolbarPortalContext);
} : ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($a9ee929a3823763d$var$ToolbarPortalContext);
};
const $a9ee929a3823763d$var$toolbarPortalStyles = {
    portal: "_49OCfRPgdg _1mT5xdWVPG _11sDorYbGa"
};
const $a9ee929a3823763d$export$ed65ed0e830b18c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const portal = $a9ee929a3823763d$export$9fa9b541c351558();
    if (portal) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $a9ee929a3823763d$var$toolbarPortalStyles.portal,
                "ak-editor-toolbar-portal"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const portal = $a9ee929a3823763d$export$9fa9b541c351558(); // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
     // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $a9ee929a3823763d$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};
module.exports["ToolbarPortalContextProvider"] = $a9ee929a3823763d$export$89a0c16b81a39772;
module.exports["useToolbarPortal"] = $a9ee929a3823763d$export$9fa9b541c351558;
module.exports["ToolbarPortalMountPoint"] = $a9ee929a3823763d$export$ed65ed0e830b18c8;

});

parcelRegister("5C5Mq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $dd1c0ac4112a3bb6$export$b5633b5b7afd4542 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useResolvedUserPreferences(userPreferencesProvider) {
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== userPreferencesProvider) {
        t0 = userPreferencesProvider?.getPreferences() || null;
        $[0] = userPreferencesProvider;
        $[1] = t0;
    } else t0 = $[1];
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== userPreferencesProvider) {
        t1 = ()=>userPreferencesProvider?.onUpdate(()=>{
                setResolvedUserPreferences(userPreferencesProvider.getPreferences());
            });
        t2 = [
            userPreferencesProvider
        ];
        $[2] = userPreferencesProvider;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== resolvedUserPreferences) {
        t3 = {
            resolvedUserPreferences: resolvedUserPreferences
        };
        $[5] = resolvedUserPreferences;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function useResolvedUserPreferences(userPreferencesProvider) {
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $cozmU.useState)(userPreferencesProvider?.getPreferences() || null);
    (0, $cozmU.useEffect)(()=>{
        return userPreferencesProvider?.onUpdate(()=>{
            setResolvedUserPreferences(userPreferencesProvider.getPreferences());
        });
    }, [
        userPreferencesProvider
    ]);
    return {
        resolvedUserPreferences: resolvedUserPreferences
    };
};



var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $jkcNT = parcelRequire("jkcNT");

const $9bbfcf54a0772351$export$17267f5809d60e00 = (currentOverrides, override)=>{
    const { key: key, value: value } = override;
    if (value === null || value === undefined) {
        const { [key]: _, ...rest } = currentOverrides;
        return rest;
    }
    return {
        ...currentOverrides,
        [key]: value
    };
};
const $9bbfcf54a0772351$export$26bf7aeec579553f = new (0, $kCECX.PluginKey)('userPreferencesPlugin');
const $9bbfcf54a0772351$export$ae829ec7b2625219 = (pluginOptions, _api)=>{
    const { userPreferencesProvider: userPreferencesProvider, initialUserPreferences: initialUserPreferences } = pluginOptions;
    const getInitialUserPreferences = ()=>{
        if (initialUserPreferences && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return initialUserPreferences;
        return {
            toolbarDockingPosition: 'top'
        };
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $9bbfcf54a0772351$export$26bf7aeec579553f,
        state: {
            init () {
                return {
                    preferences: userPreferencesProvider?.getPreferences() || getInitialUserPreferences(),
                    overrides: {}
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($9bbfcf54a0772351$export$26bf7aeec579553f);
                if (!meta || !meta.preferences && !meta.override) return currentPluginState;
                const nextState = {
                    ...currentPluginState
                };
                if (meta.preferences) nextState.preferences = {
                    ...currentPluginState.preferences,
                    ...meta.preferences
                };
                if (meta.override) nextState.overrides = $9bbfcf54a0772351$export$17267f5809d60e00(currentPluginState.overrides, meta.override);
                return nextState;
            }
        }
    });
};


const $115dab07e211c741$export$f9431c71d648ada2 = ({ key: key, value: value })=>({ tr: tr })=>{
        tr.setMeta((0, $9bbfcf54a0772351$export$26bf7aeec579553f), {
            override: {
                key: key,
                value: value
            }
        });
        return tr;
    };
const $115dab07e211c741$export$8243f41c2dd518ad = ({ key: key })=>({ tr: tr })=>{
        tr.setMeta((0, $9bbfcf54a0772351$export$26bf7aeec579553f), {
            override: {
                key: key,
                value: null
            }
        });
        return tr;
    };
const $115dab07e211c741$export$32e4436123e4fc74 = ({ key: key, value: value, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        try {
            userPreferencesProvider?.updatePreference(key, value);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-user-preferences/userPreferencesPlugin'
            });
        }
        // If the userPreferencesProvider is not available,
        // the plugin's state will be updated to operate in 'in memory' mode.
        tr.setMeta((0, $9bbfcf54a0772351$export$26bf7aeec579553f), {
            preferences: {
                [key]: value
            }
        });
        if (key === 'toolbarDockingPosition') editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: value
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };







var $cbY7C = parcelRequire("cbY7C");




const $7f5a5b4c8646f9c1$export$c3ff777471586be2 = (userPreferencesProvider)=>{
    (0, $cozmU.useEffect)(()=>{
        if (userPreferencesProvider) {
            const refreshPreferences = async ()=>{
                if (document.visibilityState === 'visible') try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $jv11C.logException)(error, {
                        location: 'editor-plugin-user-preferences/userPreferencesPlugin'
                    });
                }
            };
            return (0, $cbY7C.bind)(document, {
                type: 'visibilitychange',
                listener: refreshPreferences
            });
        }
    }, [
        userPreferencesProvider
    ]);
};









var $ieeJu = parcelRequire("ieeJu");

const $ef7d040b98810d87$export$2bd306fd54c8196e = (isInitialized, resolvedUserPreferences, api)=>{
    const isInitializedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isInitialized && resolvedUserPreferences && !isInitializedRef.current) {
            isInitializedRef.current = true;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).INITIALISED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).USER_PREFERENCES,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                attributes: {
                    toolbarDocking: resolvedUserPreferences.toolbarDockingPosition
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            // Only users with the toolbar docked at the top will see the button, so we
            // constrain the experiment population here rather than on every editor load.
            // This call is purely to log the exposure.
            if (resolvedUserPreferences.toolbarDockingPosition === 'top') // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $ieeJu.expValEquals)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true);
        }
    }, [
        api,
        isInitialized,
        resolvedUserPreferences
    ]);
};






const $3e70aa800ddf6e2c$export$c4b185fa097d4dc = (editorView, resolvedUserPreferences)=>{
    (0, $cozmU.useEffect)(()=>{
        if (resolvedUserPreferences) editorView.dispatch(editorView.state.tr.setMeta((0, $9bbfcf54a0772351$export$26bf7aeec579553f), {
            preferences: resolvedUserPreferences
        }));
    }, [
        resolvedUserPreferences,
        editorView
    ]);
};


const $2f22ab00e5a749d2$export$b2ef360f69e1145b = ({ config: config, api: api })=>{
    const userPreferencesProvider = config.userPreferencesProvider;
    return {
        name: 'userPreferences',
        pmPlugins () {
            return [
                {
                    name: 'userPreferencesPlugin',
                    plugin: ()=>{
                        return (0, $9bbfcf54a0772351$export$ae829ec7b2625219)(config, api);
                    }
                }
            ];
        },
        actions: {
            updateUserPreference: (key, value)=>{
                return (0, $115dab07e211c741$export$32e4436123e4fc74)({
                    key: key,
                    value: value,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                });
            },
            getUserPreferences: ()=>{
                if (!userPreferencesProvider) return config.initialUserPreferences;
                return userPreferencesProvider.getPreferences();
            }
        },
        commands: {
            overrideUserPreference: (key, value)=>{
                return (0, $115dab07e211c741$export$f9431c71d648ada2)({
                    key: key,
                    value: value
                });
            },
            clearOverrideUserPreference: (key)=>{
                return (0, $115dab07e211c741$export$8243f41c2dd518ad)({
                    key: key
                });
            }
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const state = (0, $9bbfcf54a0772351$export$26bf7aeec579553f).getState(editorState);
            // state can return undefined if the plugin hasn't been registered
            if (!state) return null;
            else if (!state.overrides || Object.keys(state.overrides).length === 0) return state;
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    ...state.overrides
                }
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const { resolvedUserPreferences: resolvedUserPreferences } = (0, $dd1c0ac4112a3bb6$export$b5633b5b7afd4542)(userPreferencesProvider);
            (0, $3e70aa800ddf6e2c$export$c4b185fa097d4dc)(editorView, resolvedUserPreferences);
            (0, $7f5a5b4c8646f9c1$export$c3ff777471586be2)(userPreferencesProvider);
            (0, $ef7d040b98810d87$export$2bd306fd54c8196e)(Boolean(userPreferencesProvider?.isInitialized), resolvedUserPreferences, api);
        }
    };
};
module.exports["userPreferencesPlugin"] = $2f22ab00e5a749d2$export$b2ef360f69e1145b;

});

parcelRegister("1CaNG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l5rX3 = parcelRequire("l5rX3");


var $9DHhW = parcelRequire("9DHhW");


var $krYZG = parcelRequire("krYZG");

var $fdQKX = parcelRequire("fdQKX");

var $gkq2M = parcelRequire("gkq2M");


var $gMweA = parcelRequire("gMweA");


var $5vSgR = parcelRequire("5vSgR");


var $kpCD8 = parcelRequire("kpCD8");







// oxlint-disable-next-line import/no-duplicates


var $907dffaea29d5885$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $907dffaea29d5885$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});



var $24ZxJ = parcelRequire("24ZxJ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");

function $e11b71c8f337b2a5$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $907dffaea29d5885$export$96527b3d022fe7df).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $8HW7o.CellSelection)) type = (0, $907dffaea29d5885$export$96527b3d022fe7df).CELL;
    else if (selection instanceof (0, $kCECX.NodeSelection)) type = (0, $907dffaea29d5885$export$96527b3d022fe7df).NODE;
    else if (selection.from !== selection.to) type = (0, $907dffaea29d5885$export$96527b3d022fe7df).RANGED;
    else {
        type = (0, $907dffaea29d5885$export$96527b3d022fe7df).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $907dffaea29d5885$export$f64a96dc7664cbe5).START;
        else if (from === $from.end()) position = (0, $907dffaea29d5885$export$f64a96dc7664cbe5).END;
        else position = (0, $907dffaea29d5885$export$f64a96dc7664cbe5).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $e11b71c8f337b2a5$var$findInsertedLocation(oldSelection, newSelection, tr) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $8HW7o.CellSelection)) return table.name;
    const newDoc = newSelection.$from.doc;
    const insertLocationInfo = (0, $bjg0G.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let pos = insertLocationInfo?.start || 0;
    // Map the old document position through the transaction's steps
    pos = tr.mapping.map(pos);
    let parentNodePos = newDoc.resolve(pos);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newDoc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $e11b71c8f337b2a5$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $e11b71c8f337b2a5$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $24ZxJ.findInsertLocation)(selection);
    if (tr && payload.action === (0, $krYZG.ACTION).INSERTED && payload.actionSubject !== (0, $krYZG.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $e11b71c8f337b2a5$var$findInsertedLocation(selection, tr.selection, tr);
    if (payload.action === (0, $krYZG.ACTION).INSERTED && payload.actionSubject === (0, $krYZG.ACTION_SUBJECT).DOCUMENT && payload.attributes) {
        payload.attributes.insertLocation = insertLocation;
        const { bodiedSyncBlock: bodiedSyncBlock } = selection.$from.doc.type.schema.nodes;
        payload.attributes.isInsideSyncedBlock = Boolean((0, $bjg0G.findParentNodeOfType)(bodiedSyncBlock)(selection));
    } else payload.attributes.nodeLocation = insertLocation;
    return payload;
}





function $7bf14a3c81404404$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $krYZG.ACTION).INSERTED && payload.actionSubject === (0, $krYZG.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $krYZG.ACTION).FORMATTED && payload.actionSubject === (0, $krYZG.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}


const $110175c8611e2815$var$actionsToIgnore = [
    (0, $krYZG.ACTION).INVOKED,
    (0, $krYZG.ACTION).OPENED
];
const $110175c8611e2815$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$110175c8611e2815$var$attachPayloadIntoTransaction({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
// This utils was taken as reference in packages/editor/editor-plugin-ai/src/analytics/utils.ts
//  to create new util attachPayloadIntoTransaction in above file.
// If you make a change here, please review attachPayloadIntoTransaction in above
//  file and update it as well if needed.
const $110175c8611e2815$var$attachPayloadIntoTransaction = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $e11b71c8f337b2a5$export$b8d8bec4e31cbd66)(selection, payload, tr);
    payload = (0, $7bf14a3c81404404$export$dd48e359ffe98e59)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $l5rX3.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $110175c8611e2815$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};




var $iTJtk = parcelRequire("iTJtk");

const $18b9a423bb7b7ff3$export$1467dbbb3bb418c6 = (0, $iTJtk.FabricChannel).editor;





const $44be83c1717ed33e$export$c4a4504e8a9a0b2e = new (0, $kCECX.PluginKey)('analyticsPlugin');


const $8b80ea273a59d029$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $8b80ea273a59d029$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $8b80ea273a59d029$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};


function $b865b214c8c85761$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $gMweA.isPerformanceAPIAvailable)();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $44be83c1717ed33e$export$c4a4504e8a9a0b2e),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $fdQKX.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $44be83c1717ed33e$export$c4a4504e8a9a0b2e)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $gkq2M.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $krYZG.ACTION).INSERTED && payload.action !== (0, $krYZG.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $5vSgR.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $fdQKX.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $b865b214c8c85761$var$extendPayload({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $b865b214c8c85761$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $44be83c1717ed33e$export$c4a4504e8a9a0b2e).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $110175c8611e2815$export$539ce7f09649e93)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $18b9a423bb7b7ff3$export$1467dbbb3bb418c6))=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent (payload, channel = (0, $18b9a423bb7b7ff3$export$1467dbbb3bb418c6), options) {
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (options?.context) payload = (0, $e11b71c8f337b2a5$export$b8d8bec4e31cbd66)(options.context.selection, payload);
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                // This cast is needed to satisfy TS when using custom payloads which is only allowed by
                // the fireAnalyticsEvent function in EditorAnalyticsAPI for now.
                // createAnalyticsEvent actually fires our standard AnalyticsEventPayload type which is less strict
                // so this is safe.
                const firedPayload = payload;
                (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: firedPayload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
            (0, $cozmU.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $44be83c1717ed33e$export$c4a4504e8a9a0b2e), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    createAnalyticsEvent(payload)?.fire(channel ?? (0, $18b9a423bb7b7ff3$export$1467dbbb3bb418c6));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$b865b214c8c85761$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $44be83c1717ed33e$export$c4a4504e8a9a0b2e).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $l5rX3.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $8b80ea273a59d029$export$67d130a769494b9b)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $b865b214c8c85761$var$extendPayload({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
}
module.exports["analyticsPlugin"] = $b865b214c8c85761$export$f26023c5d4a5ab44;

});

parcelRegister("8QOo3", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

const $b3d99675333063dd$export$de2a5eca4f1cacc0 = new WeakMap();
const $b3d99675333063dd$export$657fbcd00719af4b = 'toggleExpandRange';
const $b3d99675333063dd$export$de35616b4bcd2077 = (from, to, open = true)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        const fromClamped = from && from >= 0 ? from : 0;
        const toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
        const positions = [];
        tr.doc.nodesBetween(fromClamped, toClamped, (node, pos)=>{
            if ([
                expand,
                nestedExpand
            ].includes(node.type)) {
                $b3d99675333063dd$export$de2a5eca4f1cacc0.set(node, open);
                positions.push(pos);
            }
        });
        if (positions.length === 0) // No expand nodes found in the range — nothing to dispatch.
        return null;
        // Set meta so the expand PM plugin can add node decorations.
        // This ensures ExpandNodeView.update() receives the decoration and visually
        // opens or closes the expand.
        tr.setMeta($b3d99675333063dd$export$657fbcd00719af4b, {
            positions: positions,
            open: open
        });
        return tr;
    };
const $b3d99675333063dd$export$785b8bfd794fa7b6 = (node)=>{
    // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
    return !$b3d99675333063dd$export$de2a5eca4f1cacc0.get(node) ?? false;
};
const $b3d99675333063dd$export$90f32e719ed9ccda = (editorView, selection)=>{
    let parentNode = (0, $bjg0G.findParentNodeOfType)([
        editorView.state.schema.nodes.listItem,
        editorView.state.schema.nodes.heading,
        editorView.state.schema.nodes.blockquote,
        editorView.state.schema.nodes.taskItem,
        editorView.state.schema.nodes.mediaSingle
    ])(selection);
    const tableRowNode = (0, $bjg0G.findParentNodeOfType)([
        editorView.state.schema.nodes.tableRow
    ])(selection);
    if (tableRowNode) parentNode = tableRowNode;
    if (!parentNode) {
        const paragraphNode = (0, $bjg0G.findParentNodeOfType)([
            editorView.state.schema.nodes.paragraph
        ])(selection);
        if (!paragraphNode) return;
        parentNode = paragraphNode;
    }
    if (!parentNode) return undefined;
    const endPosOffset = parentNode && [
        'taskItem',
        'listItem',
        'tableRow'
    ].includes(parentNode.node.type.name) ? 1 : 0;
    const endOfTextblockPos = parentNode.start + parentNode.node.content.size + endPosOffset + 1;
    if (endOfTextblockPos > editorView.state.doc.content.size) return undefined;
    const $endOfTextblockPos = editorView.state.doc.resolve(endOfTextblockPos);
    if ($endOfTextblockPos?.nodeAfter && [
        'expand',
        'nestedExpand'
    ].includes($endOfTextblockPos.nodeAfter.type.name)) return endOfTextblockPos + 1;
    return undefined;
};
module.exports["expandedState"] = $b3d99675333063dd$export$de2a5eca4f1cacc0;
module.exports["TOGGLE_EXPAND_RANGE_META_KEY"] = $b3d99675333063dd$export$657fbcd00719af4b;
module.exports["toggleExpandRange"] = $b3d99675333063dd$export$de35616b4bcd2077;
module.exports["isExpandCollapsed"] = $b3d99675333063dd$export$785b8bfd794fa7b6;
module.exports["getNextNodeExpandPos"] = $b3d99675333063dd$export$90f32e719ed9ccda;

});

parcelRegister("b2omX", function(module, exports) {
const $e484296df8666fa4$var$elementByView = new WeakMap();
const $e484296df8666fa4$var$listenersByView = new WeakMap();
const $e484296df8666fa4$export$77832c0bea73da80 = {
    get: (view)=>{
        const element = view && $e484296df8666fa4$var$elementByView.get(view) || null;
        return element?.isConnected ? element : null;
    },
    release: (view, element)=>{
        if (!view || !element || $e484296df8666fa4$var$elementByView.get(view) !== element) return;
        $e484296df8666fa4$export$77832c0bea73da80.set(view, null);
    },
    set: (view, element)=>{
        if (!view) return;
        const current = $e484296df8666fa4$var$elementByView.get(view) ?? null;
        if (current === element) return;
        if (element) $e484296df8666fa4$var$elementByView.set(view, element);
        else $e484296df8666fa4$var$elementByView.delete(view);
        $e484296df8666fa4$var$listenersByView.get(view)?.forEach((listener)=>listener());
    },
    subscribe: (view, listener)=>{
        if (!view) return ()=>{};
        const listeners = $e484296df8666fa4$var$listenersByView.get(view) ?? new Set();
        listeners.add(listener);
        $e484296df8666fa4$var$listenersByView.set(view, listeners);
        return ()=>{
            listeners.delete(listener);
        };
    }
};
module.exports["surfaceDragHandleElementStore"] = $e484296df8666fa4$export$77832c0bea73da80;

});

parcelRegister("kAPZe", function(module, exports) {
const $18471d62d6f1377e$export$21d634b1d5d9bee3 = '[data-editor-block-ctrl-drag-handle]';
const $18471d62d6f1377e$export$8e6a2e69f746ce30 = 12;
const $18471d62d6f1377e$export$4ca64d379b54b5d9 = '[data-toolbar-nested-dropdown-menu]';
module.exports["DRAG_HANDLE_SELECTOR"] = $18471d62d6f1377e$export$21d634b1d5d9bee3;
module.exports["DRAG_HANDLE_WIDTH"] = $18471d62d6f1377e$export$8e6a2e69f746ce30;
module.exports["NESTED_DROPDOWN_MENU"] = $18471d62d6f1377e$export$4ca64d379b54b5d9;

});

parcelRegister("dQrHJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $4o0zT = parcelRequire("4o0zT");


var $iMnC5 = parcelRequire("iMnC5");

const $68ac6fee8577da34$var$styles = {
    container: "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v",
    radiusUpdate: "_0bjKvD8fU6",
    emptyMenuSectionStyles: "_3bMLo9YbGa _3HuyscYbGa"
};
const $68ac6fee8577da34$export$7ddb7d7248bd500a = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, testId: testId, xcss: xcss } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $w6R6I.cx)($68ac6fee8577da34$var$styles.container, (0, $4o0zT.isExperimentEnabled)("platform_editor_menu_radius_update") && $68ac6fee8577da34$var$styles.radiusUpdate, (0, $4o0zT.isExperimentEnabled)("platform_editor_menu_radius_update") && $68ac6fee8577da34$var$styles.emptyMenuSectionStyles, (0, $4o0zT.isExperimentEnabled)("platform_editor_menu_radius_update") && xcss);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== onMouseDown || $[4] !== onMouseEnter || $[5] !== ref || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            testId: testId,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            "data-toolbar-component": "menu",
            role: "menu",
            ref: ref,
            children: children
        });
        $[2] = children;
        $[3] = onMouseDown;
        $[4] = onMouseEnter;
        $[5] = ref;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, testId: testId, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($68ac6fee8577da34$var$styles.container, (0, $4o0zT.isExperimentEnabled)('platform_editor_menu_radius_update') && $68ac6fee8577da34$var$styles.radiusUpdate, (0, $4o0zT.isExperimentEnabled)('platform_editor_menu_radius_update') && $68ac6fee8577da34$var$styles.emptyMenuSectionStyles, (0, $4o0zT.isExperimentEnabled)('platform_editor_menu_radius_update') && xcss),
        testId: testId,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        "data-toolbar-component": "menu",
        role: "menu",
        ref: ref,
        children: children
    });
});
module.exports["ToolbarMenuContainer"] = $68ac6fee8577da34$export$7ddb7d7248bd500a;

});

parcelRegister("gk3KR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $3vgx3 = parcelRequire("3vgx3");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $dVKvM = parcelRequire("dVKvM");


var $lslMH = parcelRequire("lslMH");

const $1bfac7ec2f27774d$var$styles = {
    scrollContainer: "_0NUa3rsz7G _2WAcuGIZbP"
};
const $1bfac7ec2f27774d$export$21541b912954ea8c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { elemBefore: elemBefore, text: text, elemAfterText: elemAfterText, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: t1, onClick: onClick, shouldFitContainer: t2, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldTitleWrap: shouldTitleWrap, tooltipContent: tooltipContent, "data-extension-item-key": dataExtensionItemKey } = t0;
    const enableMaxHeight = t1 === undefined ? false : t1;
    const shouldFitContainer = t2 === undefined ? false : t2;
    const t3 = (0, $iDrrr.fg)("cc_blocks_changeboarding") ? shouldIgnoreCloseEvent : undefined;
    let t4;
    if ($[0] !== dataExtensionItemKey || $[1] !== elemAfter || $[2] !== elemAfterText || $[3] !== elemBefore || $[4] !== isDisabled || $[5] !== onClick || $[6] !== shouldTitleWrap || $[7] !== testId || $[8] !== text || $[9] !== tooltipContent) {
        t4 = (triggerProps)=>{
            const item = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dVKvM.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: triggerProps.triggerRef,
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                shouldTitleWrap: shouldTitleWrap,
                "data-extension-item-key": (0, $iDrrr.fg)("cc_blocks_changeboarding") ? dataExtensionItemKey : undefined,
                children: [
                    text,
                    elemAfterText
                ]
            });
            if (tooltipContent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent,
                position: "top",
                children: item
            });
            return item;
        };
        $[0] = dataExtensionItemKey;
        $[1] = elemAfter;
        $[2] = elemAfterText;
        $[3] = elemBefore;
        $[4] = isDisabled;
        $[5] = onClick;
        $[6] = shouldTitleWrap;
        $[7] = testId;
        $[8] = text;
        $[9] = tooltipContent;
        $[10] = t4;
    } else t4 = $[10];
    const t5 = enableMaxHeight && $1bfac7ec2f27774d$var$styles.scrollContainer;
    let t6;
    if ($[11] !== t5) {
        t6 = (0, $k12R1.cx)(t5);
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== children || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t6,
            "data-toolbar-nested-dropdown-menu": true,
            children: children
        });
        $[13] = children;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== dropdownTestId || $[17] !== shouldFitContainer || $[18] !== t3 || $[19] !== t4 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            shouldFitContainer: shouldFitContainer,
            shouldIgnoreCloseEvent: t3,
            placement: "right-start",
            testId: dropdownTestId,
            trigger: t4,
            children: t7
        });
        $[16] = dropdownTestId;
        $[17] = shouldFitContainer;
        $[18] = t3;
        $[19] = t4;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ elemBefore: elemBefore, text: text, elemAfterText: elemAfterText, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: enableMaxHeight = false, onClick: onClick, shouldFitContainer: shouldFitContainer = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldTitleWrap: shouldTitleWrap, tooltipContent: tooltipContent, 'data-extension-item-key': dataExtensionItemKey })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        shouldFitContainer: shouldFitContainer,
        shouldIgnoreCloseEvent: (0, $iDrrr.fg)('cc_blocks_changeboarding') ? shouldIgnoreCloseEvent : undefined,
        placement: "right-start",
        testId: dropdownTestId,
        trigger: (triggerProps)=>{
            const item = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dVKvM.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: triggerProps.triggerRef,
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                shouldTitleWrap: shouldTitleWrap,
                "data-extension-item-key": (0, $iDrrr.fg)('cc_blocks_changeboarding') ? dataExtensionItemKey : undefined,
                children: [
                    text,
                    elemAfterText
                ]
            });
            if (tooltipContent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent,
                position: "top",
                children: item
            });
            return item;
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)(enableMaxHeight && $1bfac7ec2f27774d$var$styles.scrollContainer),
            "data-toolbar-nested-dropdown-menu": true,
            children: children
        })
    });
};
module.exports["ToolbarNestedDropdownMenu"] = $1bfac7ec2f27774d$export$21541b912954ea8c;

});

parcelRegister("5VZEy", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");

const $c27b10d9380a677a$var$pluginKey = new (0, $kCECX.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $c27b10d9380a677a$var$createPlugin() {
    return new (0, $kpCD8.SafePlugin)({
        key: $c27b10d9380a677a$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $iLrhi.isEmptyDocument)(oldState.doc) && (0, $iLrhi.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $c27b10d9380a677a$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $c27b10d9380a677a$var$createPlugin
                }
            ];
        }
    });
module.exports["clearMarksOnEmptyDocPlugin"] = $c27b10d9380a677a$export$30b76f1055cbb7e9;

});

parcelRegister("ifkCZ", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jfFbl = parcelRequire("jfFbl");


var $kpCD8 = parcelRequire("kpCD8");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $kCECX = parcelRequire("kCECX");

const $b0d34b62107ef50b$export$7ff3d0e65871bad3 = new (0, $kCECX.PluginKey)('clipboardPlugin');


var $15964e6f0a59609a$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $15964e6f0a59609a$var$lastEventType = null;
const $15964e6f0a59609a$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $b0d34b62107ef50b$export$7ff3d0e65871bad3),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $15964e6f0a59609a$export$47cf4f31f028e0c9("CUT");
                    return $15964e6f0a59609a$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $krYZG.ACTION).CUT);
                },
                copy: (view)=>{
                    $15964e6f0a59609a$export$47cf4f31f028e0c9("COPY");
                    return $15964e6f0a59609a$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $krYZG.ACTION).COPIED);
                }
            },
            clipboardSerializer: $15964e6f0a59609a$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $15964e6f0a59609a$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $aPdNQ.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $aPdNQ.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $bjg0G.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $aPdNQ.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($15964e6f0a59609a$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            // Content for media parents can include multiple content nodes (media and captions). We now take that
            // into consideration when we are stripping annotations.
            let contentArray = [
                strippedMediaNode
            ];
            content.forEach((node)=>{
                if (node.type.name !== 'media') contentArray = [
                    ...contentArray,
                    node
                ];
            });
            const newContent = (0, $aPdNQ.Fragment).fromArray(contentArray);
            // Currently incorrectly typed, see comment above
            // @ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $15964e6f0a59609a$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $jfFbl.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $15964e6f0a59609a$export$47cf4f31f028e0c9 = (eventType)=>$15964e6f0a59609a$var$lastEventType = eventType;


const $663e50abcde7a8ac$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $15964e6f0a59609a$export$ae829ec7b2625219)(options)
                }
            ];
        }
    });
var $663e50abcde7a8ac$export$2e2bcd8739ae039 = $663e50abcde7a8ac$var$clipboard;
module.exports["default"] = $663e50abcde7a8ac$export$2e2bcd8739ae039;

});

parcelRegister("lDJPY", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $f73a9ad173c464e9$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('contextIdentiferPlugin');
async function $f73a9ad173c464e9$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $f73a9ad173c464e9$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $f73a9ad173c464e9$var$updateContextIdentifier(initialConfig, api);
        return new (0, $kpCD8.SafePlugin)({
            key: $f73a9ad173c464e9$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($f73a9ad173c464e9$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };


const $5e55bb2994d043c4$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $f73a9ad173c464e9$export$18d4026d1ea86bb1), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $f73a9ad173c464e9$export$18d4026d1ea86bb1).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $f73a9ad173c464e9$export$ae829ec7b2625219)(config, api)
                }
            ];
        }
    };
};
module.exports["contextIdentifierPlugin"] = $5e55bb2994d043c4$export$43b392516e89a467;

});

parcelRegister("h0KOi", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $3141b9ccaa59f7b8$var$pluginKey = new (0, $kCECX.PluginKey)('featureFlags');
const $3141b9ccaa59f7b8$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $3141b9ccaa59f7b8$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            key: $3141b9ccaa59f7b8$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });
module.exports["featureFlagsPlugin"] = $3141b9ccaa59f7b8$export$79626a094e303f80;

});

parcelRegister("4Kyof", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $67cccefcc148694a$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('focusPluginHandler');
const $67cccefcc148694a$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $67cccefcc148694a$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($67cccefcc148694a$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $67cccefcc148694a$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($67cccefcc148694a$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $67cccefcc148694a$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($67cccefcc148694a$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });


const $889cbdf8412b7f65$export$78540d08bd386fba = ({ api: _api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $67cccefcc148694a$export$df61b30b684217c0).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $67cccefcc148694a$export$ae829ec7b2625219)
                }
            ];
        }
    };
};
module.exports["focusPlugin"] = $889cbdf8412b7f65$export$78540d08bd386fba;

});

parcelRegister("6WRJZ", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $cI8RZ = parcelRequire("cI8RZ");

var $112688a0941ae4a5$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});



const $f07a6e1196123ea5$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $112688a0941ae4a5$export$324bf1d9598f1f30).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $f07a6e1196123ea5$export$2e2bcd8739ae039 = $f07a6e1196123ea5$var$reducer;



var $2w79Z = parcelRequire("2w79Z");

// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $63d16cd53417d9bf$var$fakePluginKey = {
    key: (0, $2w79Z.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $2w79Z.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $2w79Z.pmHistoryPluginKey));
    }
};
const $63d16cd53417d9bf$export$6bcebd7b5d7b9325 = (state)=>{
    return $63d16cd53417d9bf$var$fakePluginKey.getState(state);
};



var $kCECX = parcelRequire("kCECX");

const $d89e74f17d9532bb$export$8869884044241c3c = new (0, $kCECX.PluginKey)('historyPlugin');


const $19cef0b431d34c45$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $19cef0b431d34c45$var$createPluginState, getPluginState: $19cef0b431d34c45$var$getPluginState } = (0, $cI8RZ.pluginFactory)((0, $d89e74f17d9532bb$export$8869884044241c3c), (0, $f07a6e1196123ea5$export$2e2bcd8739ae039));
const $19cef0b431d34c45$var$createPlugin = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        state: $19cef0b431d34c45$var$createPluginState(dispatch, $19cef0b431d34c45$var$getInitialState),
        key: (0, $d89e74f17d9532bb$export$8869884044241c3c),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false || tr.getMeta('endHistorySlice'))) {
                const pmHistoryPluginState = (0, $63d16cd53417d9bf$export$6bcebd7b5d7b9325)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $19cef0b431d34c45$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $112688a0941ae4a5$export$324bf1d9598f1f30).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $d89e74f17d9532bb$export$8869884044241c3c), action);
                }
            }
        }
    });
const $19cef0b431d34c45$var$historyPlugin = ({ api: api })=>{
    let currentId = null;
    return {
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$19cef0b431d34c45$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $d89e74f17d9532bb$export$8869884044241c3c).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $63d16cd53417d9bf$export$6bcebd7b5d7b9325)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: done?.eventCount ?? 0
                },
                undone: {
                    eventCount: undone?.eventCount ?? 0
                }
            };
        },
        commands: {
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = api?.history.sharedState.currentState() ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $112688a0941ae4a5$export$324bf1d9598f1f30).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $d89e74f17d9532bb$export$8869884044241c3c), action);
            },
            startHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId) return null;
                    currentId = id;
                    return tr.setMeta('startHistorySlice', true);
                },
            endHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId !== id) return null;
                    currentId = null;
                    return tr.setMeta('endHistorySlice', true);
                }
        }
    };
};
var $19cef0b431d34c45$export$2e2bcd8739ae039 = $19cef0b431d34c45$var$historyPlugin;
module.exports["default"] = $19cef0b431d34c45$export$2e2bcd8739ae039;

});

parcelRegister("jT02V", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $ca2720939e9aa1c5$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('interactionPluginHandler');
const $ca2720939e9aa1c5$var$handleInteraction = (view)=>{
    const interactionState = $ca2720939e9aa1c5$export$df61b30b684217c0.getState(view.state);
    if (!interactionState?.hasHadInteraction) view.dispatch(view.state.tr.setMeta($ca2720939e9aa1c5$export$df61b30b684217c0, {
        hasHadInteraction: true
    }));
    return false;
};
const $ca2720939e9aa1c5$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $ca2720939e9aa1c5$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasHadInteraction: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($ca2720939e9aa1c5$export$df61b30b684217c0);
                if (typeof meta === 'object') {
                    if (meta.hasHadInteraction !== oldPluginState.hasHadInteraction) return {
                        hasHadInteraction: meta.hasHadInteraction
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                // Handle all pointer click events (includes drag inside editor)
                mousedown: $ca2720939e9aa1c5$var$handleInteraction,
                // Handle keyboard events. Must be keyup to handle tabbing into editor (keyup occurs
                // on the "next focused" element)
                keyup: $ca2720939e9aa1c5$var$handleInteraction,
                // Handle drag and drop _into_ the editor from outside. Eg image DnD
                drop: $ca2720939e9aa1c5$var$handleInteraction,
                focus: $ca2720939e9aa1c5$var$handleInteraction
            }
        }
    });


const $af5ea68114104422$export$f92f816359ce0a38 = ()=>{
    return {
        name: 'interaction',
        getSharedState (editorState) {
            if (!editorState) return {
                interactionState: 'hasNotHadInteraction'
            };
            return {
                /**
         * Interaction state can either be null or 'hasNotHadInteraction'. We
         * are specifically only returning an explicit value for 'hasNotHadInteraction'
         * because behaviour should only change when the user has _not_ ineteracted
         * with the editor. The behaviour of when `hasHadInteraction` is true and
         * when the plugin is undefined should be the same.
         */ interactionState: (0, $ca2720939e9aa1c5$export$df61b30b684217c0).getState(editorState)?.hasHadInteraction ? null : 'hasNotHadInteraction'
            };
        },
        commands: {
            handleInteraction: ({ tr: tr })=>{
                return tr.setMeta((0, $ca2720939e9aa1c5$export$df61b30b684217c0), {
                    hasHadInteraction: true
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'interactionHandlerPlugin',
                    plugin: (0, $ca2720939e9aa1c5$export$ae829ec7b2625219)
                }
            ];
        }
    };
};
module.exports["interactionPlugin"] = $af5ea68114104422$export$f92f816359ce0a38;

});

parcelRegister("f3DNZ", function(module, exports) {
/* placeholderPlugin.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $kpCD8 = parcelRequire("kpCD8");


var $mW7G5 = parcelRequire("mW7G5");


var $f3DNZ = parcelRequire("f3DNZ");

const $a9d11cb5027ae772$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $a9d11cb5027ae772$export$2d1270bfa8929bb4 = 50; // Delay between typing each character
const $a9d11cb5027ae772$export$ae685e1a0fa5d78 = 2000; // Pause before starting to erase text
const $a9d11cb5027ae772$export$ff06808c8f6da73a = 40; // Delay between erasing each character
const $a9d11cb5027ae772$export$d41926d20419077b = 500; // Delay before starting next cycle
const $a9d11cb5027ae772$export$4b72a719051acd03 = 1500; // Delay before starting animation after user typed and deleted
const $a9d11cb5027ae772$export$a754230d588f273f = [
    'expand',
    'panel'
];
const $a9d11cb5027ae772$export$70f0891e62fedaad = [
    'tableCell',
    'tableHeader'
];
const $a9d11cb5027ae772$export$b5dfee3212a7a6ea = [
    'bodiedSyncBlock'
];



var $8dxef = parcelRequire("8dxef");


var $5Qi6J = parcelRequire("5Qi6J");


var $fngNp = parcelRequire("fngNp");


var $aPdNQ = parcelRequire("aPdNQ");


var $8nvEM = parcelRequire("8nvEM");


var $jkcNT = parcelRequire("jkcNT");


const $89b19eb21c7a1dbc$export$e2d45b5ccf27f1ce = (placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted = 0)=>{
    let currentPromptIndex = 0;
    let displayedText = '';
    let animationTimeouts = [];
    const clearAllTimeouts = ()=>{
        animationTimeouts.forEach((timeoutId)=>clearTimeout(timeoutId));
        animationTimeouts = [];
    };
    const scheduleTimeout = (callback, delay)=>{
        const timeoutId = setTimeout(callback, delay);
        animationTimeouts.push(timeoutId);
        return timeoutId;
    };
    const startAnimationCycle = ()=>{
        const currentPrompt = placeholderPrompts[currentPromptIndex];
        let characterIndex = 0;
        const typeNextCharacter = ()=>{
            if (characterIndex < currentPrompt.length) {
                displayedText = currentPrompt.substring(0, characterIndex + 1);
                placeholderNodeWithText.textContent = displayedText;
                characterIndex++;
                scheduleTimeout(typeNextCharacter, (0, $a9d11cb5027ae772$export$2d1270bfa8929bb4));
            } else scheduleTimeout(eraseLastCharacter, (0, $a9d11cb5027ae772$export$ae685e1a0fa5d78));
        };
        const eraseLastCharacter = ()=>{
            if (displayedText.length > 1) {
                displayedText = displayedText.substring(0, displayedText.length - 1);
                placeholderNodeWithText.textContent = displayedText;
                scheduleTimeout(eraseLastCharacter, (0, $a9d11cb5027ae772$export$ff06808c8f6da73a));
            } else {
                displayedText = ' ';
                placeholderNodeWithText.textContent = displayedText;
                currentPromptIndex = (currentPromptIndex + 1) % placeholderPrompts.length;
                scheduleTimeout(startAnimationCycle, (0, $a9d11cb5027ae772$export$d41926d20419077b));
            }
        };
        typeNextCharacter();
    };
    activeTypewriterTimeouts?.push(clearAllTimeouts);
    if (initialDelayWhenUserTypedAndDeleted > 0) {
        placeholderNodeWithText.textContent = ' ';
        scheduleTimeout(startAnimationCycle, initialDelayWhenUserTypedAndDeleted);
    } else startAnimationCycle();
};



function $0435e4618b477671$export$980ea07f18fbfea9(editorState, placeholderText, placeholderPrompts, activeTypewriterTimeouts, pos = 1, initialDelayWhenUserTypedAndDeleted = 0, placeholderADF, showOnEmptyParagraph) {
    const browser = (0, $8dxef.getBrowserInfo)();
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', (0, $a9d11cb5027ae772$export$53e9a5af7ff64f3e));
    const shouldFadeIn = showOnEmptyParagraph;
    placeholderDecoration.className = shouldFadeIn ? 'placeholder-decoration placeholder-decoration-fade-in' : 'placeholder-decoration';
    placeholderDecoration.setAttribute('aria-hidden', 'true');
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if (browser.gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    if (placeholderText) placeholderNodeWithText.textContent = placeholderText || ' ';
    else if (placeholderADF) {
        const serializer = (0, $aPdNQ.DOMSerializer).fromSchema(editorState.schema);
        // Get a PMNode from docnode
        const docNode = (0, $5Qi6J.processRawValue)(editorState.schema, placeholderADF);
        if (docNode) {
            // Extract only the inline content from paragraphs, avoiding block-level elements
            // that can interfere with cursor rendering
            docNode.children.forEach((node)=>{
                // For paragraph nodes, serialize their content (inline elements) directly
                // without the wrapping <p> tag
                if (node.type.name === 'paragraph') node.content.forEach((inlineNode)=>{
                    const inlineDOM = serializer.serializeNode(inlineNode);
                    placeholderNodeWithText.append(inlineDOM);
                });
                else {
                    // For non-paragraph nodes, serialize normally
                    const nodeDOM = serializer.serializeNode(node);
                    placeholderNodeWithText.append(nodeDOM);
                }
            });
            const markElements = placeholderNodeWithText.querySelectorAll('[data-prosemirror-content-type="mark"]');
            markElements.forEach((markEl)=>{
                if (markEl instanceof HTMLElement) markEl.style.setProperty('color', "var(--ds-text-subtlest, #6B6E76)");
            });
            // Ensure all child elements don't block pointer events or cursor
            const allElements = placeholderNodeWithText.querySelectorAll('*');
            allElements.forEach((el)=>{
                if (el instanceof HTMLElement) {
                    el.style.pointerEvents = 'none';
                    el.style.userSelect = 'none';
                }
            });
        }
    } else if (placeholderPrompts) (0, $89b19eb21c7a1dbc$export$e2d45b5ccf27f1ce)(placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted);
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if (browser.android && browser.chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1;
    // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    if (placeholderADF && browser.chrome) {
        const fragment = document.createDocumentFragment();
        // An issue occurs with the caret where it gets bigger when it's next to a non-editable element like a decoration.
        // See: https://discuss.prosemirror.net/t/chrome-caret-cursor-larger-than-the-text-with-inlined-items/5946/2
        // Adding a zero-width space seems to fix this issue.
        fragment.appendChild(document.createTextNode((0, $fngNp.ZERO_WIDTH_SPACE)));
        fragment.appendChild(placeholderDecoration);
        return (0, $8nvEM.DecorationSet).create(editorState.doc, [
            (0, $8nvEM.Decoration).widget(pos, fragment, {
                side: 0,
                key: `placeholder ${placeholderText}`
            })
        ]);
    }
    return (0, $8nvEM.DecorationSet).create(editorState.doc, [
        (0, $8nvEM.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}



var $WnqKg = parcelRequire("WnqKg");


var $6SJ6d = parcelRequire("6SJ6d");

var $2w79Z = parcelRequire("2w79Z");




var $57Rmq = parcelRequire("57Rmq");


var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");








var $gxFDR = parcelRequire("gxFDR");

var $iO4QI = parcelRequire("iO4QI");




const $f51097f951acd32a$export$1107bf49e86ec6cc = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $gxFDR.code)(formatMessage((0, $WnqKg.placeholderTextMessages).shortEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $iO4QI.text)(' '),
                    (0, $iO4QI.text)(formatMessage((0, $WnqKg.placeholderTextMessages).shortEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });
const $f51097f951acd32a$export$45e9ce38f04dd0ca = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $iO4QI.text)(formatMessage((0, $WnqKg.placeholderTextMessages).longEmptyNodePlaceholderADFPrefix)),
                    (0, $iO4QI.text)(' '),
                    (0, $gxFDR.code)(formatMessage((0, $WnqKg.placeholderTextMessages).longEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $iO4QI.text)(' '),
                    (0, $iO4QI.text)(formatMessage((0, $WnqKg.placeholderTextMessages).longEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });



function $d1758641654a8421$export$3defeb66989079cc(editorState) {
    return (0, $f3DNZ.pluginKey).getState(editorState);
}
function $d1758641654a8421$export$5e4e0b200a219da7({ placeholderText: placeholderText, pos: pos, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph, contextPlaceholderADF: contextPlaceholderADF }) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        contextPlaceholderADF: contextPlaceholderADF,
        pos: pos ? pos : 1,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph
    };
}
const $d1758641654a8421$export$a76584009ca8faeb = ({ placeholderText: placeholderText, placeholderPrompts: placeholderPrompts, userHadTyped: userHadTyped, pos: pos, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph })=>({
        hasPlaceholder: false,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped,
        typedAndDeleted: false,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph,
        pos: pos
    });
function $d1758641654a8421$export$e919c54ee5ce8f92({ isInitial: isInitial, isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder, placeholderADF: placeholderADF, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, isPlaceholderHidden: isPlaceholderHidden, withEmptyParagraph: withEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph }) {
    const shouldHidePlaceholder = isPlaceholderHidden;
    if (shouldHidePlaceholder) return {
        ...$d1758641654a8421$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        }),
        isPlaceholderHidden: isPlaceholderHidden
    };
    if (isTypeAheadOpen?.(editorState)) return $d1758641654a8421$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
    if ((defaultPlaceholderText || placeholderPrompts || placeholderADF) && (0, $iLrhi.isEmptyDocument)(editorState.doc)) return $d1758641654a8421$export$5e4e0b200a219da7({
        placeholderText: defaultPlaceholderText,
        pos: 1,
        placeholderPrompts: placeholderPrompts,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped
    });
    if (withEmptyParagraph) {
        const { from: from, to: to, $to: $to } = editorState.selection;
        const isOnEmptyParagraphInNonEmptyDoc = (defaultPlaceholderText || placeholderADF) && withEmptyParagraph && !isInitial && !(0, $iLrhi.isEmptyDocument)(editorState.doc) && from === to && (0, $2w79Z.isEmptyParagraph)($to.parent) && (0, $2w79Z.hasDocAsParent)($to);
        if (isOnEmptyParagraphInNonEmptyDoc) {
            // If placeholder was already shown, keep it visible even without focus
            // This prevents the placeholder from disappearing when switching browser tabs
            if (showOnEmptyParagraph) return $d1758641654a8421$export$5e4e0b200a219da7({
                placeholderText: defaultPlaceholderText,
                pos: to,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: true
            });
            // Focus is required to start the timeout for showing placeholder
            if (isEditorFocused) return $d1758641654a8421$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: false,
                pos: to
            });
        }
    }
    if (isEditorFocused && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $d1758641654a8421$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode?.type && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(parentNode.type) : parentNode?.type?.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $2w79Z.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $d1758641654a8421$export$5e4e0b200a219da7({
                placeholderText: emptyLinePlaceholder,
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        const isEmptyNode = parentNode?.childCount === 1 && parentNode.firstChild?.content.size === 0 && parentNode.firstChild?.type.name === 'paragraph';
        if ((0, $a9d11cb5027ae772$export$70f0891e62fedaad).includes(parentType) && isEmptyNode) {
            const table = (0, $bjg0G.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $d1758641654a8421$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped
            });
            const isFirstCell = table?.node.firstChild?.content.firstChild === parentNode;
            if (isFirstCell) return $d1758641654a8421$export$5e4e0b200a219da7({
                placeholderText: undefined,
                contextPlaceholderADF: (0, $f51097f951acd32a$export$1107bf49e86ec6cc)(intl),
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        if ((0, $a9d11cb5027ae772$export$a754230d588f273f).includes(parentType) && isEmptyNode) return $d1758641654a8421$export$5e4e0b200a219da7({
            placeholderText: undefined,
            contextPlaceholderADF: (0, $f51097f951acd32a$export$45e9ce38f04dd0ca)(intl),
            pos: $from.pos,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
        if ((0, $a9d11cb5027ae772$export$b5dfee3212a7a6ea).includes(parentType) && isEmptyNode && !(0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true)) return $d1758641654a8421$export$5e4e0b200a219da7({
            placeholderText: intl.formatMessage((0, $WnqKg.placeholderTextMessages).sourceSyncBlockPlaceholderText),
            pos: $from.pos,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
        return $d1758641654a8421$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
    }
    if (bracketPlaceholderText && (0, $6SJ6d.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $d1758641654a8421$export$5e4e0b200a219da7({
            placeholderText: bracketHint,
            pos: $from.pos - 1,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
    }
    return $d1758641654a8421$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
}
function $d1758641654a8421$export$31fe4973d007ea9c({ placeholderState: placeholderState, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const wasEmpty = oldEditorState ? (0, $iLrhi.isEmptyDocument)(oldEditorState.doc) : true;
    const isEmpty = (0, $iLrhi.isEmptyDocument)(newEditorState.doc);
    const hasEverTyped = Boolean(placeholderState?.userHadTyped) || // Previously typed
    !wasEmpty || // Had content before
    wasEmpty && !isEmpty; // Just added content
    const justDeletedAll = hasEverTyped && isEmpty && !wasEmpty;
    const isInTypedAndDeletedState = justDeletedAll || Boolean(placeholderState?.typedAndDeleted) && isEmpty;
    // Only reset user interaction tracking when editor is cleanly empty
    const shouldResetInteraction = isEmpty && !isInTypedAndDeletedState;
    return {
        userHadTyped: shouldResetInteraction ? false : hasEverTyped,
        typedAndDeleted: isInTypedAndDeletedState
    };
}


function $b07d0697053ae84c$export$2e2bcd8739ae039(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, placeholderPrompts, withEmptyParagraph, initialIsPlaceholderHidden, placeholderADF, isRovoLLMEnabled, api) {
    if (!defaultPlaceholderText && !placeholderPrompts && !bracketPlaceholderText && !placeholderADF) return;
    let isDestroyed = false;
    let activeTypewriterTimeouts = [];
    const clearAllTypewriterTimeouts = ()=>{
        activeTypewriterTimeouts.forEach((clearFn)=>clearFn());
        activeTypewriterTimeouts = [];
    };
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $f3DNZ.pluginKey),
        state: {
            init: (_, state)=>(0, $d1758641654a8421$export$e919c54ee5ce8f92)({
                    isInitial: true,
                    isEditorFocused: Boolean(api?.focus?.sharedState.currentState()?.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: placeholderPrompts,
                    typedAndDeleted: false,
                    userHadTyped: false,
                    intl: intl,
                    withEmptyParagraph: withEmptyParagraph,
                    isPlaceholderHidden: initialIsPlaceholderHidden
                }),
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta((0, $f3DNZ.pluginKey));
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                const { userHadTyped: userHadTyped, typedAndDeleted: typedAndDeleted } = (0, $d1758641654a8421$export$31fe4973d007ea9c)({
                    placeholderState: placeholderState,
                    oldEditorState: _oldEditorState,
                    newEditorState: newEditorState
                });
                let isPlaceholderHidden = placeholderState?.isPlaceholderHidden ?? false;
                const shouldUpdatePlaceholderHidden = meta?.isPlaceholderHidden !== undefined;
                if (shouldUpdatePlaceholderHidden) isPlaceholderHidden = meta.isPlaceholderHidden;
                if (meta?.placeholderText !== undefined && withEmptyParagraph) {
                    const isCreateWithRovoOverride = !!meta.placeholderText && isRovoLLMEnabled && (0, $mW7G5.expVal)('cwr_blank_object_experiment', 'isEnabled', false);
                    // Only update defaultPlaceholderText from meta if we're not using ADF placeholder
                    // OR when the create-with-rovo experiment is active to allow intentional non-empty placeholder overrides
                    if (!placeholderADF || isCreateWithRovoOverride) defaultPlaceholderText = meta.placeholderText;
                }
                const newPlaceholderState = (0, $d1758641654a8421$export$e919c54ee5ce8f92)({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: withEmptyParagraph ? defaultPlaceholderText : meta?.placeholderText ?? placeholderState?.placeholderText ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: meta?.placeholderPrompts ?? placeholderState?.placeholderPrompts ?? placeholderPrompts,
                    typedAndDeleted: typedAndDeleted,
                    userHadTyped: userHadTyped,
                    intl: intl,
                    isPlaceholderHidden: isPlaceholderHidden,
                    withEmptyParagraph: withEmptyParagraph,
                    showOnEmptyParagraph: meta?.showOnEmptyParagraph ?? placeholderState?.showOnEmptyParagraph
                });
                // Clear timeouts when hasPlaceholder becomes false
                if (!newPlaceholderState.hasPlaceholder) clearAllTypewriterTimeouts();
                return newPlaceholderState;
            }
        },
        props: {
            decorations (editorState) {
                // @ts-ignore quick fix which needs follow up to use standard apis
                if (editorState.collabEditPlugin$ && editorState.collabEditPlugin$.isReady !== true) return;
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos, typedAndDeleted: typedAndDeleted, contextPlaceholderADF: contextPlaceholderADF, showOnEmptyParagraph: showOnEmptyParagraph } = (0, $d1758641654a8421$export$3defeb66989079cc)(editorState);
                // Decorations is still called after plugin is destroyed
                // So we need to make sure decorations is not called if plugin has been destroyed to prevent the placeholder animations' setTimeouts called infinitely
                if (isDestroyed) return;
                const compositionPluginState = api?.composition?.sharedState.currentState();
                const isShowingDiff = Boolean(api?.showDiff?.sharedState.currentState()?.isDisplayingChanges);
                if (hasPlaceholder && ((placeholderText ?? '') || placeholderPrompts || placeholderADF || contextPlaceholderADF) && pos !== undefined && !compositionPluginState?.isComposing && !isShowingDiff) {
                    const initialDelayWhenUserTypedAndDeleted = typedAndDeleted ? (0, $a9d11cb5027ae772$export$4b72a719051acd03) : 0;
                    // contextPlaceholderADF takes precedence over the global placeholderADF
                    const placeholderAdfToUse = contextPlaceholderADF || placeholderADF;
                    return (0, $0435e4618b477671$export$980ea07f18fbfea9)(editorState, placeholderText ?? '', placeholderPrompts, activeTypewriterTimeouts, pos, initialDelayWhenUserTypedAndDeleted, placeholderAdfToUse, showOnEmptyParagraph);
                }
                return;
            }
        },
        view () {
            let timeoutId;
            function startEmptyParagraphTimeout(editorView) {
                if (timeoutId) return;
                timeoutId = setTimeout(()=>{
                    timeoutId = undefined;
                    editorView.dispatch(editorView.state.tr.setMeta((0, $f3DNZ.pluginKey), {
                        showOnEmptyParagraph: true
                    }));
                }, (0, $f3DNZ.EMPTY_PARAGRAPH_TIMEOUT_DELAY));
            }
            function destroyEmptyParagraphTimeout() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            }
            return {
                update (editorView, prevState) {
                    if (withEmptyParagraph) {
                        const prevPluginState = (0, $d1758641654a8421$export$3defeb66989079cc)(prevState);
                        const newPluginState = (0, $d1758641654a8421$export$3defeb66989079cc)(editorView.state);
                        // user start typing after move to an empty paragraph, clear timeout
                        if (!newPluginState.canShowOnEmptyParagraph && timeoutId) destroyEmptyParagraphTimeout();
                        else if (prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && newPluginState.pos !== prevPluginState.pos) {
                            editorView.dispatch(editorView.state.tr.setMeta((0, $f3DNZ.pluginKey), {
                                showOnEmptyParagraph: false
                            }));
                            destroyEmptyParagraphTimeout();
                            startEmptyParagraphTimeout(editorView);
                        } else if (!prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && !newPluginState.showOnEmptyParagraph && !timeoutId) startEmptyParagraphTimeout(editorView);
                    }
                },
                destroy () {
                    clearAllTypewriterTimeouts();
                    destroyEmptyParagraphTimeout();
                    isDestroyed = true;
                }
            };
        }
    });
}


const $456c3af270cd58e2$export$d5dda3c025c51c47 = 2000; // Delay before showing placeholder on empty paragraph
const $456c3af270cd58e2$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('placeholderPlugin');
const $456c3af270cd58e2$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options?.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($456c3af270cd58e2$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                },
            setAnimatingPlaceholderPrompts: (placeholderPrompts)=>({ tr: tr })=>{
                    return tr.setMeta($456c3af270cd58e2$export$18d4026d1ea86bb1, {
                        placeholderPrompts: placeholderPrompts
                    });
                },
            setPlaceholderHidden: (isPlaceholderHidden)=>({ tr: tr })=>{
                    return tr.setMeta($456c3af270cd58e2$export$18d4026d1ea86bb1, {
                        isPlaceholderHidden: isPlaceholderHidden
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>(0, $b07d0697053ae84c$export$2e2bcd8739ae039)(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, options && options.placeholderPrompts, options?.withEmptyParagraph, options?.isPlaceholderHidden, options && options.placeholderADF, options?.isRovoLLMEnabled, api)
                }
            ];
        },
        contentComponent: (params)=>{
            if ((0, $4iudd.isSSR)()) return null;
             // If loading spinner is explicitly disabled (e.g., for DiffEditor/version history), skip
            if (options?.enableLoadingSpinner === false) return null;
            const doc = params.editorView?.state.doc; // @ts-ignore fix which needs follow up to use standard apis
            const collabEditPluginState = params.editorView?.state?.collabEditPlugin$;
            if (collabEditPluginState && collabEditPluginState.isReady !== true) {
                if (doc && !(0, $iLrhi.isEmptyDocument)(doc)) // If we have a document, and it's not empty - we should not show a loading component
                return null;
                 // In this scenario
                // - the collab plugin exists - but we don't have a "initial/placeholder" document
                // - and the collab plugin is not yet ready
                // So we show a placeholder spinner to indicate the content is still loading
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $456c3af270cd58e2$var$spinnerContainerStyles.spinnerContainer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        interactionName: "live-pages-loading-spinner",
                        size: "medium"
                    })
                });
            }
            return null;
        }
    };
};
const $456c3af270cd58e2$var$spinnerContainerStyles = {
    spinnerContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _39xV02N91d"
};
module.exports["EMPTY_PARAGRAPH_TIMEOUT_DELAY"] = $456c3af270cd58e2$export$d5dda3c025c51c47;
module.exports["pluginKey"] = $456c3af270cd58e2$export$18d4026d1ea86bb1;
module.exports["placeholderPlugin"] = $456c3af270cd58e2$export$ecbe4cfe6671ba88;

});

parcelRegister("hBGxo", function(module, exports) {
const $5eb65f2e385ca41a$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };



var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $jkcNT = parcelRequire("jkcNT");

const $7c5a8b657f76abf1$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) configuration = $7c5a8b657f76abf1$var$toolbarConfigurationV2(true);
    else {
        const shouldShowFindGroup = !!contextualFormattingEnabled;
        if (componentRegistry.has('trackChanges')) configuration = $7c5a8b657f76abf1$var$toolbarConfigurationV3(shouldShowFindGroup);
        else configuration = $7c5a8b657f76abf1$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $7c5a8b657f76abf1$var$trackChangesGroup = [
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedo') || componentRegistry.has('trackChanges')
    },
    {
        name: 'undoRedoPlugin',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    },
    {
        name: 'trackChanges',
        enabled: (componentRegistry)=>componentRegistry.has('trackChanges')
    }
];
const $7c5a8b657f76abf1$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $7c5a8b657f76abf1$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $7c5a8b657f76abf1$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $7c5a8b657f76abf1$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $7c5a8b657f76abf1$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $7c5a8b657f76abf1$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $7c5a8b657f76abf1$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $7c5a8b657f76abf1$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $7c5a8b657f76abf1$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $7c5a8b657f76abf1$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7c5a8b657f76abf1$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7c5a8b657f76abf1$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $7c5a8b657f76abf1$var$toolbarConfigurationV3 = (shouldShowFindGroup)=>[
        ...$7c5a8b657f76abf1$var$spellCheckGroup,
        ...$7c5a8b657f76abf1$var$blockTypeGroup,
        ...$7c5a8b657f76abf1$var$textFormattingGroup,
        ...$7c5a8b657f76abf1$var$alignmentGroup,
        ...$7c5a8b657f76abf1$var$textColorGroup,
        ...$7c5a8b657f76abf1$var$listFormattingGroup,
        ...$7c5a8b657f76abf1$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7c5a8b657f76abf1$var$others : $7c5a8b657f76abf1$var$othersGroupNoFind,
        ...$7c5a8b657f76abf1$var$trackChangesGroup
    ];
const $7c5a8b657f76abf1$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$7c5a8b657f76abf1$var$undoRedoGroup,
        ...$7c5a8b657f76abf1$var$spellCheckGroup,
        ...$7c5a8b657f76abf1$var$blockTypeGroup,
        ...$7c5a8b657f76abf1$var$textFormattingGroup,
        ...$7c5a8b657f76abf1$var$alignmentGroup,
        ...$7c5a8b657f76abf1$var$textColorGroup,
        ...$7c5a8b657f76abf1$var$listFormattingGroup,
        ...$7c5a8b657f76abf1$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7c5a8b657f76abf1$var$others : $7c5a8b657f76abf1$var$othersGroupNoFind
    ];
const $7c5a8b657f76abf1$var$pinToolbar = [
    {
        name: 'pinToolbar'
    }
];
const $7c5a8b657f76abf1$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowFindGroup = false)=>[
        ...$7c5a8b657f76abf1$var$blockTypeGroup,
        ...$7c5a8b657f76abf1$var$textFormattingGroup,
        ...$7c5a8b657f76abf1$var$textColorGroup,
        ...$7c5a8b657f76abf1$var$alignmentGroup,
        ...$7c5a8b657f76abf1$var$listFormattingGroup,
        ...$7c5a8b657f76abf1$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $7c5a8b657f76abf1$var$insertBlockGroup : [],
        {
            name: 'selectionExtension'
        },
        ...$7c5a8b657f76abf1$var$pinToolbar,
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $7c5a8b657f76abf1$var$findGroup : []
    ];


const $57bd5fa7d757048c$export$36f60c8b3eb879ae = new (0, $kCECX.PluginKey)('primaryToolbar');
const $57bd5fa7d757048c$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $57bd5fa7d757048c$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $7c5a8b657f76abf1$export$a758406ca53b86a5)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");


var $9iFhC = parcelRequire("9iFhC");

var $0e2839ca2ba4a0cb$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $9iFhC.wrapperStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $9iFhC.separatorStyles)
    }));


const $eb85522585f4f282$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $0e2839ca2ba4a0cb$export$2e2bcd8739ae039));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $5eb65f2e385ca41a$export$d74092cddf07c0aa)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $57bd5fa7d757048c$export$ae829ec7b2625219)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config?.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $57bd5fa7d757048c$export$36f60c8b3eb879ae).getState(editorState);
        }
    };
};
module.exports["primaryToolbarPlugin"] = $eb85522585f4f282$export$ad7799fd22a76abd;

});

parcelRegister("fb3SZ", function(module, exports) {

var $2ROjz = parcelRequire("2ROjz");

var $3rWk6 = parcelRequire("3rWk6");

const $f0f737bd8364f431$export$ebd99cdb6a61129e = (api)=>(props)=>{
        const selection = props?.selection ?? api?.selection.sharedState?.currentState()?.selection;
        return (0, $2ROjz.getFragmentsFromSelection)(selection);
    };
const $f0f737bd8364f431$export$27a1b30a70c1f80d = (api)=>(props)=>{
        let selection = props?.selection ?? api?.selection.sharedState?.currentState()?.selection;
        if (selection?.empty) // If we have an empty selection the current state might not be correct
        // We have a hack here to retrieve the current selection - but not dispatch a transaction
        api?.core.actions.execute(({ tr: tr })=>{
            selection = tr.selection;
            return null;
        });
        return (0, $3rWk6.getLocalIdsFromSelection)(selection);
    };



var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");




const $9716a906a094616a$export$e6805678cce429a4 = new (0, $kCECX.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');


const $c1d02771e872029d$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $9716a906a094616a$export$e6805678cce429a4),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                    // or mouse down doesn't trigger
                    if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                        mouseDownElement = null;
                        return;
                    }
                    // reset mouse down element after mouse up event
                    // so that we can detect the next mouse down event is triggered right after mouse up event or not
                    mouseDownElement = null;
                    // terminate early if mouse up event is not fired on inline node
                    if (!$c1d02771e872029d$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $kCECX.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $c1d02771e872029d$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};


/* eslint-disable import/no-extraneous-dependencies */ 
var $4EksL = parcelRequire("4EksL");

var $5X54F = parcelRequire("5X54F");

var $1JP3v = parcelRequire("1JP3v");

var $eaLat = parcelRequire("eaLat");


var $2w79Z = parcelRequire("2w79Z");




/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




const $54b37cf8a78f6f24$export$e530ba00b008a680 = new (0, $kCECX.PluginKey)('selection');
var $54b37cf8a78f6f24$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});


var $cbcc2720fcc3bfaa$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});



var $cI8RZ = parcelRequire("cI8RZ");





var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");



function $431100af738a232a$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $cbcc2720fcc3bfaa$export$ab4e2275d2998c63).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $cbcc2720fcc3bfaa$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}





var $iscRo = parcelRequire("iscRo");




var $gPewy = parcelRequire("gPewy");


var $57Rmq = parcelRequire("57Rmq");





var $bjg0G = parcelRequire("bjg0G");





var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $jkcNT = parcelRequire("jkcNT");





const $5923bb9669037871$var$hideCursorWidgetStyles = `
	position: absolute;
	pointer-events: none;
	width: 0;
	height: 0;
`;
const $5923bb9669037871$var$createHideCursorWidget = ()=>{
    const span = document.createElement('span');
    span.className = 'ProseMirror-hide-cursor';
    span.setAttribute('style', $5923bb9669037871$var$hideCursorWidgetStyles);
    return span;
};
const $5923bb9669037871$export$22f5d232402cb4b = ()=>{
    return (0, $8nvEM.Decoration).widget(0, $5923bb9669037871$var$createHideCursorWidget, {
        key: 'hide-cursor-decoration',
        side: -1
    });
};


const $4cbb9f67e8db09a7$export$968abecb43309c32 = (tr, manualSelection, hideCursor, blockSelection)=>{
    let selection = tr.selection;
    const decorations = [];
    if (hideCursor) decorations.push((0, $5923bb9669037871$export$22f5d232402cb4b)());
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        decorations.push((0, $8nvEM.Decoration).node(selection.from, selection.to, {
            class: (0, $7Y8M5.akEditorSelectedNodeClassName)
        }));
        return (0, $8nvEM.DecorationSet).create(tr.doc, decorations);
    }
    if (selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $kCECX.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        // Only apply node decorations when there is an active block selection.
        // When there is no block selection, text selections should use native browser selection appearance.
        if (!(0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        }) || blockSelection) {
            const selectionDecorations = $4cbb9f67e8db09a7$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
                return (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                    class: (0, $7Y8M5.akEditorSelectedNodeClassName)
                });
            });
            decorations.push(...selectionDecorations);
        }
        return (0, $8nvEM.DecorationSet).create(tr.doc, decorations);
    }
    return decorations.length > 0 ? (0, $8nvEM.DecorationSet).create(tr.doc, decorations) : (0, $8nvEM.DecorationSet).empty;
};
const $4cbb9f67e8db09a7$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $4cbb9f67e8db09a7$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const nodeTypeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(node.type) : node.type.name;
            const isTopLevelNodeThatHasSelectionStyles = $4cbb9f67e8db09a7$var$topLevelBlockNodesThatHaveSelectionStyles.includes(nodeTypeName);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $4cbb9f67e8db09a7$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $54b37cf8a78f6f24$export$e530ba00b008a680).getState(oldEditorState);
    const newPluginState = (0, $54b37cf8a78f6f24$export$e530ba00b008a680).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $kCECX.NodeSelection) && newSelection instanceof (0, $kCECX.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $kCECX.TextSelection) && newSelection instanceof (0, $kCECX.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $4cbb9f67e8db09a7$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $kCECX.NodeSelection).isSelectable(node));
const $4cbb9f67e8db09a7$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $2w79Z.isEmptyParagraph)(node) || (0, $kCECX.NodeSelection).isSelectable(node)));
const $4cbb9f67e8db09a7$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $bjg0G.findParentNode)((node)=>{
        const isSelectable = $4cbb9f67e8db09a7$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $5X54F.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $4cbb9f67e8db09a7$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $4cbb9f67e8db09a7$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $kCECX.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($4cbb9f67e8db09a7$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $5X54F.isIgnored)(node)) return;
        }
        /**
     * Stick to the default left selection behaviour,
     * useful for mediaSingleWithCaption
     */ if (selectionBefore instanceof (0, $kCECX.NodeSelection) && (0, $kCECX.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $4cbb9f67e8db09a7$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $kCECX.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($4cbb9f67e8db09a7$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $5X54F.isIgnored)(node)) return;
        }
    }
};
const $4cbb9f67e8db09a7$export$12f3aca2cb5b5ae9 = (parent)=>(0, $bjg0G.flatten)(parent).find((child)=>$4cbb9f67e8db09a7$export$e6eb31f83412b327(child.node) || !(0, $5X54F.isIgnored)(child.node));
const $4cbb9f67e8db09a7$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($4cbb9f67e8db09a7$export$e6eb31f83412b327(node) || !(0, $5X54F.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $4cbb9f67e8db09a7$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $iscRo.isSelectionAtStartOfNode)($pos, $4cbb9f67e8db09a7$export$15e7624ccd1acbba(selection)?.node);
const $4cbb9f67e8db09a7$export$1ab0c837d3abb951 = ($pos, selection)=>{
    // If the current position is at the end of its parent node's content.
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    // If at the root or parent is selectable, we're at the end
    if ($pos.depth === 0 || (0, $kCECX.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    // Handle lists: if in a list inside container and not at the end, return false
    if ((0, $bjg0G.hasParentNode)((0, $gPewy.isListItemNode))(selection) && $4cbb9f67e8db09a7$export$7eb6f464328bf47e($pos, selection)) return false;
    // Handle layout columns: if another node follows, not at end
    if ($4cbb9f67e8db09a7$export$d2d208886cf1a82d($pos)) return false;
    // Default: if at end of parent's parent
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};
const $4cbb9f67e8db09a7$export$7eb6f464328bf47e = ($pos, selection)=>{
    const isInContainerNode = (0, $bjg0G.hasParentNode)($4cbb9f67e8db09a7$export$5f94d2e4ba42a5c7)(selection);
    if (!isInContainerNode) return false;
    const parentList = (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $gPewy.isListItemNode));
    if (!parentList) return false;
    const $parentListPos = $pos.doc.resolve(parentList.pos);
    const topLevelList = $4cbb9f67e8db09a7$export$b0ac99e4524eec5a($pos);
    if (!topLevelList) return false;
    const $afterTopLevelList = $pos.doc.resolve(topLevelList.pos + topLevelList.node.nodeSize);
    const nodeAfterTopLevelList = $afterTopLevelList.nodeAfter;
    const grandParentList = (0, $bjg0G.findParentNodeClosestToPos)($pos.doc.resolve($parentListPos.before()), (0, $gPewy.isListItemNode));
    const grandParentListPos = grandParentList ? $pos.doc.resolve(grandParentList.pos) : undefined;
    const isLastListItemInParent = // Check if the current list item is the last child in its parent list
    $parentListPos.index() === $parentListPos.parent.childCount - 1 && // Check if there is no grandparent list, or if the grandparent list item is also the last child in its parent
    (!grandParentList || grandParentListPos && grandParentListPos.index() === grandParentListPos.parent.childCount - 1);
    if (!isLastListItemInParent || nodeAfterTopLevelList) return true;
    return false;
};
const $4cbb9f67e8db09a7$export$5f94d2e4ba42a5c7 = (node)=>{
    const { layoutColumn: layoutColumn, panel: panel, panel_c1: panel_c1, expand: expand } = node?.type?.schema?.nodes || {};
    const containerNodes = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        expand,
        layoutColumn
    ] : [
        panel,
        expand,
        layoutColumn
    ];
    return Boolean(node && node.type && containerNodes.includes(node.type));
};
const $4cbb9f67e8db09a7$export$b0ac99e4524eec5a = (pos)=>{
    const { bulletList: bulletList, orderedList: orderedList } = pos.doc.type.schema.nodes;
    let currentDepth = pos.depth;
    let topLevelList;
    while(currentDepth > 0){
        const node = pos.node(currentDepth);
        if ([
            bulletList,
            orderedList
        ].includes(node.type)) topLevelList = {
            node: node,
            pos: pos.before(currentDepth)
        };
        currentDepth--;
    }
    return topLevelList;
};
const $4cbb9f67e8db09a7$export$d2d208886cf1a82d = ($pos)=>{
    const layoutColumnParent = (0, $bjg0G.findParentNodeClosestToPos)($pos, $4cbb9f67e8db09a7$export$c09dbe4edab814a2);
    if (!layoutColumnParent) return false;
    const panelOrExpandParent = (0, $bjg0G.findParentNodeClosestToPos)($pos, $4cbb9f67e8db09a7$export$3180f8c1df4f8d41);
    if (panelOrExpandParent && panelOrExpandParent.pos > layoutColumnParent.pos) return false;
    const afterPos = layoutColumnParent.pos + layoutColumnParent.node.nodeSize;
    const $after = $pos.doc.resolve(afterPos);
    return Boolean($after.nodeAfter);
};
const $4cbb9f67e8db09a7$export$c09dbe4edab814a2 = (node)=>{
    const { layoutColumn: layoutColumn } = node?.type?.schema?.nodes || {};
    return Boolean(node && node.type && node.type === layoutColumn);
};
const $4cbb9f67e8db09a7$export$3180f8c1df4f8d41 = (node)=>{
    const { panel: panel, panel_c1: panel_c1, expand: expand } = node?.type?.schema?.nodes || {};
    return Boolean(node && node.type && (node.type === panel || (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && node.type === panel_c1 || node.type === expand));
};


const $12e0332593616ffe$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $4cbb9f67e8db09a7$export$968abecb43309c32)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $8nvEM.DecorationSet).empty
        };
    }
};
const $12e0332593616ffe$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $kCECX.NodeSelection) && (0, $4cbb9f67e8db09a7$export$be9646888fa9d884)(tr.selection.node) || tr.selection instanceof (0, $8HW7o.CellSelection)) && !tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const $12e0332593616ffe$var$dest = (0, $cI8RZ.pluginFactory)((0, $54b37cf8a78f6f24$export$e530ba00b008a680), (0, $431100af738a232a$export$1650419e431d3ba3), {
    onDocChanged: $12e0332593616ffe$var$handleDocChanged,
    onSelectionChanged: $12e0332593616ffe$var$handleSelectionChanged
});
const $12e0332593616ffe$export$8d4021544bdece00 = $12e0332593616ffe$var$dest.createCommand;
const $12e0332593616ffe$export$f05434c51e3762e = $12e0332593616ffe$var$dest.getPluginState;
const $12e0332593616ffe$export$656c7661095efe2e = $12e0332593616ffe$var$dest.createPluginState;



const $7578836c662e6183$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            type: (0, $cbcc2720fcc3bfaa$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $7578836c662e6183$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $12e0332593616ffe$export$8d4021544bdece00)({
        type: (0, $cbcc2720fcc3bfaa$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $7578836c662e6183$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $7578836c662e6183$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $4EksL.GapCursorSelection)) return $7578836c662e6183$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $kCECX.NodeSelection)) return $7578836c662e6183$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $kCECX.TextSelection)) return $7578836c662e6183$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $7578836c662e6183$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $4EksL.GapCursorSelection)) return $7578836c662e6183$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $kCECX.NodeSelection)) return $7578836c662e6183$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $kCECX.TextSelection)) return $7578836c662e6183$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $7578836c662e6183$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $eaLat.Side).LEFT) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$f64170c1c72ca928)($to, state.doc);
            if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).Start, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $eaLat.Side).RIGHT && (0, $4cbb9f67e8db09a7$export$1ab0c837d3abb951)($from, selection)) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $12e0332593616ffe$export$f05434c51e3762e)(state);
        if (side === (0, $eaLat.Side).RIGHT) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$5a13616ef7dc6dd)($from, state.doc);
            if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $eaLat.Side).LEFT && (0, $4cbb9f67e8db09a7$export$f80a5aec143de6c6)($from, selection)) {
            if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $4cbb9f67e8db09a7$export$5a13616ef7dc6dd)($parent, state.doc);
                    if (selectableNode && (0, $5X54F.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $7578836c662e6183$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $4cbb9f67e8db09a7$export$15e7624ccd1acbba)(selection);
                if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).Start, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $7578836c662e6183$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $12e0332593616ffe$export$f05434c51e3762e)(state);
        if (node.isAtom) {
            if ((0, $4cbb9f67e8db09a7$export$1ab0c837d3abb951)($to, selection) && (node.isInline || (0, $5X54F.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $7578836c662e6183$var$findAndSetTextSelection((0, $1JP3v.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $7578836c662e6183$var$setSelectionInsideAtNodeStart((0, $1JP3v.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $5X54F.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End)) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$f64170c1c72ca928)($to, state.doc);
            if (selectableNode && (0, $5X54F.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).Start, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $12e0332593616ffe$export$f05434c51e3762e)(state);
        if (node.isAtom) {
            if ((0, $4cbb9f67e8db09a7$export$f80a5aec143de6c6)($from, selection) && (node.isInline || (0, $5X54F.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $7578836c662e6183$var$findAndSetTextSelection((0, $1JP3v.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $7578836c662e6183$export$7c9ae5d21795cde4((0, $1JP3v.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $7578836c662e6183$var$setSelectionInsideAtNodeStart((0, $1JP3v.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $5X54F.isIgnored)(node) && selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $4cbb9f67e8db09a7$export$5a13616ef7dc6dd)($from, state.doc);
            if (selectableNode && (0, $5X54F.isIgnored)(selectableNode.node)) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $4cbb9f67e8db09a7$export$1ab0c837d3abb951)(selection.$to, selection)) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $12e0332593616ffe$export$f05434c51e3762e)(state);
        if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Before) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$5a13616ef7dc6dd)(selection.$from, state.doc);
            if (selectableNode && (0, $5X54F.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).End, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $7578836c662e6183$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $4cbb9f67e8db09a7$export$f80a5aec143de6c6)(selection.$from, selection)) {
            const selectableNode = (0, $4cbb9f67e8db09a7$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $7578836c662e6183$export$56a7f03ce3f93e52((0, $1JP3v.RelativeSelectionPos).Start, (0, $kCECX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $kCECX.Selection).findFrom($pos, dir, true);
        if (sel) return $7578836c662e6183$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $7578836c662e6183$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $2w79Z.isNodeEmpty)(node)) return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).After)(state, dispatch);
        const selectableNode = (0, $4cbb9f67e8db09a7$export$12f3aca2cb5b5ae9)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $5X54F.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).Before)(state, dispatch);
            else if ((0, $2w79Z.isEmptyParagraph)(childNode)) return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).Before)(state, dispatch);
            else if (!(0, $5X54F.isIgnored)(node)) return $7578836c662e6183$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $4EksL.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $eaLat.Side).LEFT))(state, dispatch);
            else if ((0, $4cbb9f67e8db09a7$export$be9646888fa9d884)(node)) return $7578836c662e6183$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $kCECX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $7578836c662e6183$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $2w79Z.isNodeEmpty)(node)) return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).Before)(state, dispatch);
        const selectableNode = (0, $4cbb9f67e8db09a7$export$b5a7c30cdb2d437f)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $5X54F.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).After)(state, dispatch);
            else if ((0, $2w79Z.isEmptyParagraph)(childNode)) return $7578836c662e6183$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $54b37cf8a78f6f24$export$5c80dd1df5708938).After)(state, dispatch);
            else if (!(0, $5X54F.isIgnored)(node)) return $7578836c662e6183$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $4EksL.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $eaLat.Side).RIGHT))(state, dispatch);
            else if ((0, $4cbb9f67e8db09a7$export$be9646888fa9d884)(node)) return $7578836c662e6183$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $kCECX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };



var $ldqjS = parcelRequire("ldqjS");





var $iUNgd = parcelRequire("iUNgd");


var $44cyU = parcelRequire("44cyU");


var $c2E4R = parcelRequire("c2E4R");

var $jzePg = parcelRequire("jzePg");



var $88vX6 = parcelRequire("88vX6");




var $lgdIY = parcelRequire("lgdIY");

var $7eIIL = parcelRequire("7eIIL");

var $9gS7U = parcelRequire("9gS7U");


var $fngNp = parcelRequire("fngNp");










const $2eb722959b834642$export$21af267ac39e2110 = new (0, $kCECX.PluginKey)('gapCursorPlugin');


var $ab69803f3d2f2a14$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $ab69803f3d2f2a14$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $ab69803f3d2f2a14$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}



var $4G6PK = parcelRequire("4G6PK");





var $bYPHE = parcelRequire("bYPHE");

var $68mo7 = parcelRequire("68mo7");




const $7880748a1a5330a3$export$2b745dec73894c8a = (side)=>side === (0, $eaLat.Side).LEFT;
function $7880748a1a5330a3$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $7880748a1a5330a3$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $7880748a1a5330a3$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $7880748a1a5330a3$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $4G6PK.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $bYPHE.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $68mo7.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $7880748a1a5330a3$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};


const $ec027e8702a7ba36$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).UP:
            if ((0, $c2E4R.atTheBeginningOfDoc)(state)) return false;
            return (0, $9gS7U.isPositionNearTableRow)($pos, schema, 'before') || (0, $7880748a1a5330a3$export$84353379d6171bb9)(doc, schema, $pos, -1) || (0, $7eIIL.isNodeBeforeMediaNode)($pos, state);
        case (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).DOWN:
            return(// end of a paragraph
            (0, $jzePg.atTheEndOfDoc)(state) || (0, $7880748a1a5330a3$export$84353379d6171bb9)(doc, schema, $pos, 1) || (0, $9gS7U.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $ec027e8702a7ba36$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $4EksL.GapCursorSelection) && dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).UP && selection.$from.nodeBefore && (0, $lgdIY.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $4EksL.GapCursorSelection) && dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $ec027e8702a7ba36$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).UP && selection.$from.nodeBefore && (0, $lgdIY.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $bjg0G.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $eaLat.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $eaLat.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $ec027e8702a7ba36$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $kCECX.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($ec027e8702a7ba36$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $kCECX.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).UP && !(0, $c2E4R.atTheBeginningOfDoc)(state) && !(0, $7eIIL.isNodeBeforeMediaNode)($pos, state) || dir === (0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($ec027e8702a7ba36$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $ec027e8702a7ba36$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $4EksL.GapCursorSelection) && // next node allow gap cursor position
        (0, $88vX6.isValidTargetNode)((0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) && selection.side === (0, $eaLat.Side).LEFT || (0, $ab69803f3d2f2a14$export$9439bc4ba99faca1)(dir) && selection.side === (0, $eaLat.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $4EksL.GapCursorSelection)($pos, selection.side === (0, $eaLat.Side).RIGHT ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $bjg0G.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $fngNp.ZERO_WIDTH_SPACE)) return false;
        }
        const nextSelection = (0, $4EksL.GapCursorSelection).findFrom($pos, (0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $88vX6.isValidTargetNode)((0, $ab69803f3d2f2a14$export$9439bc4ba99faca1)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $4EksL.GapCursorSelection)(nextSelection.$from, (0, $ab69803f3d2f2a14$export$9439bc4ba99faca1)(dir) ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $ec027e8702a7ba36$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $4EksL.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $ab69803f3d2f2a14$export$4d894a9a195acd59)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $4EksL.GapCursorSelection)($anchor, (0, $eaLat.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $bjg0G.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $ec027e8702a7ba36$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $eaLat.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT;
            let position;
            if (side === (0, $eaLat.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $ec027e8702a7ba36$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $ec027e8702a7ba36$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $eaLat.Side).LEFT ? (0, $88vX6.isValidTargetNode)($pos.nodeAfter) : (0, $88vX6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $4EksL.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $4EksL.GapCursorSelection)) tr.setSelection((0, $kCECX.Selection).near($pos));
        else tr.setSelection(new (0, $4EksL.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $kCECX.Selection).findFrom($pos, cursorCoords.side === (0, $eaLat.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $ec027e8702a7ba36$export$ddeed8e54d88a7b0 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $ec027e8702a7ba36$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $ec027e8702a7ba36$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $2eb722959b834642$export$21af267ac39e2110).get(state));
};



function $c93c2946bb3620b9$export$2e2bcd8739ae039() {
    const map = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $4EksL.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $iUNgd.createParagraphNear)(state, dispatch);
    }, map);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ec027e8702a7ba36$export$f2120bbfa5450bd2)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ec027e8702a7ba36$export$f2120bbfa5450bd2)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ec027e8702a7ba36$export$f2120bbfa5450bd2)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ec027e8702a7ba36$export$f2120bbfa5450bd2)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.backspace).common, (0, $ec027e8702a7ba36$export$b05da9e94a08038f)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.deleteKey).common, (0, $ec027e8702a7ba36$export$b05da9e94a08038f)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).FORWARD), map);
    return (0, $44cyU.keymap)(map);
}








var $Lh4Gi = parcelRequire("Lh4Gi");



























/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $f65777e6ba648e4a$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $f65777e6ba648e4a$var$getNestedSelector = (key)=>{
    if (key === 'multiBodiedExtensionView-content-wrap' && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '.multiBodiedExtension--wrapper';
    return $f65777e6ba648e4a$var$nestedCases[key];
};
const $f65777e6ba648e4a$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($f65777e6ba648e4a$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $f65777e6ba648e4a$var$getNestedSelector(foundKey);
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $f65777e6ba648e4a$var$measureHeight = (style)=>{
    return $f65777e6ba648e4a$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $f65777e6ba648e4a$var$measureWidth = (style)=>{
    return $f65777e6ba648e4a$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $f65777e6ba648e4a$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $f65777e6ba648e4a$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $7880748a1a5330a3$export$2b745dec73894c8a)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
/**
 * For nested elements (e.g. .extension-container inside
 * .extensionView-content-wrap), use getBoundingClientRect to compute
 * the exact pixel offset between the gap cursor's position in the
 * flow and the inner element's visual position.
 */ const $f65777e6ba648e4a$var$positionFromRect = (gapCursor, cursorParent, nestedElement)=>{
    const cursorRect = cursorParent.getBoundingClientRect();
    const innerRect = nestedElement.getBoundingClientRect();
    gapCursor.style.marginTop = `${innerRect.top - cursorRect.top}px`;
    gapCursor.style.left = `${innerRect.left - cursorRect.left}px`;
    gapCursor.style.width = `${innerRect.width}px`;
};
const $f65777e6ba648e4a$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $eaLat.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (element.firstChild) {
        const gapCursor = element.firstChild;
        // The DOM from view.nodeDOM() might be stale after paste
        // Use requestAnimationFrame to wait for DOM to update, then fetch and measure
        requestAnimationFrame(()=>{
            const nodeStart = getPos();
            if (nodeStart === undefined) return;
            // if selection has changed, we no longer need to compute the styles for the gapcursor
            if (!view.state.selection.eq(selection)) return;
            const dom = view.nodeDOM(nodeStart);
            if (dom instanceof HTMLElement) {
                // For native embed extensions only, use getBoundingClientRect
                // to position the gap cursor precisely relative to the inner
                // .extension-container
                if (dom.classList.contains('extensionView-content-wrap')) {
                    const nativeEmbed = dom.querySelector('.extension-container:has([data-native-embed-alignment])');
                    if (nativeEmbed) {
                        const nativeEmbedStyle = window.getComputedStyle(nativeEmbed);
                        gapCursor.style.height = `${$f65777e6ba648e4a$var$measureHeight(nativeEmbedStyle)}px`;
                        $f65777e6ba648e4a$var$positionFromRect(gapCursor, element, nativeEmbed);
                        return;
                    }
                }
                const style = $f65777e6ba648e4a$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
                gapCursor.style.height = `${$f65777e6ba648e4a$var$measureHeight(style)}px`;
                const layoutMode = node && (0, $7880748a1a5330a3$export$698eab35981fecbc)(node);
                if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
                const isNestedTable = node?.type.name === 'table' && selection.$to.depth > 0;
                if (layoutMode && !isNestedTable) {
                    gapCursor.setAttribute('layout', layoutMode);
                    const breakoutModeStyle = (0, $7880748a1a5330a3$export$b5b7287d8577df27)(dom, node, style);
                    gapCursor.style.width = `${$f65777e6ba648e4a$var$measureWidth(breakoutModeStyle)}px`;
                } else $f65777e6ba648e4a$var$mutateElementStyle(gapCursor, style, selection.side);
            }
        });
    }
    return element;
};


const $cfdd352226c18bda$var$plugin = new (0, $kpCD8.SafePlugin)({
    key: (0, $2eb722959b834642$export$21af267ac39e2110),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true,
                hideCursor: false
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $2eb722959b834642$export$21af267ac39e2110));
            const selectionMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
            const selectionIsGapCursor = newState.selection instanceof (0, $4EksL.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true,
                // track hideCursor state from selection plugin
                hideCursor: selectionMeta?.hideCursor ?? pluginState.hideCursor
            };
        }
    },
    view: (view)=>{
        /**
		 * If the selection is at the beginning of a document and is a NodeSelection,
		 * convert to a GapCursor selection. This is to stop users accidentally replacing
		 * the first node of a document by accident.
		 */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $kCECX.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(view.state.doc.resolve(0), (0, $eaLat.Side).LEFT)));
        });
        return {};
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor, hideCursor: hideCursor } = (0, $2eb722959b834642$export$21af267ac39e2110).getState(editorState);
            if (selection instanceof (0, $4EksL.GapCursorSelection) && displayGapCursor && !hideCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $eaLat.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $bjg0G.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $7880748a1a5330a3$export$698eab35981fecbc)(node);
                return (0, $8nvEM.DecorationSet).create(doc, [
                    (0, $8nvEM.Decoration).widget(position, (0, $f65777e6ba648e4a$export$289411c5a7970646), {
                        key: `${(0, $4EksL.JSON_ID)}-${side}-${layoutMode}`,
                        // position === 0: if gap cursor at start of document, render it on the left side of the selection to enable pasting (otherwise Chrome doesn't pick up the paste event)
                        side: layoutMode || position === 0 ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $8HW7o.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $4EksL.GapCursorSelection).valid($head)) return new (0, $4EksL.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $7880748a1a5330a3$export$e5da7366668fb130)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $eaLat.Side).RIGHT : (0, $eaLat.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $Lh4Gi.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $Lh4Gi.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
			 * Android composition events aren't handled well by Prosemirror
			 * We've added a couple of beforeinput hooks to help PM out when trying to delete
			 * certain nodes. We can remove these when PM has better composition support.
			 * @see https://github.com/ProseMirror/prosemirror/issues/543
			 */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $4EksL.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $ec027e8702a7ba36$export$b05da9e94a08038f)((0, $ab69803f3d2f2a14$export$cacd6541cfeeb6c1).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $cfdd352226c18bda$export$2e2bcd8739ae039 = $cfdd352226c18bda$var$plugin;










function $38cb46acc33bdb7a$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveRight).common, (0, $7578836c662e6183$export$680a8d7c28b0860), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveLeft).common, (0, $7578836c662e6183$export$3ff8c533d254ed7c), list);
    return (0, $44cyU.keymap)(list);
}
var $38cb46acc33bdb7a$export$2e2bcd8739ae039 = $38cb46acc33bdb7a$var$keymapPlugin;











const $6874c4667cdedbaf$export$220fecd6a5c51ffb = new (0, $kCECX.PluginKey)('markBoundaryCursorPlugin');





const $d92496b7b6d07a32$var$containerStyle = `
	position: relative;
`;
const $d92496b7b6d07a32$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #292A2E)"};
`;
const $d92496b7b6d07a32$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $d92496b7b6d07a32$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $d92496b7b6d07a32$var$caretStyle);
    caret.animate?.([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $d92496b7b6d07a32$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $8nvEM.Decoration).widget(pos, $d92496b7b6d07a32$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};



var $b9BvQ = parcelRequire("b9BvQ");


var $aPdNQ = parcelRequire("aPdNQ");

var $ff5a117367d52834$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});



function $c1458987f0ac1d68$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $ff5a117367d52834$export$6705e1762430d43f).Right;
    return (0, $ff5a117367d52834$export$6705e1762430d43f).None;
}


function $7f3606a1fe9d79f6$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $b9BvQ.isTextSelection)(selection) || !selection.empty) return (0, $ff5a117367d52834$export$6705e1762430d43f).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $aPdNQ.Mark).sameSet(leftMarks, rightMarks)) return (0, $ff5a117367d52834$export$6705e1762430d43f).None;
    return (0, $c1458987f0ac1d68$export$325621c34246ee7d)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}


const $d2802a40c8437136$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $6874c4667cdedbaf$export$220fecd6a5c51ffb),
        state: {
            init: ()=>({
                    decorations: (0, $8nvEM.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $7f3606a1fe9d79f6$export$8f6a177d567e1134)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $8nvEM.DecorationSet).empty
                };
                return {
                    decorations: (0, $8nvEM.DecorationSet).create(doc, [
                        (0, $d92496b7b6d07a32$export$499e8e2917534a4d)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $6874c4667cdedbaf$export$220fecd6a5c51ffb).getState(state)?.decorations;
            }
        }
    });
};






















const $6eb3eaefbfb55bdb$var$DOC_START_POS = 0;
function $6eb3eaefbfb55bdb$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $6eb3eaefbfb55bdb$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($6eb3eaefbfb55bdb$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $6eb3eaefbfb55bdb$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $6eb3eaefbfb55bdb$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $6eb3eaefbfb55bdb$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $6eb3eaefbfb55bdb$var$isNodeContentEmpty(maybeNode) && (0, $kCECX.NodeSelection).isSelectable(maybeNode);
};
function $6eb3eaefbfb55bdb$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
    // and $head which are based on a transformed document, but only provides the original
    // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
    if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
    else if ($targetHead.pos !== $6eb3eaefbfb55bdb$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $6eb3eaefbfb55bdb$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $6eb3eaefbfb55bdb$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$6eb3eaefbfb55bdb$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $6eb3eaefbfb55bdb$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $kCECX.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};



var $8QOo3 = parcelRequire("8QOo3");








var $anBbz = parcelRequire("anBbz");

/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $4c958b748ff1f85e$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) currentExpandedState = node ? !(0, $8QOo3.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $4c958b748ff1f85e$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $4c958b748ff1f85e$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $4c958b748ff1f85e$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $4c958b748ff1f85e$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $4c958b748ff1f85e$var$isBodiedExtension(node) || $4c958b748ff1f85e$var$isTable(node);
};
const $4c958b748ff1f85e$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $4c958b748ff1f85e$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $4c958b748ff1f85e$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $4c958b748ff1f85e$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $kCECX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $4c958b748ff1f85e$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $kCECX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    if (isNavigatingInlineNodeDownward && (0, $8QOo3.getNextNodeExpandPos)(view, selection) !== undefined && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) return false;
    return isNavigatingInlineNodeDownward;
};
function $4c958b748ff1f85e$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $kCECX.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($4c958b748ff1f85e$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($4c958b748ff1f85e$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $4c958b748ff1f85e$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $kCECX.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}





function $176b4fe3844203a7$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $176b4fe3844203a7$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $kCECX.TextSelection) && $176b4fe3844203a7$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $kCECX.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}




const $181c352f5d73684d$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $4cbb9f67e8db09a7$export$968abecb43309c32)(state.tr),
        selection: state.selection
    });
const $181c352f5d73684d$export$ae829ec7b2625219 = (api, dispatch, dispatchAnalyticsEvent, options = {})=>{
    let cursorHidden = false;
    let blockSelection;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $54b37cf8a78f6f24$export$e530ba00b008a680),
        state: (0, $12e0332593616ffe$export$656c7661095efe2e)(dispatch, $181c352f5d73684d$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            let hideCursorChanged = false;
            let blockSelectionChanged = false;
            const needsBlockSelection = (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            });
            for(let i = transactions.length - 1; i >= 0; i--){
                const meta = transactions[i].getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
                if (meta?.hideCursor !== undefined) {
                    const newHideCursorValue = meta.hideCursor;
                    if (cursorHidden !== newHideCursorValue) {
                        cursorHidden = newHideCursorValue;
                        hideCursorChanged = true;
                    }
                }
                if (meta?.manualSelection && !manualSelection) manualSelection = meta.manualSelection;
                if (needsBlockSelection) {
                    if (meta?.setBlockSelection) {
                        blockSelection = meta.setBlockSelection;
                        blockSelectionChanged = true;
                    }
                    if (meta?.clearBlockSelection) {
                        blockSelection = undefined;
                        blockSelectionChanged = true;
                    }
                }
            }
            if (!(0, $4cbb9f67e8db09a7$export$8f1ae47b39045ce2)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection && !hideCursorChanged && !blockSelectionChanged) return;
            tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
                type: (0, $cbcc2720fcc3bfaa$export$ab4e2275d2998c63).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $4cbb9f67e8db09a7$export$968abecb43309c32)(tr, manualSelection, cursorHidden, blockSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $kCECX.NodeSelection) && !tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $kCECX.NodeSelection) && tr.selection instanceof (0, $kCECX.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $6eb3eaefbfb55bdb$export$ba3a236bf89a370d),
            decorations (state) {
                const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
                // Do not show selection decorations for live pages where the user has not
                // interacted with the page. We do not show cursor until interaction and we do not
                // want to show selections either.
                if ((options.__livePage || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && interactionState === 'hasNotHadInteraction') return (0, $8nvEM.DecorationSet).empty;
                return (0, $12e0332593616ffe$export$f05434c51e3762e)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $4c958b748ff1f85e$export$1bff6ff05fed49a5)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $176b4fe3844203a7$export$65a11040da641544)
            }
        }
    });
};



const $93afba474ecb726f$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $2eb722959b834642$export$21af267ac39e2110), {
            displayGapCursor: toggle
        });
    };
const $93afba474ecb726f$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
        return tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $93afba474ecb726f$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
        return tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $93afba474ecb726f$var$hideCursor = (hide)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
        return tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            ...currMeta,
            hideCursor: hide
        });
    };
const $93afba474ecb726f$var$setBlockSelection = (selection)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
        return tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            ...currMeta,
            setBlockSelection: selection
        });
    };
const $93afba474ecb726f$var$clearBlockSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680));
        return tr.setMeta((0, $54b37cf8a78f6f24$export$e530ba00b008a680), {
            ...currMeta,
            clearBlockSelection: true
        });
    };
const $93afba474ecb726f$export$35a6a08064a865b4 = ({ api: api, config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $93afba474ecb726f$var$displayGapCursor,
            clearManualSelection: $93afba474ecb726f$var$clearManualSelection,
            hideCursor: $93afba474ecb726f$var$hideCursor,
            setManualSelection: $93afba474ecb726f$var$setManualSelection,
            setBlockSelection: $93afba474ecb726f$var$setBlockSelection,
            clearBlockSelection: $93afba474ecb726f$var$clearBlockSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $7578836c662e6183$export$c7d22caae2fd3756)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                },
            getSelectionFragment: (0, $f0f737bd8364f431$export$ebd99cdb6a61129e)(api),
            getSelectionLocalIds: (0, $f0f737bd8364f431$export$27a1b30a70c1f80d)(api)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $54b37cf8a78f6f24$export$e530ba00b008a680).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $181c352f5d73684d$export$ae829ec7b2625219)(api, dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $38cb46acc33bdb7a$export$2e2bcd8739ae039)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $c93c2946bb3620b9$export$2e2bcd8739ae039)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $cfdd352226c18bda$export$2e2bcd8739ae039)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $d2802a40c8437136$export$d3a8cfe12ba42d22)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $c1d02771e872029d$export$b5faf98028194323)()
                }
            ];
        }
    });
var $93afba474ecb726f$export$2e2bcd8739ae039 = $93afba474ecb726f$export$35a6a08064a865b4;
module.exports["selectionPlugin"] = $93afba474ecb726f$export$35a6a08064a865b4;

});

parcelRegister("dxDD9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $gZpSA = parcelRequire("gZpSA");


var $kCECX = parcelRequire("kCECX");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");










const $d7edd68d2c6ffb77$export$b382528b8197b4f1 = new (0, $kCECX.PluginKey)('selectionToolbarPluginKey');


const $4f153fffb71ac75c$export$9bf0179b815bb489 = ({ hide: hide })=>({ tr: tr })=>{
        tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
            hide: hide
        });
        return tr;
    };
const $4f153fffb71ac75c$export$78c8c4f9cf91105f = ({ toolbarDocking: toolbarDocking })=>({ tr: tr })=>{
        tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };
const $4f153fffb71ac75c$export$c90257e445702eb2 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        // We currently ignore any update failures, need to confirm this is the desired behaviour
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        if (toolbarDocking === 'top') // Remove the selection if the toolbar is docked to the top
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, tr.selection.head));
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: toolbarDocking
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $4f153fffb71ac75c$export$93bfa5da95924fe8 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider })=>({ tr: tr })=>{
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };




var $cozmU = parcelRequire("cozmU");





var $jv11C = parcelRequire("jv11C");

const $82910985d2df4cac$export$57bf1011afa72cdf = ({ api: api, userPreferencesProvider: userPreferencesProvider })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!userPreferencesProvider || !api) return;
        const refreshPrefrerence = async ()=>{
            if (document.visibilityState === 'visible') {
                try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $jv11C.logException)(error, {
                        location: 'editor-plugin-selection-toolbar/PageVisibilityWatcher'
                    });
                }
                api?.selectionToolbar?.actions?.refreshToolbarDocking?.();
            }
        };
        return (0, $cbY7C.bind)(document, {
            type: 'visibilitychange',
            listener: refreshPrefrerence
        });
    }, [
        api,
        userPreferencesProvider
    ]);
    return null;
};





parcelRequire("cozmU");


var $7uaqq = parcelRequire("7uaqq");


var $jaFVy = parcelRequire("jaFVy");


var $lW3nu = parcelRequire("lW3nu");


var $5P5VV = parcelRequire("5P5VV");

const $b3cd50465f421f03$export$c9b144c567898dd8 = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    const isOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
    let pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.unpined',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'top')) ?? false;
        },
        title: intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionUnpined),
        type: 'button'
    };
    const isDockedToTop = toolbarDocking === 'top';
    if (isDockedToTop) pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.pinedToTop',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none')) ?? false;
        },
        type: 'button',
        title: intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionPinedAtTop)
    };
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        pinButton
    ];
};


/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");





var $ldbHR = parcelRequire("ldbHR");


var $4Qu9h = parcelRequire("4Qu9h");













const $760336b0b227aef0$var$buttonStyles = null;
const $760336b0b227aef0$export$94516d5cccf573e3 = ({ api: api, disabled: disabled })=>{
    const intl = (0, $kSwu1.useIntl)();
    const mode = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const isOffline = (0, $jaFVy.isOfflineMode)(mode);
    const isDockedToTop = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition === 'top' : api?.selectionToolbar.sharedState.currentState()?.toolbarDocking === 'top';
    if (isDockedToTop) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
        "aria-label": intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionPinedAtTop),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none')) ?? false;
        },
        title: intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionPinedAtTop),
        className: (0, $hekY6.default)([
            "_0Of8r2gVvo _1wydGWgVvo _2Zuz6QgVvo _1ZnuxbgVvo"
        ])
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
        "aria-label": intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionUnpined),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'top')) ?? false;
        },
        title: intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionUnpined),
        className: (0, $hekY6.default)([
            "_0Of8r2gVvo _1wydGWgVvo _2Zuz6QgVvo _1ZnuxbgVvo"
        ])
    });
};





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




parcelRequire("cozmU");


var $bFSJa = parcelRequire("bFSJa");


var $jgJIe = parcelRequire("jgJIe");

const $21b5cac7249ca4ba$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $21b5cac7249ca4ba$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $21b5cac7249ca4ba$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};





parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");










var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $73a3402be4919211$export$d2415675e97f35c2 = ({ api: api })=>{
    const intl = (0, $kSwu1.useIntl)();
    const message = intl.formatMessage((0, $7uaqq.selectionToolbarMessages).toolbarPositionPinedAtTop);
    const { isOffline: isDisabled } = (0, $bFSJa.useEditorToolbar)();
    // Pin/unpin is meaningless when a runtime override forces `'always-pinned'`
    // (e.g. Markdown Mode source / preview view). Subscribe so we re-render and
    // hide ourselves on flip.
    const runtimeOverride = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    if (runtimeOverride === 'always-pinned') return null;
    const onClick = ()=>{
        if (!api || isDisabled) return;
        api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none'));
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
                size: "small",
                label: ""
            }),
            label: message,
            onClick: onClick,
            isDisabled: isDisabled
        })
    });
};





parcelRequire("cozmU");


















var $dVKvM = parcelRequire("dVKvM");




const $0e5b0f8b3d6bcdfa$var$shouldShowPinMenuItem = (editMode)=>{
    return editMode !== 'view';
};
const $0e5b0f8b3d6bcdfa$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
};
const $0e5b0f8b3d6bcdfa$export$38c363c8d7e9c6f1 = ({ api: api, disablePin: disablePin })=>{
    const intl = (0, $kSwu1.useIntl)();
    const runtimeOverride = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isDisabled } = $0e5b0f8b3d6bcdfa$var$usePluginState(api);
    const isToolbarDocked = editorToolbarDockingPreference === 'top';
    if (disablePin || !$0e5b0f8b3d6bcdfa$var$shouldShowPinMenuItem(editorViewMode) || runtimeOverride === 'always-pinned' && (0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) return null;
    const onClick = ()=>{
        if (!api || isDisabled) return;
        api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', isToolbarDocked ? 'none' : 'top'));
    };
    const message = intl.formatMessage(isToolbarDocked ? (0, $7uaqq.selectionToolbarMessages).toolbarPositionPinedAtTop : (0, $7uaqq.selectionToolbarMessages).toolbarPositionUnpinnedConcise);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: onClick,
        isDisabled: isDisabled,
        elemBefore: isToolbarDocked ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))), {
            size: "small",
            label: ""
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))), {
            size: "small",
            label: ""
        }),
        children: message
    });
};


const $12f35155336d0189$export$a758406ca53b86a5 = (api, contextualFormattingEnabled, disablePin)=>{
    const components = [
        {
            type: (0, $3nacY.PIN_MENU_SECTION).type,
            key: (0, $3nacY.PIN_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_MENU).type,
                    key: (0, $3nacY.OVERFLOW_MENU).key,
                    rank: (0, $hVLmg.OVERFLOW_MENU_RANK)[(0, $3nacY.PIN_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $21b5cac7249ca4ba$export$4b1545b4f2016d26), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.PIN_MENU_ITEM).type,
            key: (0, $3nacY.PIN_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.PIN_MENU_SECTION).type,
                    key: (0, $3nacY.PIN_MENU_SECTION).key,
                    rank: (0, $hVLmg.PIN_MENU_SECTION_RANK)[(0, $3nacY.PIN_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0e5b0f8b3d6bcdfa$export$38c363c8d7e9c6f1), {
                    api: api,
                    disablePin: disablePin
                });
            }
        }
    ];
    // Add pin button to primary toolbar when contextual formatting is enabled
    if (contextualFormattingEnabled) {
        const pinButtonComponents = [
            {
                type: (0, $3nacY.PIN_GROUP).type,
                key: (0, $3nacY.PIN_GROUP).key,
                parents: [
                    {
                        type: (0, $3nacY.PIN_SECTION).type,
                        key: (0, $3nacY.PIN_SECTION).key,
                        rank: (0, $hVLmg.PIN_SECTION_RANK)[(0, $3nacY.PIN_GROUP).key]
                    }
                ]
            },
            {
                type: (0, $3nacY.PIN_BUTTON).type,
                key: (0, $3nacY.PIN_BUTTON).key,
                parents: [
                    {
                        type: (0, $3nacY.PIN_GROUP).type,
                        key: (0, $3nacY.PIN_GROUP).key,
                        rank: (0, $hVLmg.PIN_GROUP_RANK)[(0, $3nacY.PIN_BUTTON).key]
                    }
                ],
                component: ()=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $73a3402be4919211$export$d2415675e97f35c2), {
                        api: api
                    });
                }
            }
        ];
        components.push(...pinButtonComponents);
    }
    return components;
};


const $3dfe36305e4737c3$var$getToolbarDocking = (contextualFormattingEnabled, userPreferencesProvider)=>{
    if (contextualFormattingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') ?? 'none';
    return 'top';
};
const $3dfe36305e4737c3$var$getToolbarDockingV2 = (contextualFormattingEnabled, dockingPreference)=>{
    if (contextualFormattingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return dockingPreference ?? 'none';
    return 'top';
};
const $3dfe36305e4737c3$export$b621d761b94834de = ({ api: api, config: config })=>{
    const __selectionToolbarHandlers = [];
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { userPreferencesProvider: userPreferencesProvider, contextualFormattingEnabled: contextualFormattingEnabled, disablePin: disablePin } = config;
    if (isToolbarAIFCEnabled) /**
     * If toolbar is set to always-pinned or always-inline, there is no control over toolbar placement
     */ {
        if (api?.toolbar?.actions.contextualFormattingMode() === 'controlled') api?.toolbar?.actions.registerComponents((0, $12f35155336d0189$export$a758406ca53b86a5)(api, true, disablePin));
    } else if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        primaryToolbarComponent = ({ disabled: disabled })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $760336b0b227aef0$export$94516d5cccf573e3), {
                api: api,
                disabled: disabled
            });
        };
        api?.primaryToolbar?.actions.registerComponent({
            name: 'pinToolbar',
            component: primaryToolbarComponent
        });
    }
    let previousToolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') || null;
    let isPreferenceInitialized = false;
    return {
        name: 'selectionToolbar',
        actions: {
            /**
       * Overrides the user's toolbar docking position preference programmatically,
       * bypassing the normal user-driven preference update flow.
       */ overrideToolbarDocking: (toolbarDocking)=>{
                const command = api?.userPreferences?.commands.overrideUserPreference('toolbarDockingPosition', toolbarDocking);
                if (!command) return false;
                return api?.core.actions.execute(command) ?? false;
            },
            /**
       * Clears the toolbar docking override and reverts to the current preference/state value.
       */ clearToolbarDockingOverride: ()=>{
                const command = api?.userPreferences?.commands.clearOverrideUserPreference('toolbarDockingPosition');
                if (!command) return false;
                return api?.core.actions.execute(command) ?? false;
            },
            suppressToolbar: ()=>{
                return api?.core.actions.execute((0, $4f153fffb71ac75c$export$9bf0179b815bb489)({
                    hide: true
                })) ?? false;
            },
            unsuppressToolbar: ()=>{
                return api?.core.actions.execute((0, $4f153fffb71ac75c$export$9bf0179b815bb489)({
                    hide: false
                })) ?? false;
            },
            setToolbarDocking: (toolbarDocking)=>{
                if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking)) ?? false;
                return api?.core.actions.execute((0, $4f153fffb71ac75c$export$c90257e445702eb2)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                })) ?? false;
            },
            forceToolbarDockingWithoutAnalytics: (toolbarDocking)=>{
                if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking)) ?? false;
                return api?.core.actions.execute((0, $4f153fffb71ac75c$export$93bfa5da95924fe8)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider
                })) ?? false;
            },
            refreshToolbarDocking: ()=>{
                if (userPreferencesProvider) {
                    const userToolbarDockingPref = $3dfe36305e4737c3$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                    return api?.core.actions.execute((0, $4f153fffb71ac75c$export$78c8c4f9cf91105f)({
                        toolbarDocking: userToolbarDockingPref
                    })) ?? false;
                }
                return false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $d7edd68d2c6ffb77$export$b382528b8197b4f1).getState(editorState);
        },
        pmPlugins (selectionToolbarHandlers) {
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            const initialToolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? $3dfe36305e4737c3$var$getToolbarDockingV2(contextualFormattingEnabled, api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition) : $3dfe36305e4737c3$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: (0, $d7edd68d2c6ffb77$export$b382528b8197b4f1),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false,
                                        hide: false,
                                        toolbarDocking: initialToolbarDocking
                                    };
                                },
                                apply (tr, pluginState) {
                                    const meta = tr.getMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1));
                                    let newPluginState = pluginState;
                                    if (meta) return {
                                        ...newPluginState,
                                        ...meta
                                    };
                                    if ((0, $jkcNT.editorExperiment)('platform_editor_block_menu', true)) {
                                        const isBlockMenuOpen = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
                                        newPluginState = {
                                            ...newPluginState,
                                            isBlockMenuOpen: isBlockMenuOpen
                                        };
                                    }
                                    // if the toolbarDockingInitialPosition preference has changed
                                    // update the toolbarDocking state
                                    if (!previousToolbarDocking) {
                                        // we currently only check for the initial value
                                        const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                        if (toolbarDockingPreference && toolbarDockingPreference !== previousToolbarDocking) {
                                            previousToolbarDocking = toolbarDockingPreference;
                                            const userToolbarDockingPref = $3dfe36305e4737c3$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                            if (pluginState.toolbarDocking !== userToolbarDockingPref) return {
                                                ...newPluginState,
                                                toolbarDocking: userToolbarDockingPref
                                            };
                                        }
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $cbY7C.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: (event)=>{
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        const target = event.target;
                                        if (target && target instanceof Element) {
                                            const isRovoChangeToneButton = target.tagName === 'BUTTON' && $3dfe36305e4737c3$var$hasNestedSpanWithText(target, 'Change tone') || target.getAttribute('aria-label') === 'Change tone' || target.innerHTML === 'Change tone';
                                            const isRovoTranslateButton = target.tagName === 'BUTTON' && $3dfe36305e4737c3$var$hasNestedSpanWithText(target, 'Translate options') || target.getAttribute('aria-label') === 'Translate options' || target.innerHTML === 'Translate options';
                                            if (isRovoChangeToneButton || isRovoTranslateButton) return null;
                                        }
                                        view.dispatch(view.state.tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $cbY7C.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            appendTransaction (_transactions, _oldState, newState) {
                                if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) return null;
                                if (!isPreferenceInitialized && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                                    const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                    if (toolbarDockingPreference !== undefined) {
                                        isPreferenceInitialized = true;
                                        const userToolbarDockingPref = $3dfe36305e4737c3$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                        const tr = newState.tr;
                                        api?.analytics?.actions.attachAnalyticsEvent({
                                            action: (0, $krYZG.ACTION).INITIALISED,
                                            actionSubject: (0, $krYZG.ACTION_SUBJECT).USER_PREFERENCES,
                                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                                            attributes: {
                                                toolbarDocking: userToolbarDockingPref
                                            },
                                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                                        })(tr);
                                        return tr;
                                    }
                                }
                                return null;
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $d7edd68d2c6ffb77$export$b382528b8197b4f1), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable, hide: hide, toolbarDocking: toolbarDocking, isBlockMenuOpen: isBlockMenuOpen } = (0, $d7edd68d2c6ffb77$export$b382528b8197b4f1).getState(state);
                const isCellSelection = '$anchorCell' in state.selection;
                const isEditorControlsEnabled = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1');
                if (state.selection.empty || !selectionStable || hide || state.selection instanceof (0, $kCECX.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                isCellSelection && !isEditorControlsEnabled // for Editor Controls we want to show the toolbar on CellSelection
                ) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                if (isCellSelection && isEditorControlsEnabled) {
                    const isSelectedViaDragHandle = api?.blockControls?.sharedState.currentState()?.isSelectedViaDragHandle;
                    if (isSelectedViaDragHandle) return;
                }
                if (isBlockMenuOpen && isEditorControlsEnabled && (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true)) // If the block menu is open, do not show the selection toolbar.
                return;
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    // add a seperator icon after each group except the last
                    if (Array.isArray(resolved[i]?.items)) items.push(...resolved[i].items);
                    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                        if (resolved[i] && resolved[i + 1]) {
                            if (resolved[i + 1]?.pluginName === 'annotation') items.push({
                                type: 'separator',
                                fullHeight: true
                            });
                        }
                    } else if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                if (items.length > 0 && contextualFormattingEnabled && isEditorControlsEnabled) {
                    const toolbarDockingPref = api?.userPreferences && (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : toolbarDocking;
                    items.push(...(0, $b3cd50465f421f03$export$c9b144c567898dd8)({
                        api: api,
                        toolbarDocking: toolbarDockingPref,
                        intl: intl
                    }));
                }
                let onPositionCalculated;
                const toolbarTitle = 'Selection toolbar';
                if (isCellSelection && isEditorControlsEnabled) onPositionCalculated = (0, $gZpSA.calculateToolbarPositionOnCellSelection)(toolbarTitle);
                else {
                    const calcToolbarPosition = config.preferenceToolbarAboveSelection ? (0, $gZpSA.calculateToolbarPositionAboveSelection) : (0, $gZpSA.calculateToolbarPositionTrackHead);
                    onPositionCalculated = calcToolbarPosition(toolbarTitle);
                }
                const nodeType = $3dfe36305e4737c3$var$getSelectionNodeTypes(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    ...isEditorControlsEnabled && {
                        scrollable: true
                    },
                    onPositionCalculated: onPositionCalculated
                };
            }
        },
        contentComponent: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $82910985d2df4cac$export$57bf1011afa72cdf), {
                api: api,
                userPreferencesProvider: userPreferencesProvider
            }) : undefined,
        primaryToolbarComponent: !api?.primaryToolbar && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? primaryToolbarComponent : undefined
    };
};
function $3dfe36305e4737c3$var$getSelectionNodeTypes(state) {
    const selectionNodeTypes = [];
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}
const $3dfe36305e4737c3$var$hasNestedSpanWithText = (element, text)=>{
    if (element.tagName === 'SPAN' && element.innerHTML === text) return true;
    for (const child of Array.from(element.children)){
        if ($3dfe36305e4737c3$var$hasNestedSpanWithText(child, text)) return true;
    }
    return false;
};
module.exports["selectionToolbarPlugin"] = $3dfe36305e4737c3$export$b621d761b94834de;

});

parcelRegister("ljXAk", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $6pnwK = parcelRequire("6pnwK");


var $44cyU = parcelRequire("44cyU");

function $2c8432d8d1a81954$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $44cyU.keymap)({
        [`${(0, $ldqjS.submit).common}`]: (state, _dispatch, editorView)=>{
            const mediaState = api?.media?.sharedState?.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $6pnwK.analyticsEventKey), $2c8432d8d1a81954$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $2c8432d8d1a81954$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $krYZG.ACTION).STOPPED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        }
    });


const $560d01161b5096ef$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $2c8432d8d1a81954$export$ae829ec7b2625219)(dispatch, api, onSave)
                }
            ];
        }
    });
module.exports["submitEditorPlugin"] = $560d01161b5096ef$export$e488d499f3ae3f86;

});

parcelRegister("4gNvG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $f9e3d12e2bdb278a$export$34783ae4fef40269 = ()=>{
    const components = [];
    const register = (newComponents)=>{
        components.push(...newComponents);
    };
    /**
   * Similer to `register` but first checks the registry against `newComponents` using its
   * key and type, if it already exists it replaces the item instead of simply appending it.
   *
   * Most likely you should avoid using this and just use the `register` method as it's preferred
   * to register components statically.
   */ const safeRegister = (newComponents)=>{
        newComponents.forEach((newComponent)=>{
            const existingIndex = components.findIndex((existingComponent)=>existingComponent.type === newComponent.type && existingComponent.key === newComponent.key);
            if (existingIndex !== -1) // Replace existing component
            components[existingIndex] = newComponent;
            else // Add new component
            components.push(newComponent);
        });
    };
    return {
        register: register,
        safeRegister: safeRegister,
        components: components
    };
};



var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");


var $1fBj6 = parcelRequire("1fBj6");

var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $6NW7h = parcelRequire("6NW7h");

var $jw4KW = parcelRequire("jw4KW");










const $c31dddbd5a5304ff$export$e76971190b14d34a = (currentUserIntent, isCellSelection)=>Boolean(currentUserIntent && currentUserIntent !== 'default' && !(currentUserIntent === 'dragHandleSelected' && !isCellSelection));
const $c31dddbd5a5304ff$export$1040bb4c78920b38 = ({ shiftKey: shiftKey, key: key, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey })=>shiftKey && !metaKey && !ctrlKey && !altKey && key.includes('Arrow');
const $c31dddbd5a5304ff$export$29c1d2c9a57e77aa = (mouseDownSelection, currentSelection)=>Boolean(mouseDownSelection && !mouseDownSelection.eq(currentSelection));


const $3e937741a8caac79$var$pluginKey = new (0, $kCECX.PluginKey)('selectionToolbarOpenExperience');
const $3e937741a8caac79$var$START_METHOD = {
    MOUSE_UP: 'mouseUp',
    KEY_DOWN: 'keyDown'
};
const $3e937741a8caac79$var$ABORT_REASON = {
    SELECTION_CLEARED: 'selectionCleared',
    BLOCK_MENU_OPENED: 'blockMenuOpened',
    EDITOR_DESTROYED: 'editorDestroyed',
    USER_INTENT_SUPPRESSED: 'userIntentSuppressed'
};
const $3e937741a8caac79$export$cfe4aed4f8555228 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getCurrentUserIntent: getCurrentUserIntent })=>{
    const isIntentFixEnabled = (0, $iDrrr.fg)('platform_editor_toolbar_intent_fix');
    let editorView;
    let targetEl;
    let shiftArrowKeyPressed = false;
    let mouseDownPos;
    let mouseDownSelection;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || (0, $jw4KW.getPopupContainerFromEditorView)(editorView?.dom);
        return targetEl;
    };
    const isCurrentUserIntentSuppressingToolbar = (selection)=>{
        if (!selection) return false;
        const isCellSelection = !selection.empty && '$anchorCell' in selection;
        return (0, $c31dddbd5a5304ff$export$e76971190b14d34a)(getCurrentUserIntent?.(), isCellSelection);
    };
    const experience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_OPEN, {
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: 1000,
                onTimeout: ()=>{
                    if (isIntentFixEnabled && isCurrentUserIntentSuppressingToolbar(editorView?.state.selection)) return {
                        status: 'abort',
                        reason: $3e937741a8caac79$var$ABORT_REASON.USER_INTENT_SUPPRESSED
                    };
                    else if ($3e937741a8caac79$var$isBlockMenuWithinNode(getTarget())) return {
                        status: 'abort',
                        reason: $3e937741a8caac79$var$ABORT_REASON.BLOCK_MENU_OPENED
                    };
                    else if ($3e937741a8caac79$var$isSelectionWithoutTextContent(editorView?.state.selection)) return {
                        status: 'abort',
                        reason: $3e937741a8caac79$var$ABORT_REASON.SELECTION_CLEARED
                    };
                }
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($3e937741a8caac79$var$isSelectionToolbarAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    const shouldSkipExperienceStart = (selection)=>{
        if ($3e937741a8caac79$var$isSelectionWithoutTextContent(selection) || $3e937741a8caac79$var$isSelectionWithinCodeBlock(selection) || isIntentFixEnabled && isCurrentUserIntentSuppressingToolbar(selection)) return true;
        const target = getTarget();
        if (!target) // when target is not found, skip the experience start
        return true;
        return $3e937741a8caac79$var$isSelectionToolbarWithinNode(target) || $3e937741a8caac79$var$isBlockMenuWithinNode(target);
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $3e937741a8caac79$var$pluginKey,
        state: {
            init: ()=>({}),
            apply: (_tr, pluginState, oldState, newState)=>{
                if (!oldState.selection.empty && $3e937741a8caac79$var$isSelectionWithoutTextContent(newState.selection)) experience.abort({
                    reason: $3e937741a8caac79$var$ABORT_REASON.SELECTION_CLEARED
                });
                const shouldStartExperience = shiftArrowKeyPressed && !newState.selection.eq(oldState.selection) && !shouldSkipExperienceStart(newState.selection);
                if (shouldStartExperience) {
                    experience.start({
                        method: $3e937741a8caac79$var$START_METHOD.KEY_DOWN
                    });
                    shiftArrowKeyPressed = false;
                }
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                mousedown: (view, e)=>{
                    mouseDownPos = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    if (isIntentFixEnabled) mouseDownSelection = view.state.selection;
                },
                mouseup: (view, e)=>{
                    const initialMouseDownPos = mouseDownPos;
                    const selectionChanged = (0, $c31dddbd5a5304ff$export$29c1d2c9a57e77aa)(mouseDownSelection, view.state.selection);
                    if (isIntentFixEnabled) {
                        mouseDownPos = undefined;
                        mouseDownSelection = undefined;
                    }
                    if (!initialMouseDownPos || shouldSkipExperienceStart(view.state.selection)) return;
                    const mouseCoordinatesChanged = e.clientX !== initialMouseDownPos.x || e.clientY !== initialMouseDownPos.y;
                    if (mouseCoordinatesChanged && (!isIntentFixEnabled || selectionChanged)) experience.start({
                        method: $3e937741a8caac79$var$START_METHOD.MOUSE_UP
                    });
                },
                dblclick: (view)=>{
                    if (shouldSkipExperienceStart(view.state.selection)) return;
                    experience.start({
                        method: $3e937741a8caac79$var$START_METHOD.MOUSE_UP
                    });
                },
                keydown: (_view, event)=>{
                    shiftArrowKeyPressed = (isIntentFixEnabled ? (0, $c31dddbd5a5304ff$export$1040bb4c78920b38)(event) : event.shiftKey && event.key.includes('Arrow')) && !$3e937741a8caac79$var$isSelectionToolbarWithinNode(getTarget());
                },
                keyup: ()=>{
                    shiftArrowKeyPressed = false;
                }
            }
        },
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $3e937741a8caac79$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $3e937741a8caac79$var$isSelectionToolbarAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($3e937741a8caac79$var$isSelectionToolbarWithinNode);
};
const $3e937741a8caac79$var$isSelectionToolbarWithinNode = (node)=>{
    return (0, $1fBj6.containsPopupWithNestedElement)(node, '[data-testid="editor-floating-toolbar"]');
};
const $3e937741a8caac79$var$isBlockMenuWithinNode = (node)=>{
    return (0, $1fBj6.containsPopupWithNestedElement)(node, '[data-testid="editor-block-menu"]');
};
const $3e937741a8caac79$var$isSelectionWithoutTextContent = (selection)=>{
    if (!selection || selection.empty) return true;
    let hasText = false;
    selection.$from.doc.nodesBetween(selection.from, selection.to, (node)=>{
        if (hasText) return false;
        if (node.isText && node.text && node.text.length > 0) {
            hasText = true;
            return false;
        }
        return true;
    });
    return !hasText;
};
const $3e937741a8caac79$var$isSelectionWithinCodeBlock = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.sameParent($to) && $from.parent.type.name === 'codeBlock';
};



var $erHVE = parcelRequire("erHVE");

const $d64b73b531f94eae$export$e235a0bccaa8a700 = 'Selection toolbar';
const $d64b73b531f94eae$export$c0535c9204f67376 = {
    toolbarContainer: '[role="toolbar"]',
    portal: '.atlaskit-portal'
};






var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");





var $4iudd = parcelRequire("4iudd");


var $h75sz = parcelRequire("h75sz");


var $3k5Tv = parcelRequire("3k5Tv");


var $jv11C = parcelRequire("jv11C");


var $bFSJa = parcelRequire("bFSJa");

var $gnAkm = parcelRequire("gnAkm");
const $ae06ba3afdcae1e1$export$af4b2f219e301e70 = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition === 'top';
    if (contextualFormattingEnabled === 'always-inline') return true;
    return false;
};



var $7XIuB = parcelRequire("7XIuB");


var $gZpSA = parcelRequire("gZpSA");


var $jaFVy = parcelRequire("jaFVy");





var $7Y8M5 = parcelRequire("7Y8M5");


var $5AKbu = parcelRequire("5AKbu");

var $jgJIe = parcelRequire("jgJIe");

var $cE5a1 = parcelRequire("cE5a1");

var $b2jdX = parcelRequire("b2jdX");


var $7CFSN = parcelRequire("7CFSN");





var $ieeJu = parcelRequire("ieeJu");


var $jkcNT = parcelRequire("jkcNT");



var $1hQ0e = parcelRequire("1hQ0e");


var $l1ngX = parcelRequire("l1ngX");





var $bwJyA = parcelRequire("bwJyA");

const $0193b6c1578a5c29$export$3985dc3e1cbf9fe4 = (event, containerSelector)=>{
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return false;
    return !!target.closest(containerSelector);
};
const $0193b6c1578a5c29$export$d75f9c68101e0fa9 = (event)=>{
    return event.altKey && event.key === 'F10';
};
const $0193b6c1578a5c29$export$433aaa1f216cf32d = (rootNode)=>{
    if (!rootNode) return [];
    const focusableElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    const focusableElementsArray = Array.from(focusableElements);
    // filter out focusable elements from child components such as dropdown menus / popups
    return focusableElementsArray.filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // filter out invisible elements
        return style.visibility !== 'hidden' && style.display !== 'none';
    });
};


const $ff89bf7e9aa7d1e0$export$48b8f4aa7f88bf3a = (editorView, intl, api)=>{
    if (!(editorView.dom instanceof HTMLElement)) return;
    const toolbarSelector = "[data-testid='editor-floating-toolbar']";
    return {
        childComponentSelector: toolbarSelector,
        dom: editorView.dom,
        isShortcutToFocusToolbar: (0, $0193b6c1578a5c29$export$d75f9c68101e0fa9),
        handleFocus: (event)=>{
            try {
                const toolbar = (0, $1hQ0e.getDocument)()?.querySelector(toolbarSelector);
                if (!(toolbar instanceof HTMLElement)) return;
                const filteredFocusableElements = (0, $0193b6c1578a5c29$export$433aaa1f216cf32d)(toolbar);
                filteredFocusableElements[0]?.focus();
                // the button element removes the focus ring so this class adds it back
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $jv11C.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        handleEscape: (event)=>{
            try {
                const isDropdownOpen = !!document.querySelector('[data-toolbar-component="menu-section"]');
                if (isDropdownOpen) return;
                api?.core.actions.focus();
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $jv11C.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        ariaControls: (0, $bwJyA.EDIT_AREA_ID),
        ariaLabel: intl.formatMessage((0, $l1ngX.messages).toolbarLabel)
    };
};











const $83cda40c9db7d284$export$49d74ed2464a12b9 = (view, dispatchAnalyticsEvent)=>{
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) return domRef;
        throw new Error('Invalid DOM reference');
    } catch (error) {
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $krYZG.CONTENT_COMPONENT).SELECTION_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error instanceof Error ? error.toString() : String(error),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
        if (error instanceof Error) (0, $jv11C.logException)(error, {
            location: 'editor-plugin-toolbar/selectionToolbar'
        });
    }
};



const $2798a2ac57c73b6e$var$isToolbarComponent = (component)=>{
    return component.type === 'toolbar' && component.key === 'inline-text-toolbar';
};
const $2798a2ac57c73b6e$var$usePluginState = (api)=>{
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'userPreferences',
        'toolbar',
        'selection',
        'userIntent',
        'editorViewMode'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition,
            shouldShowToolbar: state.toolbarState?.shouldShowToolbar,
            selectedNode: state.toolbarState?.selectedNode,
            contextualFormattingModeOverride: state.toolbarState?.contextualFormattingModeOverride,
            selection: state.selectionState?.selection,
            currentUserIntent: state.userIntentState?.currentUserIntent,
            editorViewMode: state.editorViewModeState?.mode
        };
    });
};
const $2798a2ac57c73b6e$var$useOnPositionCalculated = (editorView)=>{
    const onPositionCalculated = (0, $cozmU.useCallback)((position)=>{
        try {
            // Show special position on cell selection only when editor controls experiment is enabled
            const isEditorControlsEnabled = (0, $ieeJu.expValEquals)('platform_editor_controls', 'cohort', 'variant1');
            const isCellSelection = '$anchorCell' in editorView.state.selection;
            if (isCellSelection && isEditorControlsEnabled) return (0, $gZpSA.calculateToolbarPositionOnCellSelection)((0, $d64b73b531f94eae$export$e235a0bccaa8a700))(editorView, position);
            return (0, $gZpSA.calculateToolbarPositionTrackHead)((0, $d64b73b531f94eae$export$e235a0bccaa8a700))(editorView, position);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-toolbar/selectionToolbar'
            });
            return position;
        }
    }, [
        editorView
    ]);
    return onPositionCalculated;
};
const $2798a2ac57c73b6e$export$5d706a9638468490 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, onToolbarMouseUp: onToolbarMouseUp })=>{
    const { connectivityStateMode: connectivityStateMode, editorToolbarDockingPreference: editorToolbarDockingPreference, currentUserIntent: currentUserIntent, shouldShowToolbar: shouldShowToolbar, editorViewMode: editorViewMode, contextualFormattingModeOverride: contextualFormattingModeOverride } = $2798a2ac57c73b6e$var$usePluginState(api);
    const contextualFormattingEnabled = contextualFormattingModeOverride ?? api?.toolbar?.actions.contextualFormattingMode() ?? 'always-pinned';
    const selectionToolbarConfigEnabled = (0, $ae06ba3afdcae1e1$export$af4b2f219e301e70)(contextualFormattingEnabled, editorToolbarDockingPreference);
    const intl = (0, $kSwu1.useIntl)();
    const components = api?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>$2798a2ac57c73b6e$var$isToolbarComponent(component));
    const keyboardNavigation = (0, $cozmU.useMemo)(()=>{
        return (0, $ff89bf7e9aa7d1e0$export$48b8f4aa7f88bf3a)(editorView, intl, api);
    }, [
        editorView,
        intl,
        api
    ]);
    const { isDisabled: isDisabled } = (0, $b2jdX.useToolbarUI)();
    const isOffline = (0, $jaFVy.isOfflineMode)(connectivityStateMode);
    const isTextSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $kCECX.TextSelection);
    const isAllSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $kCECX.AllSelection);
    const isCellSelection = !editorView.state.selection.empty && '$anchorCell' in editorView.state.selection;
    const onPositionCalculated = $2798a2ac57c73b6e$var$useOnPositionCalculated(editorView);
    if (selectionToolbarConfigEnabled && disableSelectionToolbarWhenPinned || !components || !toolbar) return null;
    if (!(isTextSelection || isCellSelection || isAllSelection) || currentUserIntent === 'dragging' || !shouldShowToolbar || currentUserIntent === 'blockMenuOpen' && (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true) || // hide toolbar when user intent is not default, except when it's dragHandleSelected without cell selection
    (0, $c31dddbd5a5304ff$export$e76971190b14d34a)(currentUserIntent, isCellSelection) || (0, $4iudd.isSSR)()) return null;
    const toolbarContent = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bFSJa.EditorToolbarProvider), {
        editorView: editorView,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        editorViewMode: editorViewMode ?? 'edit',
        isOffline: isOffline,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gnAkm.EditorToolbarUIProvider), {
            api: api,
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            fireAnalyticsEvent: (payload)=>{
                api?.analytics?.actions.fireAnalyticsEvent(payload);
            },
            keyboardNavigation: keyboardNavigation,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7CFSN.ToolbarModelRenderer), {
                toolbar: toolbar,
                components: components,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                fallbacks: {
                    section: (0, $cE5a1.ToolbarSection),
                    menuSection: (0, $jgJIe.ToolbarDropdownItemSection),
                    group: (0, $5AKbu.ToolbarButtonGroup)
                }
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        target: (0, $83cda40c9db7d284$export$49d74ed2464a12b9)(editorView),
        onPositionCalculated: onPositionCalculated,
        mountTo: mountPoint,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        children: (0, $4o0zT.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix') ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            onMouseUpCapture: onToolbarMouseUp,
            children: toolbarContent
        }) : toolbarContent
    });
};
const $2798a2ac57c73b6e$export$316d94f683c144f1 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, onToolbarMouseUp: onToolbarMouseUp })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
        component: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
        componentId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
        fallbackComponent: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($2798a2ac57c73b6e$export$5d706a9638468490, {
            api: api,
            editorView: editorView,
            mountPoint: mountPoint,
            disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned,
            onToolbarMouseUp: onToolbarMouseUp
        })
    });
};





parcelRequire("cozmU");





var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $bR6es = parcelRequire("bR6es");





parcelRequire("cozmU");





var $bq13E = parcelRequire("bq13E");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6TaGl = parcelRequire("6TaGl");

const $8e8d895bd5fa51b1$export$c07cde1baa478056 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing } = t0;
    let t1;
    if ($[0] !== color || $[1] !== label || $[2] !== shouldRecommendSmallIcon || $[3] !== spacing || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: label,
            testId: testId,
            color: color,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: "small"
        });
        $[0] = color;
        $[1] = label;
        $[2] = shouldRecommendSmallIcon;
        $[3] = spacing;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });


var $a6nzD = parcelRequire("a6nzD");

var $lslMH = parcelRequire("lslMH");

const $a236f42219f96f32$export$f62801e1786d0b09 = ({ children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    const tooltipContent = intl.formatMessage((0, $bq13E.toolbarMessages).selectionToolbarOverflowMenuTooltip);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        label: tooltipContent,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8e8d895bd5fa51b1$export$c07cde1baa478056), {
            label: ""
        }),
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent,
            position: "top"
        }),
        children: children
    });
};





parcelRequire("cozmU");







const $2801dfc07559d846$export$e3cf1fcb813fa9a4 = ({ children: children })=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    const isEdit = editorViewMode === 'edit';
    // only show separator in edit mode, when the pinned toolbar option is available
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};





parcelRequire("cozmU");







const $b7e555d5fe20ddd2$export$3590112bc75b92dc = ({ children: children, hasSeparator: hasSeparator, testId: testId })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cE5a1.ToolbarSection), {
        hasSeparator: hasSeparator,
        testId: testId,
        children: children
    });
};





parcelRequire("cozmU");










const $a3aadae827f35eaa$var$isFullPage = (editorAppearance)=>{
    return editorAppearance === 'full-page' || editorAppearance === 'full-width';
};
const $a3aadae827f35eaa$var$getBreakpointPreset = (breakpointPreset, editorAppearance)=>{
    if (breakpointPreset) return breakpointPreset;
    return editorAppearance && $a3aadae827f35eaa$var$isFullPage(editorAppearance) ? 'fullpage' : 'reduced';
};
const $a3aadae827f35eaa$export$7469f9986edfc2 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bR6es.PrimaryToolbar), {
        testId: (0, $ieeJu.expValEquals)('editor_a11y__primary-toolbar-aria-label_fy27', 'isEnabled', true) ? 'editor-primary-toolbar' : undefined,
        label: (0, $ieeJu.expValEquals)('editor_a11y__primary-toolbar-aria-label_fy27', 'isEnabled', true) ? undefined : 'Primary Toolbar',
        breakpointPreset: $a3aadae827f35eaa$var$getBreakpointPreset(breakpointPreset, editorAppearance),
        children: children
    });
};





parcelRequire("cozmU");












const $d755cfecb2685b2f$var$shouldShowSection = (editMode, toolbar, toolbarDocking, contextualFormattingEnabled)=>{
    if (editMode === 'view') return false;
    if (toolbar?.key === (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR) return toolbarDocking !== 'top' || contextualFormattingEnabled === 'always-inline';
    if (toolbar?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR) return toolbarDocking !== 'none' || contextualFormattingEnabled === 'always-pinned';
    return false;
};
const $d755cfecb2685b2f$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        editorAppearance: editorAppearance
    };
};
const $d755cfecb2685b2f$export$6e2c8f0811a474ce = ({ children: children, parents: parents, api: api, testId: testId, showSeparatorInFullPagePrimaryToolbar: showSeparatorInFullPagePrimaryToolbar, isSharedSection: isSharedSection = true })=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = $d755cfecb2685b2f$var$usePluginState(api);
    const runtimeOverride = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const toolbar = parents.find((parent)=>parent.type === 'toolbar');
    const contextualFormattingEnabled = runtimeOverride ?? api?.toolbar?.actions.contextualFormattingMode() ?? 'always-pinned';
    if (isSharedSection && !$d755cfecb2685b2f$var$shouldShowSection(editorViewMode, toolbar, editorToolbarDockingPreference, contextualFormattingEnabled)) return null;
    const isFullPage = editorAppearance === 'full-page';
    const hasSeparator = showSeparatorInFullPagePrimaryToolbar && isFullPage;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cE5a1.ToolbarSection), {
        testId: testId,
        hasSeparator: hasSeparator ? (0, $cE5a1.SeparatorPosition).START : hasSeparator,
        children: children
    });
};





parcelRequire("cozmU");








var $UL6rM = parcelRequire("UL6rM");





const $8ee373c639903b88$export$55607282fee51b86 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
            label: formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip),
            size: "small"
        }),
        enableMaxHeight: true,
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip)
        }),
        children: children
    });
};


const $dc255a55795cd388$var$getInlineTextToolbarComponents = ()=>{
    return [
        {
            type: 'toolbar',
            key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bR6es.Toolbar), {
                    label: (0, $d64b73b531f94eae$export$e235a0bccaa8a700),
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
                    testId: 'editor-floating-toolbar',
                    children: children
                });
            }
        }
    ];
};
const $dc255a55795cd388$var$getPrimaryToolbarComponents = (breakpointPreset)=>{
    return [
        {
            type: 'toolbar',
            key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $a3aadae827f35eaa$export$7469f9986edfc2), {
                    breakpointPreset: breakpointPreset,
                    children: children
                })
        }
    ];
};
const $dc255a55795cd388$export$a758406ca53b86a5 = (contextualFormattingEnabled, api, breakpointPreset)=>{
    const components = [
        {
            type: (0, $3nacY.TEXT_SECTION).type,
            key: (0, $3nacY.TEXT_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
            key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_SECTION_COLLAPSED).type,
            key: (0, $3nacY.TEXT_SECTION_COLLAPSED).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.TEXT_SECTION_COLLAPSED).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.TEXT_SECTION_COLLAPSED).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    below: "md",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_COLLAPSED_GROUP).type,
            key: (0, $3nacY.TEXT_COLLAPSED_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_COLLAPSED).type,
                    key: (0, $3nacY.TEXT_SECTION_COLLAPSED).key,
                    rank: 100
                }
            ]
        },
        {
            type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
            key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_GROUP).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_GROUP).key,
                    rank: 100
                }
            ],
            component: (0, $8ee373c639903b88$export$55607282fee51b86)
        },
        {
            type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
            key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.INSERT_BLOCK_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                    testId: "insert-block-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    isSharedSection: false,
                    children: children
                })
        },
        {
            type: (0, $3nacY.LINKING_SECTION).type,
            key: (0, $3nacY.LINKING_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.LINKING_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.LINKING_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                    testId: "link-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                })
        },
        {
            type: (0, $3nacY.OVERFLOW_SECTION).type,
            key: (0, $3nacY.OVERFLOW_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.OVERFLOW_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.OVERFLOW_GROUP).type,
            key: (0, $3nacY.OVERFLOW_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_SECTION).type,
                    key: (0, $3nacY.OVERFLOW_SECTION).key,
                    rank: (0, $hVLmg.OVERFLOW_SECTION_RANK)[(0, $3nacY.OVERFLOW_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.OVERFLOW_MENU).type,
            key: (0, $3nacY.OVERFLOW_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_GROUP).type,
                    key: (0, $3nacY.OVERFLOW_GROUP).key,
                    rank: (0, $hVLmg.OVERFLOW_GROUP_RANK)[(0, $3nacY.OVERFLOW_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a236f42219f96f32$export$f62801e1786d0b09), {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
            key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_MENU).type,
                    key: (0, $3nacY.OVERFLOW_MENU).key,
                    rank: (0, $hVLmg.OVERFLOW_MENU_RANK)[(0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key]
                }
            ],
            component: (0, $2801dfc07559d846$export$e3cf1fcb813fa9a4)
        },
        {
            type: (0, $3nacY.PIN_SECTION).type,
            key: (0, $3nacY.PIN_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.PIN_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                    testId: "pin-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                });
            }
        }
    ];
    components.push({
        type: (0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
        key: (0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7e555d5fe20ddd2$export$3590112bc75b92dc), {
                children: children
            });
        }
    }, {
        type: (0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
        key: (0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
                key: (0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
                rank: (0, $hVLmg.OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]
            }
        ]
    }, {
        type: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
        key: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
                key: (0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
                rank: (0, $hVLmg.OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a236f42219f96f32$export$f62801e1786d0b09), {
                children: children
            });
        }
    });
    switch(contextualFormattingEnabled){
        case 'always-inline':
            components.unshift(...$dc255a55795cd388$var$getInlineTextToolbarComponents());
            break;
        case 'always-pinned':
            components.unshift(...$dc255a55795cd388$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
        case 'controlled':
            components.unshift(...$dc255a55795cd388$var$getInlineTextToolbarComponents());
            components.unshift(...$dc255a55795cd388$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
    }
    components.push({
        type: (0, $3nacY.TRACK_CHANGES_SECTION).type,
        key: (0, $3nacY.TRACK_CHANGES_SECTION).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.TRACK_CHANGES_SECTION).key]
            }
        ],
        component: ({ children: children, parents: parents })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d755cfecb2685b2f$export$6e2c8f0811a474ce), {
                testId: "track-changes-section",
                parents: parents,
                api: api,
                showSeparatorInFullPagePrimaryToolbar: true,
                children: children
            });
        }
    });
    return components;
};



function $e556b244f5e65bf9$var$getSelectedNode(editorState) {
    const { selection: selection } = editorState;
    if (selection instanceof (0, $kCECX.NodeSelection)) return {
        node: selection.node,
        pos: selection.from,
        nodeType: selection.node.type.name,
        marks: selection.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const { nodes: nodes } = editorState.schema;
    const selectedNode = (0, $bjg0G.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.codeBlock
    ])(selection);
    if (selectedNode) return {
        node: selectedNode.node,
        pos: selectedNode.pos,
        nodeType: selectedNode.node.type.name,
        marks: selectedNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const parentNode = (0, $bjg0G.findParentNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.listItem,
        nodes.taskItem
    ])(selection);
    if (parentNode) return {
        node: parentNode.node,
        pos: parentNode.pos,
        nodeType: parentNode.node.type.name,
        marks: parentNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const $pos = selection.$from;
    return {
        node: $pos.parent,
        pos: $pos.pos,
        nodeType: $pos.parent.type.name,
        marks: $pos.marks().map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
}
const $e556b244f5e65bf9$export$2235d7d328f4404b = ({ api: api, config: config = {
    disableSelectionToolbar: false,
    disableSelectionToolbarWhenPinned: false
} })=>{
    const refs = {};
    const handleToolbarMouseUp = (event)=>{
        refs.toolbarMouseUpEvent = event.nativeEvent;
    };
    const { disableSelectionToolbar: disableSelectionToolbar, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, contextualFormattingEnabled: contextualFormattingEnabled = 'always-pinned', breakpointPreset: breakpointPreset } = config;
    const registry = (0, $f9e3d12e2bdb278a$export$34783ae4fef40269)();
    registry.register((0, $dc255a55795cd388$export$a758406ca53b86a5)(contextualFormattingEnabled, api, breakpointPreset));
    return {
        name: 'toolbar',
        actions: {
            registerComponents: (toolbarComponents, replaceItems = false)=>{
                if (replaceItems) registry.safeRegister(toolbarComponents);
                else registry.register(toolbarComponents);
            },
            // EDITOR-6558: `componentFilter` is evaluated at read time (not at
            // `registerComponents` time) so it can react to runtime state
            // (e.g. the current markdown view mode) without forcing every
            // plugin to re-register its components. Returning a new array on
            // every call means React-tree consumers re-render whenever the
            // underlying filter would change.
            getComponents: ()=>{
                return config?.componentFilter ? registry.components.filter(config.componentFilter) : registry.components;
            },
            contextualFormattingMode: ()=>{
                // Returns the config-time mode only. The runtime override
                // (`EditorToolbarPluginState.contextualFormattingModeOverride`)
                // lives in PM state and must be merged in by the React render
                // site — see SelectionToolbar / Section / FullPageToolbarNext for
                // the `runtimeOverride ?? action() ?? 'always-pinned'` pattern.
                // Doing the merge here would require closure-capturing `editorView`,
                // which races with StrictMode double-mount.
                return config?.contextualFormattingModeOverride?.() ?? contextualFormattingEnabled ?? 'always-pinned';
            },
            getBreakpointPreset: ()=>{
                return breakpointPreset;
            }
        },
        commands: {
            setContextualFormattingModeOverride: (mode)=>{
                return ({ tr: tr })=>{
                    tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                        contextualFormattingModeOverride: mode
                    });
                    return tr;
                };
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $erHVE.editorToolbarPluginKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'editor-toolbar-selection',
                    plugin: ()=>{
                        // Tracks mouse-down state to prevent the focus event (first page load)
                        // from prematurely showing the toolbar mid-drag
                        const mouseState = {
                            isMouseDown: false
                        };
                        return new (0, $kpCD8.SafePlugin)({
                            key: (0, $erHVE.editorToolbarPluginKey),
                            state: {
                                init (_, editorState) {
                                    return {
                                        shouldShowToolbar: false,
                                        selectedNode: $e556b244f5e65bf9$var$getSelectedNode(editorState),
                                        contextualFormattingModeOverride: undefined
                                    };
                                },
                                apply (tr, pluginState, _, newState) {
                                    const meta = tr.getMeta((0, $erHVE.editorToolbarPluginKey));
                                    let newPluginState = {
                                        ...pluginState
                                    };
                                    const shouldUpdateNode = tr.docChanged || tr.selectionSet;
                                    if (shouldUpdateNode) {
                                        const newSelectedNode = $e556b244f5e65bf9$var$getSelectedNode(newState);
                                        const oldNode = pluginState.selectedNode;
                                        const hasNodeChanged = !oldNode || !newSelectedNode || oldNode.nodeType !== newSelectedNode.nodeType || oldNode.pos !== newSelectedNode.pos || JSON.stringify(oldNode.marks) !== JSON.stringify(newSelectedNode.marks);
                                        if (hasNodeChanged) newPluginState.selectedNode = newSelectedNode;
                                    }
                                    if (meta) {
                                        const { contextualFormattingModeOverride: contextualFormattingModeOverride, ...rest } = meta;
                                        // Only forward the override when the meta actually carries
                                        // the key — unrelated metas (mouseup / focus / mousedown
                                        // from the view() listeners) destructure it as `undefined`
                                        // and would otherwise wipe a previously-set override on
                                        // every interaction.
                                        newPluginState = {
                                            ...newPluginState,
                                            ...rest,
                                            ...'contextualFormattingModeOverride' in meta ? {
                                                contextualFormattingModeOverride: contextualFormattingModeOverride
                                            } : {}
                                        };
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $cbY7C.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: function(ev) {
                                        mouseState.isMouseDown = false;
                                        const event = ev;
                                        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix')) {
                                            // Scope mouseups to this editor and its React-portaled toolbar.
                                            const isMouseUpInOwnedToolbar = refs.toolbarMouseUpEvent === event;
                                            const isMouseUpInEditor = event.composedPath().includes(view.dom);
                                            refs.toolbarMouseUpEvent = undefined;
                                            // Prevent outside clicks from reopening a blurred editor's toolbar.
                                            const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                            const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                            // Include focus in nested editable islands when enabled.
                                            const hasEditorFocus = (0, $iDrrr.fg)('platform_editor_blocks_patch_7') ? view.hasFocus() || view.dom.contains(view.root.activeElement) : view.hasFocus();
                                            const shouldShowToolbar = isViewModeEnabled ? isMouseUpInEditor || isMouseUpInOwnedToolbar : hasEditorFocus || isMouseUpInOwnedToolbar;
                                            view.dispatch(view.state.tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                                                shouldShowToolbar: shouldShowToolbar
                                            }));
                                            return;
                                        }
                                        const isInToolbar = (0, $0193b6c1578a5c29$export$3985dc3e1cbf9fe4)(event, (0, $d64b73b531f94eae$export$c0535c9204f67376).toolbarContainer);
                                        const isInPortal = (0, $0193b6c1578a5c29$export$3985dc3e1cbf9fe4)(event, (0, $d64b73b531f94eae$export$c0535c9204f67376).portal);
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        // Focus can sit inside a nested editable region ProseMirror does not own -
                                        // such as a reference synced block's island - where `view.hasFocus()` is
                                        // false but the user is still interacting with the editor.
                                        const hasEditorFocus = (0, $iDrrr.fg)('platform_editor_blocks_patch_7') ? view.hasFocus() || view.dom.contains(view.root.activeElement) : view.hasFocus();
                                        view.dispatch(view.state.tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                                            shouldShowToolbar: !isViewModeEnabled ? hasEditorFocus || isInToolbar || isInPortal : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $cbY7C.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        // On first page load, focus fires after mousedown — skip to
                                        // avoid showing the toolbar mid-drag
                                        if (mouseState.isMouseDown) return;
                                        view.dispatch(view.state.tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                                            shouldShowToolbar: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        mouseState.isMouseDown = true;
                                        view.dispatch(view.state.tr.setMeta((0, $erHVE.editorToolbarPluginKey), {
                                            shouldShowToolbar: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                },
                ...!disableSelectionToolbar ? [
                    {
                        name: 'selectionToolbarOpenExperience',
                        plugin: ()=>(0, $3e937741a8caac79$export$cfe4aed4f8555228)({
                                refs: refs,
                                dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload),
                                getCurrentUserIntent: ()=>api?.userIntent?.sharedState.currentState()?.currentUserIntent
                            })
                    }
                ] : []
            ];
        },
        contentComponent: !disableSelectionToolbar ? ({ editorView: editorView, popupsMountPoint: popupsMountPoint })=>{
            refs.popupsMountPoint = popupsMountPoint || undefined;
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2798a2ac57c73b6e$export$316d94f683c144f1), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned ?? false,
                onToolbarMouseUp: handleToolbarMouseUp
            });
        } : undefined
    };
};
module.exports["toolbarPlugin"] = $e556b244f5e65bf9$export$2235d7d328f4404b;

});

parcelRegister("abOD2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $iDrrr = parcelRequire("iDrrr");


var $8mvho = parcelRequire("8mvho");


var $1Iyfh = parcelRequire("1Iyfh");


var $jkcNT = parcelRequire("jkcNT");





var $eEdSM = parcelRequire("eEdSM");


var $6SJ6d = parcelRequire("6SJ6d");

// NOTE: The string values below intentionally duplicate the values of the
// matching `INPUT_METHOD` members in `@atlaskit/editor-common/analytics`
// (`TOOLBAR='toolbar'`, `KEYBOARD='keyboard'`, `EXTERNAL='external'`).
// Under TypeScript's `--isolatedDeclarations`, enum member initializers cannot
// reference external symbols (TS9020), so we cannot write
// `TOOLBAR = INPUT_METHOD.TOOLBAR`. If you change a value here, update the
// corresponding `INPUT_METHOD` member to match — these strings are written
// straight into transaction meta in `attach-input-meta.ts` and surface as
// the `historyTriggerMethod` analytics attribute (asserted in
// `editor-plugin-undo-redo-tests/.../analytics-input-method.ts`).
var $e23341615a849f80$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource["TOOLBAR"] = "toolbar";
    InputSource["KEYBOARD"] = "keyboard";
    InputSource["EXTERNAL"] = "external";
    return InputSource;
}({});



var $kCECX = parcelRequire("kCECX");

const $b5ea9acd5ee7600a$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('undoRedoPlugin');


const $0f84072f0ead6fe5$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $b5ea9acd5ee7600a$export$18d4026d1ea86bb1), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };
const $0f84072f0ead6fe5$var$inputSourceToInputMethod = (inputSource)=>{
    switch(inputSource){
        case (0, $e23341615a849f80$export$c3de12c0810a343d).EXTERNAL:
            return (0, $krYZG.INPUT_METHOD).EXTERNAL;
        case (0, $e23341615a849f80$export$c3de12c0810a343d).KEYBOARD:
            return (0, $krYZG.INPUT_METHOD).KEYBOARD;
        case (0, $e23341615a849f80$export$c3de12c0810a343d).TOOLBAR:
            return (0, $krYZG.INPUT_METHOD).TOOLBAR;
        default:
            return (0, $krYZG.INPUT_METHOD).EXTERNAL;
    }
};
function $0f84072f0ead6fe5$var$getNodesWithDifferingAttributes({ before: before, after: after }) {
    const allAttributeKeys = Object.keys({
        ...before.attrs,
        ...after.attrs
    });
    const differingAttributes = allAttributeKeys.filter((key)=>before.attrs[key] !== after.attrs[key]);
    const affectedNodes = differingAttributes.length ? [
        {
            type: before.type.name,
            attributes: differingAttributes
        }
    ] : [];
    return before.children.reduce((acc, beforeChild, index)=>[
            ...acc,
            ...$0f84072f0ead6fe5$var$getNodesWithDifferingAttributes({
                before: beforeChild,
                after: after.child(index)
            })
        ], affectedNodes);
}
function $0f84072f0ead6fe5$export$db14845dcbb6e6df({ before: before, after: after }) {
    const hasChanged = !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(after, before);
    const affectedNodes = hasChanged ? undefined : $0f84072f0ead6fe5$var$getNodesWithDifferingAttributes({
        before: before,
        after: after
    })// Limit to 25 nodes to avoid oversize payloads
    .slice(0, 25);
    return {
        hasChanged: hasChanged,
        affectedNodes: affectedNodes
    };
}
const $0f84072f0ead6fe5$export$5b05f10224c3caf8 = (editorAnalyticsAPI)=>(inputSource, action)=>(command)=>$0f84072f0ead6fe5$export$84d159245233a2bb(inputSource)((0, $eEdSM.withAnalytics)(editorAnalyticsAPI, ({ doc: before }, { currentDoc: after })=>({
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        inputMethod: $0f84072f0ead6fe5$var$inputSourceToInputMethod(inputSource),
                        ...$0f84072f0ead6fe5$export$db14845dcbb6e6df({
                            before: before,
                            after: after
                        })
                    }
                }))(command));




var $ldqjS = parcelRequire("ldqjS");





var $44cyU = parcelRequire("44cyU");












const $9cc992287d751c65$export$1d1a6834315b2876 = (0, $0f84072f0ead6fe5$export$84d159245233a2bb)((0, $e23341615a849f80$export$c3de12c0810a343d).KEYBOARD)((0, $1Iyfh.undo));
const $9cc992287d751c65$export$b51f9da6d7e523d2 = (0, $0f84072f0ead6fe5$export$84d159245233a2bb)((0, $e23341615a849f80$export$c3de12c0810a343d).KEYBOARD)((0, $8mvho.redo));
const $9cc992287d751c65$export$841850d252e034f0 = (0, $0f84072f0ead6fe5$export$84d159245233a2bb)((0, $e23341615a849f80$export$c3de12c0810a343d).TOOLBAR)((0, $1Iyfh.undo));
const $9cc992287d751c65$export$11ad0a77a5cc0ccf = (0, $0f84072f0ead6fe5$export$84d159245233a2bb)((0, $e23341615a849f80$export$c3de12c0810a343d).TOOLBAR)((0, $8mvho.redo));
const $9cc992287d751c65$export$4c45d895aa8430e8 = (editorAnalyticsAPI)=>(0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $e23341615a849f80$export$c3de12c0810a343d).KEYBOARD, (0, $krYZG.ACTION).UNDO_PERFORMED)((0, $1Iyfh.undo));
const $9cc992287d751c65$export$1f3073e8f226f307 = (editorAnalyticsAPI)=>(0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $e23341615a849f80$export$c3de12c0810a343d).KEYBOARD, (0, $krYZG.ACTION).REDO_PERFORMED)((0, $8mvho.redo));
const $9cc992287d751c65$export$a9ef7677c700995e = (editorAnalyticsAPI)=>(0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $e23341615a849f80$export$c3de12c0810a343d).TOOLBAR, (0, $krYZG.ACTION).UNDO_PERFORMED)((0, $1Iyfh.undo));
const $9cc992287d751c65$export$1746c262152d0cc4 = (editorAnalyticsAPI)=>(0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $e23341615a849f80$export$c3de12c0810a343d).TOOLBAR, (0, $krYZG.ACTION).REDO_PERFORMED)((0, $8mvho.redo));


function $275dc7992dbb8815$export$e832373cff8dec22(api) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findKeyMapForBrowser)((0, $ldqjS.redo)), (0, $9cc992287d751c65$export$1f3073e8f226f307)(api?.analytics?.actions), list);
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findKeyMapForBrowser)((0, $ldqjS.redoAlt)), (0, $9cc992287d751c65$export$1f3073e8f226f307)(api?.analytics?.actions), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.undo).common, (0, $9cc992287d751c65$export$4c45d895aa8430e8)(api?.analytics?.actions), list);
    return new (0, $kpCD8.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $ldqjS.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $44cyU.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}






const $8621a68b3ffe4112$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $b5ea9acd5ee7600a$export$18d4026d1ea86bb1)
    });
};


const $11a350ed42a7d491$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        if (!editorView) return false;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
        return true;
    };
const $11a350ed42a7d491$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $11a350ed42a7d491$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");





var $bOjiE = parcelRequire("bOjiE");


var $9iFhC = parcelRequire("9iFhC");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $bAKDg = parcelRequire("bAKDg");


var $kUFQ0 = parcelRequire("kUFQ0");



const $884ced8a38161d81$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { canRedo: canRedo, canUndo: canUndo } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canUndo: states.historyState?.canUndo,
            canRedo: states.historyState?.canRedo
        }));
    const handleUndo = ()=>{
        (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorView, api)((0, $9cc992287d751c65$export$a9ef7677c700995e)(api?.analytics?.actions));
    };
    const handleRedo = ()=>{
        (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorView, api)((0, $9cc992287d751c65$export$1746c262152d0cc4)(api?.analytics?.actions));
    };
    const labelUndo = formatMessage((0, $bOjiE.messages).undo);
    const labelRedo = formatMessage((0, $bOjiE.messages).redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $9iFhC.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.undo), labelUndo),
        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.undo)),
        title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $ldqjS.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: labelRedo,
            keymap: (0, $ldqjS.redoAlt)
        }),
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAKDg))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.redoAlt), labelRedo),
        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.redoAlt))
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $9iFhC.separatorStyles)
    })));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $884ced8a38161d81$var$_default_1 = (0, $kSwu1.injectIntl)($884ced8a38161d81$export$4a0f2fb817767d20);
var $884ced8a38161d81$export$2e2bcd8739ae039 = $884ced8a38161d81$var$_default_1;





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");




parcelRequire("cozmU");














var $bFSJa = parcelRequire("bFSJa");




var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");



const $4a47ab3fc26aa37a$export$de10bfe090602e0a = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { canRedo: canRedo } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canRedo: states.historyState?.canRedo
        }));
    const handleRedo = ()=>{
        if (editorView) (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorView, api)((0, $9cc992287d751c65$export$1746c262152d0cc4)(api?.analytics?.actions));
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $bOjiE.messages).redo),
            keymap: (0, $ldqjS.redo)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAKDg))), {
                label: formatMessage((0, $bOjiE.messages).redo),
                size: "small"
            }),
            onClick: handleRedo,
            isDisabled: !canRedo,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.redo)),
            testId: "ak-editor-toolbar-button-redo"
        })
    });
};





parcelRequire("cozmU");

























const $83c5e9d712b82921$export$f2500353cb92e6ec = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { canUndo: canUndo } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canUndo: states.historyState?.canUndo
        }));
    const handleUndo = ()=>{
        if (editorView) (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorView, api)((0, $9cc992287d751c65$export$a9ef7677c700995e)(api?.analytics?.actions));
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $bOjiE.messages).undo),
            keymap: (0, $ldqjS.undo)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
                label: formatMessage((0, $bOjiE.messages).undo),
                size: "small"
            }),
            onClick: handleUndo,
            isDisabled: !canUndo,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.undo)),
            testId: "ak-editor-toolbar-button-undo"
        })
    });
};


const $338430e67f389845$export$a758406ca53b86a5 = (api)=>{
    const breakpointPreset = api?.toolbar?.actions.getBreakpointPreset();
    return [
        {
            type: (0, $3nacY.UNDO_CHANGES_GROUP).type,
            key: (0, $3nacY.UNDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TRACK_CHANGES_SECTION).type,
                    key: (0, $3nacY.TRACK_CHANGES_SECTION).key,
                    rank: (0, $hVLmg.TRACK_CHANGES_SECTION_RANK)[(0, $3nacY.UNDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $3nacY.UNDO_BUTTON).type,
            key: (0, $3nacY.UNDO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.UNDO_CHANGES_GROUP).type,
                    key: (0, $3nacY.UNDO_CHANGES_GROUP).key,
                    rank: (0, $hVLmg.UNDO_CHANGES_GROUP_RANK)[(0, $3nacY.UNDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $83c5e9d712b82921$export$f2500353cb92e6ec), {
                    api: api
                })
        },
        {
            type: (0, $3nacY.REDO_CHANGES_GROUP).type,
            key: (0, $3nacY.REDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TRACK_CHANGES_SECTION).type,
                    key: (0, $3nacY.TRACK_CHANGES_SECTION).key,
                    rank: (0, $hVLmg.TRACK_CHANGES_SECTION_RANK)[(0, $3nacY.REDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $3nacY.REDO_BUTTON).type,
            key: (0, $3nacY.REDO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.REDO_CHANGES_GROUP).type,
                    key: (0, $3nacY.REDO_CHANGES_GROUP).key,
                    rank: (0, $hVLmg.REDO_CHANGES_GROUP_RANK)[(0, $3nacY.REDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4a47ab3fc26aa37a$export$de10bfe090602e0a), {
                    api: api
                })
        }
    ];
};


const $366b8a1768fbb384$export$dcdc7fc7ecd3098 = ({ api: api, config: config })=>{
    const showToolbarButton = config?.showToolbarButton ?? true;
    const editorViewRef = {
        current: null
    };
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $884ced8a38161d81$export$2e2bcd8739ae039), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    if ((0, $iDrrr.fg)('platform_editor_ai_add_undoredo_jira')) {
        if (showToolbarButton) {
            if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $338430e67f389845$export$a758406ca53b86a5)(api));
            else api?.primaryToolbar?.actions.registerComponent({
                name: 'undoRedoPlugin',
                component: primaryToolbarComponent
            });
        }
    } else if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $338430e67f389845$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    const handleUndo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorViewRef.current, api)((0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(api?.analytics?.actions)(inputSource || (0, $e23341615a849f80$export$c3de12c0810a343d).EXTERNAL, (0, $krYZG.ACTION).UNDO_PERFORMED)((0, $1Iyfh.undo)));
    };
    const handleRedo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $11a350ed42a7d491$export$4126ecb6f20789f0)(editorViewRef.current, api)((0, $0f84072f0ead6fe5$export$5b05f10224c3caf8)(api?.analytics?.actions)(inputSource || (0, $e23341615a849f80$export$c3de12c0810a343d).EXTERNAL, (0, $krYZG.ACTION).REDO_PERFORMED)((0, $8mvho.redo)));
    };
    const showPrimaryToolbarComponent = (0, $iDrrr.fg)('platform_editor_ai_add_undoredo_jira') ? !api?.primaryToolbar && !isToolbarAIFCEnabled && showToolbarButton : !api?.primaryToolbar && !isToolbarAIFCEnabled;
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $275dc7992dbb8815$export$e832373cff8dec22)(api)
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $8621a68b3ffe4112$export$ae829ec7b2625219)(options)
                }
            ];
            if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $kpCD8.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: showPrimaryToolbarComponent ? primaryToolbarComponent : undefined
    };
};
module.exports["undoRedoPlugin"] = $366b8a1768fbb384$export$dcdc7fc7ecd3098;

});

parcelRegister("cjuKO", function(module, exports) {

var $g185T = parcelRequire("g185T");


var $1E9VS = parcelRequire("1E9VS");


var $egqI8 = parcelRequire("egqI8");


var $kwL1e = parcelRequire("kwL1e");


var $bliHm = parcelRequire("bliHm");


var $jZlhw = parcelRequire("jZlhw");


var $Igylv = parcelRequire("Igylv");

var $3k3tn = parcelRequire("3k3tn");


var $kpCD8 = parcelRequire("kpCD8");


var $KTiWz = parcelRequire("KTiWz");


var $kCECX = parcelRequire("kCECX");


var $4o0zT = parcelRequire("4o0zT");


var $cbY7C = parcelRequire("cbY7C");


var $krYZG = parcelRequire("krYZG");


var $bHKSU = parcelRequire("bHKSU");


var $68mo7 = parcelRequire("68mo7");


var $1H5A4 = parcelRequire("1H5A4");


var $h1Peg = parcelRequire("h1Peg");


var $aPdNQ = parcelRequire("aPdNQ");

function $e2a0a3e38abae58e$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        // `confluenceUnsupportedBlock` and `confluenceUnsupportedInline` are declared with a
        // `cxhtml` attribute and no `originalValue`, so this must not assume it exists.
        //
        // NOTE: intentional deviation from the `@atlaskit/editor-common` original, which throws a
        // TypeError for those node types. In the React node views that throw is swallowed by
        // `ReactNodeView`'s ErrorBoundary; a vanilla node view has no such boundary, so it would
        // propagate out of the ProseMirror node view constructor. Keep this guard when the
        // duplication is resolved.
        //
        // @see https://hello.jira.atlassian.cloud/jira/browse/EDITOR-8637
        const { originalValue: originalValue } = node.attrs;
        if (originalValue) {
            if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
                finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
                canTranslateToLocale = false;
            } else if (originalValue.type) {
                finalMessage = `${prefix} ${originalValue.type}`;
                canTranslateToLocale = false;
            }
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}


// Question circle icon SVG — source: @atlaskit/icon/core/question-circle.
const $d9fd69c381a319a3$var$QUESTION_ICON_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" style="display:block">
  <path fill="currentColor" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1"/>
  <path fill="currentColor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>`;
/**
 * Parsing the SVG markup is the same work for every unsupported node, so the template is
 * built once and reused.
 *
 * Only the parse is cached: appending a `DocumentFragment` moves its children out of it, so
 * each caller needs its own clone — sharing one fragment would leave every icon after the
 * first empty.
 */ const $d9fd69c381a319a3$var$getIconFragment = (()=>{
    let template;
    return ()=>{
        if (!template) {
            template = document.createElement('template');
            template.innerHTML = $d9fd69c381a319a3$var$QUESTION_ICON_SVG;
        }
        return template.content.cloneNode(true);
    };
})();
function $d9fd69c381a319a3$export$a9413459ee06c46a(iconClassName) {
    return [
        'span',
        {
            class: iconClassName,
            role: 'img',
            'aria-label': '?'
        },
        $d9fd69c381a319a3$var$getIconFragment()
    ];
}


/**
 * CSS class names for the vanilla unsupported block node view elements.
 * Corresponding styles are defined in EditorContentContainer (gated behind
 * the platform_editor_vanilla_node_views_phase1 experiment).
 *
 * ⚠️ Renaming any of these requires the same change in BOTH copies of the styles:
 *  - `editor-core/src/ui/EditorContentContainer/styles/unsupportedStyles.ts` (emotion)
 *  - `editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx` (cssMap)
 *
 * These cannot be imported by either stylesheet: `cssMap` keys must be statically defined, so
 * the compiled copy hardcodes the strings — as it already does for `UnsupportedSharedCssClassName`.
 * A rename that misses a stylesheet fails loudly in the unsupported-content VR tests, which
 * assert the styled output rather than the class names.
 */ const $112617a02575e185$var$VanillaUnsupportedCssClassName = {
    BLOCK_INNER: 'unsupported-block-vanilla-inner',
    ICON: 'unsupported-vanilla-icon'
};
const $112617a02575e185$var$TOOLTIP_CLASS_NAME = 'unsupported-content-tooltip';
/** Distinct from the inline node view's prefix, so the counter fallback below cannot collide. */ const $112617a02575e185$var$TOOLTIP_ID_PREFIX = 'unsupported-block-content-tooltip';
/** Classes applied to the tooltip element: the shared default look, plus our own hook. */ const $112617a02575e185$var$TOOLTIP_CLASS_NAMES = `${(0, $h1Peg.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$112617a02575e185$var$TOOLTIP_CLASS_NAME}`;
/**
 * `crypto.randomUUID()` is undefined outside a secure context. The counter is not the best
 * fallback, but given how widely available the crypto API is, it should be fine.
 *
 * Ideally `VanillaTooltip` would take an optional id and generate its own when one is not
 * supplied, rather than leaving this to every caller.
 */ const $112617a02575e185$var$nextTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$112617a02575e185$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$112617a02575e185$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
/**
 * Spec for an unsupported block node.
 *
 * The outer wrapper carries the shared CSS class so selection and cursor styles apply.
 * The inner element's `unsupported` class is retained for parity with the React
 * implementation, which products and tests may still select on.
 */ function $112617a02575e185$var$getBlockSpec(label) {
    return [
        'div',
        {
            class: (0, $68mo7.UnsupportedSharedCssClassName).BLOCK_CONTAINER
        },
        [
            'div',
            {
                class: `unsupported ${$112617a02575e185$var$VanillaUnsupportedCssClassName.BLOCK_INNER}`
            },
            [
                'span',
                {},
                label
            ],
            (0, $d9fd69c381a319a3$export$a9413459ee06c46a)($112617a02575e185$var$VanillaUnsupportedCssClassName.ICON)
        ]
    ];
}
/**
 * Creates the DOM structure for an unsupported content node view.
 *
 * Matches the React version's two-level structure:
 *   outer wrapper (gets the shared CSS class — unsupportedBlockView-content-wrap)
 *     └── inner div (gets visual styles from EditorContentContainer CSS)
 *           ├── text label (span)
 *           └── icon (span, tooltip trigger)
 *
 * Visual styles (background, border, flex) are applied via EditorContentContainer CSS on
 * `.unsupportedBlockView-content-wrap > div`, matching how the existing selection/cursor
 * styles already work.
 */ function $112617a02575e185$var$createUnsupportedDOM(node, intl) {
    const label = (0, $e2a0a3e38abae58e$export$d4ded51d0f0bd2df)((0, $bHKSU.unsupportedContentMessages).unsupportedBlockContent, `${(0, $bHKSU.unsupportedContentMessages).unsupportedBlockContent.defaultMessage}:`, node, intl);
    const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $112617a02575e185$var$getBlockSpec(label));
    const domElement = dom instanceof HTMLElement ? dom : undefined;
    const icon = domElement?.querySelector(`.${$112617a02575e185$var$VanillaUnsupportedCssClassName.ICON}`) ?? null;
    return {
        dom: dom,
        icon: icon
    };
}
class $112617a02575e185$export$9d67847ab5f2260 {
    update(node) {
        if (node.type !== this.node.type) return false;
        // originalValue attrs are immutable — label never changes.
        // Track node reference so analytics can read the latest attrs.
        this.node = node;
        return true;
    }
    destroy() {
        this.tooltip?.destroy();
        this.tooltip = null;
        this.unbindMouseenter?.();
        this.unbindMouseenter = null;
    }
    constructor(node, intl, dispatchAnalyticsEvent){
        this.dom = void 0;
        this.node = void 0;
        this.tooltip = null;
        this.unbindMouseenter = null;
        this.node = node;
        const { dom: dom, icon: icon } = $112617a02575e185$var$createUnsupportedDOM(node, intl);
        this.dom = dom;
        if (!icon) return;
        // Lazy-init: create the VanillaTooltip on first mouseenter.
        // Inline styles are required because the Popover API promotes the tooltip to the
        // browser's top layer, where ancestor CSS selectors cannot reach it.
        const initTooltip = (event)=>{
            // Unbind before re-dispatching below, so this listener is not re-entered by the
            // synthetic event. Matches `EmojiNodeView`.
            this.unbindMouseenter?.();
            this.unbindMouseenter = null;
            const tooltipText = intl.formatMessage((0, $bHKSU.unsupportedContentMessages).unsupportedContentTooltip);
            this.tooltip = new (0, $h1Peg.VanillaTooltip)(icon, tooltipText, $112617a02575e185$var$nextTooltipId(), $112617a02575e185$var$TOOLTIP_CLASS_NAMES, 300, // Styling comes from the classes above, defined in the EditorContentContainer stylesheets.
            undefined, // Fired once the tooltip is actually visible, rather than on hover intent, so the
            // analytics match the React implementation's `<Tooltip onShow>`.
            dispatchAnalyticsEvent ? ()=>(0, $1H5A4.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, this.node?.attrs?.originalValue?.type) : undefined);
            // VanillaTooltip binds its own `mouseenter` listener inside its constructor.
            // Listeners added while an event is being dispatched are not invoked for that
            // same event, so without re-dispatching, the tooltip would stay hidden until
            // the user hovered away and back. Matches `EmojiNodeView`, which lazy-inits
            // the same way.
            icon.dispatchEvent(new Event(event.type));
        };
        this.unbindMouseenter = (0, $cbY7C.bind)(icon, {
            type: 'mouseenter',
            listener: initTooltip,
            options: {
                once: true
            }
        });
    }
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3F4bj = parcelRequire("3F4bj");

const $285bc0eff429c08e$export$b963567668795b80 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3F4bj.default), props);
};









var $8dxef = parcelRequire("8dxef");











var $fngNp = parcelRequire("fngNp");






const $86a03afdabda4516$var$VanillaUnsupportedInlineCssClassName = {
    INNER: 'unsupported-inline-vanilla-inner',
    ICON: 'unsupported-vanilla-icon'
};
/** Identifies this tooltip for tests and debugging. */ const $86a03afdabda4516$var$TOOLTIP_CLASS_NAME = 'unsupported-content-tooltip';
/** Distinct from the block node view's prefix, so the counter fallback below cannot collide. */ const $86a03afdabda4516$var$TOOLTIP_ID_PREFIX = 'unsupported-inline-content-tooltip';
/** Classes applied to the tooltip element: the shared default look, plus our own hook. */ const $86a03afdabda4516$var$TOOLTIP_CLASS_NAMES = `${(0, $h1Peg.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$86a03afdabda4516$var$TOOLTIP_CLASS_NAME}`;
const $86a03afdabda4516$var$INLINE_NODE_VIEW_CLASS_NAME = 'inlineNodeView';
const $86a03afdabda4516$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME = 'zeroWidthSpaceContainer';
const $86a03afdabda4516$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME = `${$86a03afdabda4516$var$INLINE_NODE_VIEW_CLASS_NAME}AddZeroWidthSpace`;
const $86a03afdabda4516$var$nextTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$86a03afdabda4516$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$86a03afdabda4516$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
function $86a03afdabda4516$var$getInlineSpec(node, label) {
    const browser = (0, $8dxef.getBrowserInfo)();
    const trailingSpec = browser.android ? [
        'span',
        {
            class: $86a03afdabda4516$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME,
            contentEditable: 'false'
        },
        [
            'span',
            {
                class: $86a03afdabda4516$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
            }
        ],
        (0, $fngNp.ZERO_WIDTH_SPACE)
    ] : [
        'span',
        {
            class: $86a03afdabda4516$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
        }
    ];
    return [
        'span',
        {
            class: `${node.type.name}View-content-wrap ${$86a03afdabda4516$var$INLINE_NODE_VIEW_CLASS_NAME}`,
            contentEditable: 'false'
        },
        [
            'span',
            {
                class: $86a03afdabda4516$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME
            },
            [
                'span',
                {
                    class: $86a03afdabda4516$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
                }
            ],
            (0, $fngNp.ZERO_WIDTH_SPACE)
        ],
        [
            'span',
            {
                class: $86a03afdabda4516$var$VanillaUnsupportedInlineCssClassName.INNER
            },
            label,
            (0, $d9fd69c381a319a3$export$a9413459ee06c46a)($86a03afdabda4516$var$VanillaUnsupportedInlineCssClassName.ICON)
        ],
        trailingSpec
    ];
}
function $86a03afdabda4516$var$createUnsupportedInlineDOM(node, intl) {
    const label = (0, $e2a0a3e38abae58e$export$d4ded51d0f0bd2df)((0, $bHKSU.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $86a03afdabda4516$var$getInlineSpec(node, label));
    const domElement = dom instanceof HTMLElement ? dom : undefined;
    const icon = domElement?.querySelector(`.${$86a03afdabda4516$var$VanillaUnsupportedInlineCssClassName.ICON}`) ?? null;
    return {
        dom: dom,
        icon: icon
    };
}
class $86a03afdabda4516$export$81269ac65e4cceef {
    update(node) {
        if (node.type !== this.node.type) return false;
        if (!this.node.sameMarkup(node)) return false;
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        return mutation.type !== 'selection';
    }
    destroy() {
        this.tooltip?.destroy();
        this.tooltip = null;
        this.unbindMouseenter?.();
        this.unbindMouseenter = null;
    }
    constructor(node, intl, dispatchAnalyticsEvent){
        this.dom = void 0;
        this.node = void 0;
        this.tooltip = null;
        this.unbindMouseenter = null;
        this.node = node;
        const { dom: dom, icon: icon } = $86a03afdabda4516$var$createUnsupportedInlineDOM(node, intl);
        this.dom = dom;
        if (!icon) return;
        this.unbindMouseenter = (0, $cbY7C.bind)(icon, {
            type: 'mouseenter',
            options: {
                once: true
            },
            listener: (event)=>{
                this.unbindMouseenter?.();
                this.unbindMouseenter = null;
                const tooltipText = intl.formatMessage((0, $bHKSU.unsupportedContentMessages).unsupportedContentTooltip);
                this.tooltip = new (0, $h1Peg.VanillaTooltip)(icon, tooltipText, $86a03afdabda4516$var$nextTooltipId(), $86a03afdabda4516$var$TOOLTIP_CLASS_NAMES, 300, // Use default style by having the default tooltip class name.
                undefined, ()=>{
                    if (dispatchAnalyticsEvent) (0, $1H5A4.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, this.node?.attrs?.originalValue?.type);
                });
                icon.dispatchEvent(new Event(event.type));
            }
        });
    }
}


const $ba4ce9343e939227$var$pluginKey = new (0, $kCECX.PluginKey)('unsupportedContentPlugin');
const $ba4ce9343e939227$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getIntl: getIntl } = pmPluginFactoryParams;
    const intl = getIntl();
    return new (0, $kpCD8.SafePlugin)({
        key: $ba4ce9343e939227$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $112617a02575e185$export$9d67847ab5f2260)(node, intl, dispatchAnalyticsEvent) : (0, $Igylv.default).fromComponent((0, $KTiWz.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $86a03afdabda4516$export$81269ac65e4cceef)(node, intl, dispatchAnalyticsEvent) : (0, $3k3tn.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $285bc0eff429c08e$export$b963567668795b80),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $112617a02575e185$export$9d67847ab5f2260)(node, intl, dispatchAnalyticsEvent) : (0, $Igylv.default).fromComponent((0, $KTiWz.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $86a03afdabda4516$export$81269ac65e4cceef)(node, intl, dispatchAnalyticsEvent) : (0, $3k3tn.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $285bc0eff429c08e$export$b963567668795b80),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
const $ba4ce9343e939227$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $bliHm.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $jZlhw.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $g185T.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $1E9VS.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $egqI8.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $kwL1e.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $ba4ce9343e939227$var$createPlugin
                }
            ];
        }
    });
module.exports["unsupportedContentPlugin"] = $ba4ce9343e939227$export$fae834324d89b92;

});

parcelRegister("h1Peg", function(module, exports) {

var $kdxSx = parcelRequire("kdxSx");


var $cbY7C = parcelRequire("cbY7C");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");

/**
 * UNSAFE compatibility entry point. `createPopper` for non-React, imperative
 * consumers moving direct `@popperjs/core` dependency ownership onto
 * `@atlaskit/popper`.
 *
 * Do not use this for new code. New overlays should build on
 * `@atlaskit/top-layer` directly: `Popover` + `useAnchorPosition`. top-layer
 * has no imperative positioning API and is not getting one — see
 * `top-layer/notes/migrations/popper-migration.md` -> "Decision: popper brings
 * its own React".
 *
 * Behind the `platform-dst-top-layer` feature gate this returns a top-layer
 * backed instance: the element is positioned with CSS Anchor Positioning and
 * lifted into the browser top layer. Flag-off it is the raw Popper.js v2
 * engine. See `createPopperTopLayer` for the option-handling tiers.
 */ 






var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fRQ3t = parcelRequire("fRQ3t");


var $1hQ0e = parcelRequire("1hQ0e");


var $aRDbl = parcelRequire("aRDbl");


var $97Yf0 = parcelRequire("97Yf0");


var $7tQDG = parcelRequire("7tQDG");


var $aM6nP = parcelRequire("aM6nP");


var $duYjR = parcelRequire("duYjR");


var $pQqk9 = parcelRequire("pQqk9");

/**
 * Popper.js defaults, applied when the caller omits them.
 * <https://popper.js.org/docs/v2/constructors/#options>
 */ const $8a5d834575581bec$var$DEFAULT_PLACEMENT = 'bottom';
const $8a5d834575581bec$var$DEFAULT_STRATEGY = 'absolute';
/**
 * Popper.js' `offset` modifier defaults to `[0, 0]` — no gap. This differs from
 * ADS `<Popper>` (`[0, 8]`) and from top-layer's own `space.100` default, so the
 * offset is always passed explicitly: a caller that asked for no offset keeps
 * getting none.
 */ const $8a5d834575581bec$var$NO_OFFSET = [
    0,
    0
];
/**
 * Fills in Popper.js' option defaults so `state.options` is always complete,
 * matching what the real engine exposes.
 */ function $8a5d834575581bec$var$resolveOptions(options) {
    return {
        placement: options?.placement ?? $8a5d834575581bec$var$DEFAULT_PLACEMENT,
        modifiers: options?.modifiers ?? [],
        strategy: options?.strategy ?? $8a5d834575581bec$var$DEFAULT_STRATEGY,
        onFirstUpdate: options?.onFirstUpdate
    };
}
/**
 * Reads the `offset` modifier's `[skidding, distance]` tuple.
 *
 * Popper.js merges duplicate modifier entries by name with later entries
 * winning, so the last `offset` entry is the one that counts. A disabled
 * modifier, or a function-valued `offset` (which Popper.js resolves per-update
 * against live rects and CSS Anchor Positioning has no equivalent for), falls
 * back to no offset.
 */ function $8a5d834575581bec$var$getOffset(modifiers) {
    const offsetModifier = modifiers.filter((modifier)=>modifier?.name === 'offset').pop();
    if (!offsetModifier || offsetModifier.enabled === false) return $8a5d834575581bec$var$NO_OFFSET;
    const offset = offsetModifier.options?.offset;
    if (!Array.isArray(offset)) return $8a5d834575581bec$var$NO_OFFSET;
    const [along, away] = offset;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * Maps resolved Popper.js options onto top-layer's placement input.
 *
 * Called from the bridge components' render, not memoized: the bridge remounts
 * on every option change (see `createPopperTopLayer`), so a `useMemo` cache
 * could never be read, and `useAnchorPosition` already re-derives a stable
 * placement from the primitive fields so a fresh object identity per render
 * costs nothing downstream.
 */ function $8a5d834575581bec$var$toTopLayerPlacement(options) {
    return (0, $aRDbl.fromLegacyPlacement)({
        legacy: (0, $pQqk9.toLegacyPlacement)(options.placement),
        offset: $8a5d834575581bec$var$getOffset(options.modifiers)
    });
}
/**
 * Neutralises the UA stylesheet's `[popover]` rules for an element this adapter
 * promoted, so promotion is a change of paint order and nothing else.
 *
 * The UA sheet gives every popover `border: solid`, `padding: 0.25em`,
 * `overflow: auto`, `width` / `height: fit-content`, `color: CanvasText` and
 * `background-color: Canvas`. `<Popover>` overrides these in its own Compiled
 * class, but the element here belongs to the caller, so inline styles are the
 * wrong tool: they would beat the caller's own stylesheet rather than only the
 * UA's. A zero-specificity `:where()` rule in the author origin is exactly the
 * right precedence — it always beats the UA sheet and always loses to any
 * caller selector.
 *
 * `inline-size` is deliberately left at the UA default, matching `<Popover>`
 * (which keeps it for anchor-width matching).
 */ const $8a5d834575581bec$var$PROMOTED_ATTRIBUTE = 'data-ds--popper-promoted';
function $8a5d834575581bec$var$ensurePromotedStyles(element) {
    // Injected into the element's own document rather than a module-cached one,
    // so a caller positioning inside an iframe still gets the reset.
    const document = element.ownerDocument;
    if (document.querySelector(`style[${$8a5d834575581bec$var$PROMOTED_ATTRIBUTE}]`)) return;
    const style = document.createElement('style');
    style.setAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE, 'true');
    style.textContent = `:where([${$8a5d834575581bec$var$PROMOTED_ATTRIBUTE}]){border-style:none;padding:0;overflow:visible;block-size:auto;color:inherit;background-color:transparent;}`;
    document.head.appendChild(style);
}
/**
 * Lifts the caller's element into the browser top layer.
 *
 * Uses `popover="manual"` so the element gets top-layer promotion without light
 * dismiss and without joining the auto-dismiss stack - the caller keeps owning
 * visibility, which matches Popper.js' contract (and mirrors the
 * `<Popover mode="manual">` the React `<Popper>` FF-on path uses).
 *
 * Returns `undefined` when no promotion happened: the element is already a
 * popover / `<dialog>` (the caller owns the top layer already), or the browser
 * has no Popover API. The latter is unpositioned flag-on — but so is every
 * other `@atlaskit/top-layer` consumer, because the whole stack is built on the
 * Popover API. It is not a gap specific to this adapter.
 */ function $8a5d834575581bec$var$promoteToTopLayer(element) {
    if (element.hasAttribute('popover') || element.tagName === 'DIALOG') return undefined;
    if (typeof element.showPopover !== 'function') return undefined;
    $8a5d834575581bec$var$ensurePromotedStyles(element);
    element.setAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE, 'true');
    element.setAttribute('popover', 'manual');
    try {
        element.showPopover();
    } catch  {
        // `showPopover()` throws `InvalidStateError` for a disconnected element.
        // Leave the element in normal flow rather than stranding it as a hidden,
        // never-shown popover.
        element.removeAttribute('popover');
        element.removeAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE);
        return undefined;
    }
    return function undoPromotion() {
        try {
            element.hidePopover();
        } catch  {}
        element.removeAttribute('popover');
        element.removeAttribute($8a5d834575581bec$var$PROMOTED_ATTRIBUTE);
    };
}
const $8a5d834575581bec$var$EMPTY_RECT = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
};
/**
 * `VirtualElement.getBoundingClientRect()` is typed as `ClientRect | DOMRect`,
 * and `ClientRect` has no `x` / `y` - so read the physical edges instead.
 */ function $8a5d834575581bec$var$toRect(rect) {
    return {
        width: rect.width,
        height: rect.height,
        x: rect.left,
        y: rect.top
    };
}
// Both bridges below render nothing. They exist purely so top-layer's
// positioning hooks can run against elements that live outside any React tree,
// and they mirror the anchor resolution in `popper-top-layer.tsx`. Which one is
// used is decided when the instance is created and never changes, so each calls
// exactly one hook unconditionally.
//
// Every prop is constant for the lifetime of a mount: the elements are fixed at
// creation, and an option change remounts the bridge (see
// `createPopperTopLayer`). So props go straight into refs with no re-assignment,
// and closures over them cannot go stale.
/**
 * Real DOM anchor: `useAnchorPosition` gives it `anchor-name` on the CSS Anchor
 * Positioning path, and measures it on the JS fallback.
 */ const $8a5d834575581bec$var$AnchorBridge = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnchorBridge(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { anchor: anchor, popover: popover, options: options } = t0;
    const anchorRef = (0, $cozmU.useRef)(anchor);
    const popoverRef = (0, $cozmU.useRef)(popover);
    let t1;
    if ($[0] !== options) {
        t1 = $8a5d834575581bec$var$toTopLayerPlacement(options);
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = {
            anchorRef: anchorRef,
            popoverRef: popoverRef,
            placement: t1,
            isOpen: true
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    (0, $97Yf0.useAnchorPosition)(t2);
    return null;
} : function AnchorBridge({ anchor: anchor, popover: popover, options: options }) {
    const anchorRef = (0, $cozmU.useRef)(anchor);
    const popoverRef = (0, $cozmU.useRef)(popover);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: $8a5d834575581bec$var$toTopLayerPlacement(options),
        isOpen: true
    });
    return null;
};
/**
 * Anything that is not a real DOM element (a Popper.js `VirtualElement`, an SVG
 * element, an element from another realm) cannot carry `anchor-name`, so its
 * rect is reduced to the geometrically-equivalent point for the requested
 * placement and handed to `useAnchorPositionAtPoint`, which owns the synthetic
 * anchor.
 */ const $8a5d834575581bec$var$PointBridge = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PointBridge(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { reference: reference, popover: popover, options: options } = t0;
    const popoverRef = (0, $cozmU.useRef)(popover);
    let t1;
    if ($[0] !== options) {
        t1 = $8a5d834575581bec$var$toTopLayerPlacement(options);
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    const placement = t1;
    let t2;
    if ($[2] !== placement || $[3] !== reference) {
        t2 = ()=>(0, $duYjR.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $aM6nP.isPageRtl)()
            });
        $[2] = placement;
        $[3] = reference;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== placement || $[6] !== t2) {
        t3 = {
            popoverRef: popoverRef,
            placement: placement,
            isOpen: true,
            getPoint: t2
        };
        $[5] = placement;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    (0, $7tQDG.useAnchorPositionAtPoint)(t3);
    return null;
} : function PointBridge({ reference: reference, popover: popover, options: options }) {
    const popoverRef = (0, $cozmU.useRef)(popover);
    const placement = $8a5d834575581bec$var$toTopLayerPlacement(options);
    (0, $7tQDG.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isOpen: true,
        getPoint: ()=>(0, $duYjR.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $aM6nP.isPageRtl)()
            })
    });
    return null;
};
function $8a5d834575581bec$export$3f3476d827c0bd92(reference, popper, options) {
    let currentOptions = $8a5d834575581bec$var$resolveOptions(options);
    let isDestroyed = false;
    // Used as the bridge's `key` and bumped by every call that re-positions, so
    // the bridge remounts and its hook re-runs from scratch. See "Instance
    // surface" above for why that is load-bearing on both bridges.
    let generation = 0;
    // Which bridge to render is fixed here, for the instance's lifetime.
    const anchor = reference instanceof HTMLElement ? reference : null;
    // Promote BEFORE the first render so the popover is already open when the
    // hooks' layout effects run - `useAnchorPosition`'s JS fallback detects an
    // already-open popover and measures immediately instead of waiting for a
    // `toggle` event it would otherwise have missed.
    const undoPromotion = $8a5d834575581bec$var$promoteToTopLayer(popper);
    // React host for the bridge. The bridge renders `null`, so this container
    // stays empty and is deliberately never appended to the document: React only
    // needs an element to own, and effects run either way.
    const container = (0, $1hQ0e.getDocument)()?.createElement('div');
    const root = container ? (0, $fRQ3t.createRoot)(container) : null;
    const state = {
        elements: {
            reference: reference,
            popper: popper
        },
        options: currentOptions,
        placement: currentOptions.placement,
        strategy: currentOptions.strategy,
        orderedModifiers: [],
        rects: {
            reference: $8a5d834575581bec$var$EMPTY_RECT,
            popper: $8a5d834575581bec$var$EMPTY_RECT
        },
        scrollParents: {
            reference: [],
            popper: []
        },
        styles: {},
        attributes: {},
        modifiersData: {},
        reset: false
    };
    function render() {
        if (!root || isDestroyed) return;
        // Deliberately NOT wrapped in `flushSync`. React commits this on its own
        // schedule, so positioning lands on the next tick rather than before this
        // call returns. Popper.js is the same (its first update is async), and
        // forcing a sync flush is not an option: a React consumer calling
        // `createPopper` from an effect would trip
        // "flushSync was called from inside a lifecycle method", which React
        // downgrades to an async commit anyway — so the flush buys a console
        // error and nothing else.
        root.render(anchor ? /*#__PURE__*/ (0, $8aG6j.jsx)($8a5d834575581bec$var$AnchorBridge, {
            anchor: anchor,
            popover: popper,
            options: currentOptions
        }, generation) : /*#__PURE__*/ (0, $8aG6j.jsx)($8a5d834575581bec$var$PointBridge, {
            reference: reference,
            popover: popper,
            options: currentOptions
        }, generation));
        // Measured at call time, so `rects.popper` reflects the position before
        // this render commits. Popper.js' `state` is likewise only as fresh as the
        // last completed update.
        state.rects = {
            reference: $8a5d834575581bec$var$toRect(reference.getBoundingClientRect()),
            popper: $8a5d834575581bec$var$toRect(popper.getBoundingClientRect())
        };
    }
    render();
    // Popper.js resolves `onFirstUpdate` asynchronously, after the first update
    // completes. Match that timing so callers that mutate state in the callback
    // do not do so during their own `createPopper()` call.
    const { onFirstUpdate: onFirstUpdate } = currentOptions;
    if (onFirstUpdate) Promise.resolve().then(()=>{
        if (!isDestroyed) onFirstUpdate(state);
    });
    return {
        state: state,
        update () {
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        forceUpdate () {
            generation += 1;
            render();
        },
        setOptions (setOptionsAction) {
            if (isDestroyed) return Promise.resolve(state);
            const next = typeof setOptionsAction === 'function' ? setOptionsAction(currentOptions) : setOptionsAction;
            currentOptions = $8a5d834575581bec$var$resolveOptions({
                ...currentOptions,
                ...next
            });
            state.options = currentOptions;
            state.placement = currentOptions.placement;
            state.strategy = currentOptions.strategy;
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        destroy () {
            if (isDestroyed) return;
            // Set synchronously so a `render()` already in flight is dropped and
            // `onFirstUpdate` never fires after `destroy()`.
            isDestroyed = true;
            // Deferred to a microtask, NOT run inline. `root.unmount()` is
            // synchronous, and React logs "Attempted to synchronously unmount a
            // root while React was already rendering" when it is called during a
            // commit — which is exactly where a React caller destroys, since
            // effect cleanups run in the commit phase. React also downgrades the
            // unmount to an async commit there, so inline teardown would restore
            // the hooks' styles *after* `undoPromotion()` had already run,
            // inverting the order below. A microtask leaves the commit and gets
            // both: no warning, and teardown in the right order.
            queueMicrotask(()=>{
                // Unmounting runs the hooks' cleanups, which restore every inline
                // style they wrote and remove any synthetic anchor.
                root?.unmount();
                undoPromotion?.();
            });
        }
    };
}


const $19378def19a022a0$export$8f7491d57c8f97a9 = (reference, popper, options)=>{
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return (0, $8a5d834575581bec$export$3f3476d827c0bd92)(reference, popper, options);
    return (0, $kdxSx.createPopper)(reference, popper, options);
};



var $jv11C = parcelRequire("jv11C");

const $b3a4b496786a0875$var$startingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            4
        ]
    }
};
const $b3a4b496786a0875$var$endingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            8
        ]
    }
};
const $b3a4b496786a0875$export$3c00f79c82af3714 = 'ak-editor-vanilla-tooltip-default';
/**
 * Namespaced to keep generated ids from colliding with ids the host page owns, since they share
 * the document's single id space.
 */ const $b3a4b496786a0875$var$TOOLTIP_ID_PREFIX = 'ak-editor-internal-tooltip';
/**
 * Generates a tooltip id for `aria-describedby`/`popovertarget`.
 *
 * `crypto.randomUUID` covers effectively all production traffic
 * The counter is only a fallback for environments without it (for example a non-secure context)
 * and is scoped to this closure rather than module state.
 */ const $b3a4b496786a0875$var$generateTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$b3a4b496786a0875$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$b3a4b496786a0875$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
function $b3a4b496786a0875$var$getCreatePopper() {
    if ((0, $iDrrr.fg)('platform-dst-popper-consolidation')) return 0, $19378def19a022a0$export$8f7491d57c8f97a9;
    return 0, $kdxSx.createPopper;
}
class $b3a4b496786a0875$export$47a232ed95817c75 {
    /**
   * Closes the popover, tolerating it already being closed.
   *
   * A `hint` popover is light-dismissed by the browser whenever another `hint` or `auto` popover
   * opens, so the caller can never be sure this one is still showing.
   */ closePopover() {
        try {
            this.tooltip.hidePopover();
        } catch (error) {
            // `hidePopover()` raises `InvalidStateError` both when the popover is not showing
            // when the tooltip is disconnected or has lost its `popover` attribute.
            if (!this.tooltip.isConnected || !this.tooltip.hasAttribute('popover')) (0, $jv11C.logException)(error, {
                location: 'editor-common/vanilla-tooltip'
            });
        }
    }
    /**
   * Opens the popover, tolerating it already being open.
   *
   * A hover returning during a pending hide re-enters `show()` before `isDisplayed` is set, so
   * this runs against an already-open popover on that path.
   */ openPopover() {
        try {
            this.tooltip.showPopover();
        } catch (error) {
            // `showPopover()` raises `InvalidStateError` both when the tooltip is already in the
            // top layer and when it is disconnected or has lost its `popover` attribute.
            if (!this.tooltip.isConnected || !this.tooltip.hasAttribute('popover')) (0, $jv11C.logException)(error, {
                location: 'editor-common/vanilla-tooltip'
            });
        }
    }
    createPopperInstance() {
        this.popperInstance = $b3a4b496786a0875$var$getCreatePopper()(this.trigger, this.tooltip, {
            placement: this.placement,
            modifiers: [
                $b3a4b496786a0875$var$startingOffset
            ]
        });
    }
    destroy() {
        // Cancels any pending show/hide, which would otherwise run against detached DOM and
        // invoke `onShow` after the owner has gone away.
        clearTimeout(this.currentTimeoutId);
        // Destroying while visible must not leave the listener bound to a dead tooltip.
        this.unbindEscapeListener();
        this.popperInstance?.destroy();
        this.listeners.forEach((listener)=>{
            listener();
        });
        // Undoes what the constructor added to the trigger, matching the React `@atlaskit/tooltip`
        // callers are moving off, whose unmount took its DOM with it.
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            // A popover removed while still showing is never light-dismissed, so the top layer
            // keeps treating it as open.
            this.closePopover();
            this.tooltip.remove();
            if (this.trigger.getAttribute('aria-describedby') === this.tooltip.id) this.trigger.removeAttribute('aria-describedby');
            if (this.trigger.getAttribute('popovertarget') === this.tooltip.id) this.trigger.removeAttribute('popovertarget');
        }
    }
    /**
   * Starts listening for Escape to dismiss this tooltip.
   *
   * A tooltip only ever needs one Escape listener, so this does nothing when one is already
   * bound.
   */ bindEscapeListener() {
        if (this.unbindEscape) return;
        this.unbindEscape = (0, $cbY7C.bind)(this.trigger.ownerDocument.defaultView ?? window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        });
    }
    /**
   * Stops listening for Escape, so no listener is retained while this tooltip is off screen.
   *
   * Does nothing when no listener is bound.
   */ unbindEscapeListener() {
        this.unbindEscape?.();
        this.unbindEscape = undefined;
    }
    hide(immediate = false) {
        clearTimeout(this.currentTimeoutId);
        // Unbound synchronously so a repeated Escape does not re-enter this tooltip while the
        // hide is still pending.
        this.unbindEscapeListener();
        this.shouldHidePopover = true;
        // Disable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                // Released rather than reconfigured. The instance was previously kept for the
                // trigger's whole lifetime, so every element the pointer passed over retained
                // one — and under `platform-dst-popper-consolidation` an instance owns a
                // detached React root, so that was a retained root per hovered trigger.
                //
                // Destroying is also the only way to release that root's capture-phase
                // `scroll`/`resize` listeners on the consolidated path, where the
                // `eventListeners: false` reconfiguration in the control arm is accepted but
                // does nothing.
                this.popperInstance?.destroy();
                this.popperInstance = undefined;
                this.tooltip.style.opacity = '0';
                this.isDisplayed = false;
                // Closed here rather than from `ontransitionend`. No consumer declares a
                // transition on the tooltip, so that event never fires and the popover would
                // otherwise stay open in the top layer for good.
                this.closePopover();
                // Paired with the `visibility` that `show()` sets, so a popover left open by
                // a failed close cannot intercept pointer events over the content.
                this.tooltip.style.visibility = 'hidden';
            } else {
                this.popperInstance?.setOptions((options)=>({
                        ...options,
                        modifiers: [
                            $b3a4b496786a0875$var$startingOffset,
                            {
                                name: 'eventListeners',
                                enabled: false
                            }
                        ]
                    }));
                this.tooltip.style.opacity = '0';
                this.isDisplayed = false;
                // If transition animations are disabled immediately hide the popover
                if (this.tooltip.style.transition === 'none') this.tooltip.hidePopover();
            }
        }, immediate ? 0 : this.timeout);
    }
    show() {
        // Ahead of the `isDisplayed` guard, unlike the equivalent below: `hide()` takes effect
        // synchronously but leaves the tooltip on screen until its timeout, so a pointer
        // returning in that window finds `isDisplayed` still true and returns early. Cancelling
        // first keeps the tooltip up and stops it being left undismissable with a hide pending.
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            this.bindEscapeListener();
            clearTimeout(this.currentTimeoutId);
            this.shouldHidePopover = false;
        }
        if (this.isDisplayed) return;
        // Control only: the experiment cancels above, ahead of the guard. Kept gated rather than
        // left unconditional — despite being a no-op once the block above has run — so that
        // experiment cleanup can delete it outright instead of having to reason about it.
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            clearTimeout(this.currentTimeoutId);
            this.shouldHidePopover = false;
        }
        // Make the tooltip visible - but hide until
        this.tooltip.style.visibility = 'hidden';
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.openPopover();
        else this.tooltip.showPopover();
        // Update its position
        if (!this.popperInstance) this.createPopperInstance();
        else this.popperInstance.update();
        // Enable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.tooltip.style.opacity = '1';
            this.tooltip.style.visibility = 'visible';
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $b3a4b496786a0875$var$endingOffset,
                        {
                            name: 'eventListeners',
                            enabled: true
                        }
                    ]
                }));
            this.isDisplayed = true;
            this.onShow?.();
        }, this.timeout);
    }
    constructor(/**
   * The element that the tooltip describes and Popper uses as its anchor.
   *
   * Prefer a `<button>`: it is focusable and announced by assistive tech for free, and is the
   * only element the browser honours `popovertarget` on. Anything else works, since this
   * class calls `showPopover()`/`hidePopover()` itself, but then make sure it:
   *
   * - **Renders its children**, as the tooltip is appended to the trigger. `<img>`, `<input>`
   *   and `<br>` accept the append without error but never render it, leaving the tooltip
   *   silently at zero size.
   * - **Is reachable**, if keyboard and screen reader users need the tooltip — usually
   *   `tabindex="0"` plus a role and accessible name, since `focus`/`blur` are bound to the
   *   trigger and `aria-describedby` is set on it.
   */ trigger, content, /**
   * Id associated to the tooltip - must be unique within the document.
   *
   * Pass `undefined` to have one generated, which is preferred: callers otherwise have to
   * solve uniqueness themselves, and every consumer had solved it differently.
   */ id, /**
   * Class Name – used for styling.
   */ className, timeout = 300, /**
   * Optional inline styles to apply directly to the tooltip element.
   * Useful when the tooltip is rendered in the browser's top layer (via Popover API),
   * where ancestor CSS selectors cannot reach it.
   */ styles, /**
   * Called when the tooltip has become visible, after `timeout` has elapsed.
   * Not called when the pointer leaves before the tooltip is shown, matching
   * the `onShow` semantics of "@atlaskit/tooltip".
   */ onShow, /**
   * Where the tooltip sits relative to the trigger.
   *
   * Defaults to `'top'`, matching the default `position` of "@atlaskit/tooltip". Use
   * `'bottom'` to match its `position="mouse"`, which places the tooltip below the cursor.
   */ placement = 'top'){
        this.trigger = trigger;
        this.timeout = timeout;
        this.onShow = onShow;
        this.placement = placement;
        this.popperInstance = void 0;
        this.listeners = [];
        this.currentTimeoutId = void 0;
        this.shouldHidePopover = false;
        this.tooltip = void 0;
        this.isDisplayed = false;
        /**
     * Set only while this tooltip is on screen, so no listener is retained at rest.
     */ this.unbindEscape = void 0;
        // Created in the trigger's own document rather than the global one, so nothing depends on
        // the parent realm when the editor renders inside an iframe. Gated alongside the Escape
        // listener's window so the whole iframe fix moves as a single unit.
        const ownerDocument = (0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components') ? trigger.ownerDocument : document;
        const tooltip = ownerDocument.createElement('span');
        tooltip.role = 'tooltip';
        tooltip.popover = 'hint';
        tooltip.className = className;
        tooltip.id = id ?? $b3a4b496786a0875$var$generateTooltipId();
        tooltip.textContent = content;
        // A tooltip is never a hit target. Set before the caller's styles so it can be overridden.
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) tooltip.style.pointerEvents = 'none';
        if (styles) Object.assign(tooltip.style, styles);
        this.tooltip = tooltip;
        this.trigger.appendChild(tooltip);
        this.trigger.setAttribute('popovertarget', tooltip.id);
        this.trigger.setAttribute('aria-describedby', tooltip.id);
        const showEvents = [
            'mouseenter',
            'focus'
        ];
        const hideEvents = [
            'mouseleave',
            'blur'
        ];
        showEvents.forEach((event)=>{
            this.listeners.push((0, $cbY7C.bind)(this.trigger, {
                type: event,
                listener: ()=>this.show()
            }));
        });
        hideEvents.forEach((event)=>{
            this.listeners.push((0, $cbY7C.bind)(this.trigger, {
                type: event,
                listener: ()=>this.hide()
            }));
        });
        // Bound for this tooltip's whole lifetime, even while it is off screen. The experiment
        // moves this to `show()` so nothing is retained at rest.
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.listeners.push((0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        }));
        // Hide the tooltip if the hide transition has completed.
        //
        // Only reachable in the control arm: no consumer declares a transition on the tooltip, so
        // this never fires today, and the experiment closes the popover in `hide()` regardless.
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.tooltip.ontransitionend = ()=>{
            if (this.shouldHidePopover) this.tooltip.hidePopover();
        };
    }
}
module.exports["VANILLA_TOOLTIP_DEFAULT_CLASS"] = $b3a4b496786a0875$export$3c00f79c82af3714;
module.exports["VanillaTooltip"] = $b3a4b496786a0875$export$47a232ed95817c75;

});

parcelRegister("4lpx1", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $c31c52779eb9e4a4$export$f43d3f526d9434e = new (0, $kCECX.PluginKey)('userIntentPlugin');
const $c31c52779eb9e4a4$var$initialState = {
    currentUserIntent: 'default'
};
const $c31c52779eb9e4a4$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $c31c52779eb9e4a4$export$f43d3f526d9434e,
        state: {
            init () {
                return $c31c52779eb9e4a4$var$initialState;
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($c31c52779eb9e4a4$export$f43d3f526d9434e);
                if (meta) {
                    // If the incoming currentUserIntent is the same as the existing one, return the existing state
                    if (meta.data.currentUserIntent === currentPluginState.currentUserIntent) return currentPluginState;
                    return {
                        currentUserIntent: meta.data.currentUserIntent
                    };
                }
                return currentPluginState;
            }
        }
    });
};


const $028f32a587de99d0$export$4de3f86a2063c3b3 = (currentUserIntent)=>({ tr: tr })=>{
        tr.setMeta((0, $c31c52779eb9e4a4$export$f43d3f526d9434e), {
            type: 'setCurrentUserIntent',
            data: {
                currentUserIntent: currentUserIntent
            }
        });
        return tr;
    };



const $a74236dfb60e9f17$export$234188bd1f793aed = ()=>({
        name: 'userIntent',
        pmPlugins () {
            return [
                {
                    name: 'userIntentPlugin',
                    plugin: (0, $c31c52779eb9e4a4$export$ae829ec7b2625219)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $c31c52779eb9e4a4$export$f43d3f526d9434e).getState(editorState);
            if (!pluginState) return;
            return {
                currentUserIntent: pluginState.currentUserIntent
            };
        },
        commands: {
            setCurrentUserIntent: $028f32a587de99d0$export$4de3f86a2063c3b3
        }
    });
module.exports["userIntentPlugin"] = $a74236dfb60e9f17$export$234188bd1f793aed;

});

parcelRegister("lfQQe", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $f3c6c7310a379a91$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('widthPlugin');


function $c088522f84c51cc5$export$ae829ec7b2625219(dispatch) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $f3c6c7310a379a91$export$18d4026d1ea86bb1),
        state: {
            init: ()=>{
                return {
                    width: document.body.offsetWidth
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $f3c6c7310a379a91$export$18d4026d1ea86bb1));
                if (!meta) return pluginState;
                const newPluginState = {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $f3c6c7310a379a91$export$18d4026d1ea86bb1), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}




var $cozmU = parcelRequire("cozmU");






var $cbY7C = parcelRequire("cbY7C");

// List of names for transition end events across browsers
const $e547d6d7fe52a418$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $e547d6d7fe52a418$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!containerElement) return;
        /**
		 * Update the plugin components once the transition
		 * to full width / default mode completes
		 */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $cbY7C.bindAll)(containerElement, $e547d6d7fe52a418$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};


const $c08434a4a88ab62d$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $f3c6c7310a379a91$export$18d4026d1ea86bb1), props);
        dispatch(tr);
    };
const $c08434a4a88ab62d$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $e547d6d7fe52a418$export$b72edfd730e58e7c)(containerElement);
    (0, $cozmU.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $c08434a4a88ab62d$export$33d12d97a81b0d33(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $cozmU.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $c08434a4a88ab62d$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};


const $808876d782d150ee$export$8cdf857cb01de6dc = ()=>{
    return {
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $c088522f84c51cc5$export$ae829ec7b2625219)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $f3c6c7310a379a91$export$18d4026d1ea86bb1).getState(editorState);
        },
        usePluginHook: (0, $c08434a4a88ab62d$export$b0f894529c6bfe0a)
    };
};
module.exports["widthPlugin"] = $808876d782d150ee$export$8cdf857cb01de6dc;

});

parcelRegister("bdURs", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $1f0684a82f8c7e2c$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $1f0684a82f8c7e2c$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($1f0684a82f8c7e2c$export$e38af27e662e9783, {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.state = {
            width: 0,
            positionedOverEditor: false
        };
        this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        };
        this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
}
const $1f0684a82f8c7e2c$export$e38af27e662e9783 = $1f0684a82f8c7e2c$export$c174a7dc96b2afb8.Provider;
const $1f0684a82f8c7e2c$export$24734d8d7782a3fc = $1f0684a82f8c7e2c$export$c174a7dc96b2afb8.Consumer;
module.exports["ContextPanelWidthProvider"] = $1f0684a82f8c7e2c$export$ba19517e2c08f4aa;
module.exports["ContextPanelConsumer"] = $1f0684a82f8c7e2c$export$24734d8d7782a3fc;

});

parcelRegister("68mo7", function(module, exports) {
const $12486f915d6ab22b$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
module.exports["UnsupportedSharedCssClassName"] = $12486f915d6ab22b$export$629043421dcc56e5;

});


$parcel$global.rlb("iPvQ1")
//# sourceMappingURL=FullPageEditorComponent.fc4cdb51.js.map
